export default {
  currencyFormat: "#,###.##",
  thousandSeparator: ",",
  salesInvoiceEditor: {
    glAccountName: "គណនី GL",
    glAccountNo: "លេខគណនី GL",
  },
  title: {
    store: "ហាង",
    budget: "ថវិកា",
    receivable: "បំណុលត្រូវទទួល",
    client: "អតិថិជន",
    payable: "បំណុលត្រូវបង់",
    inventory: "សន្និធិ",
    item: "ទំនិញ",
    vendor: "អ្នកផ្គត់ផ្គង់",
    masterData: "ទិន្នន័យមេ",
    closeIncomeStatement: "បិទរបាយការណ៍ប្រាក់ចំណូល",
    storeRequisitionBatch: "កញ្ចប់សំណើស្តុក",
    generalPostingGroup: "ក្រុមចុះបញ្ជីទូទៅ",
    generalProductPostingGroup: "ក្រុមចុះបញ្ជីផលិតផលទូទៅ",
    generalBusinessPostingGroup: "ក្រុមចុះបញ្ជីអាជីវកម្មទូទៅ",
    clientPostingGroup: "ក្រុមចុះបញ្ជីអតិថិជន",
    vendorPostingGroup: "ក្រុមចុះបញ្ជីអ្នកផ្គត់ផ្គង់",
    inventoryPostingGroup: "ក្រុមចុះបញ្ជីសន្និធិ",
    bankAccountPostingGroup: "ក្រុមចុះបញ្ជីគណនីធនាគារ",
    inventoryReconciliationSetup: "ការកំណត់តុល្យភាពសន្និធិ",
    expenseGeneralProductPostingGroup: "ក្រុមចុះបញ្ជីផលិតផលចំណាយទូទៅ",
    expenseGeneralBusinessPostingGroup: "ក្រុមចុះបញ្ជីអាជីវកម្មចំណាយទូទៅ",
    vatPostingGroup: "ក្រុមចុះបញ្ជីអាករ",
    vatBusinessPostingGroup: "ក្រុមចុះបញ្ជីអាជីវកម្មអាករ",
    vatProductPostingGroup: "ក្រុមចុះបញ្ជីផលិតផលអាករ",
    vatPostingSetup: "ការកំណត់ការចុះបញ្ជីអាករ",
    postingSetup: "ការកំណត់ការចុះបញ្ជី",
    generalPostingSetup: "ការកំណត់ការចុះបញ្ជីទូទៅ",
    inventoryPostingSetup: "ការកំណត់ការចុះបញ្ជីសន្និធិ",
    userPostingSetup: "ការកំណត់ការចុះបញ្ជីអ្នកប្រើប្រាស់",
    signatureSetup: "ការកំណត់ហត្ថលេខា",
    generalLedger: "សៀវភៅធំទូទៅ",
    chartOfAccount: "តារាងគណនី",
    chartOfAccountCategory: "ប្រភេទតារាងគណនី",
    chartOfAccountCategoryMenu: "ប្រភេទ COA",
    generalLedgerBudget: "ថវិកាសៀវភៅធំទូទៅ",
    generalJournal: "សៀវភៅទូទៅ",
    accountReconciliationJournal: "សៀវភៅតុល្យភាពគណនី",
    newAccountReconciliationJournal: "សៀវភៅតុល្យភាពគណនីថ្មី",
    generalConfiguration: "ការកំណត់ទូទៅ",
    warehouseLocation: "ទីតាំងឃ្លាំង",
    accountingPeriod: "រយៈពេលគណនេយ្យ",
    inventoryPeriod: "រយៈពេលសន្និធិ",
    bankAccount: "គណនីធនាគារ",
    paymentTerm: "លក្ខខណ្ឌបង់ប្រាក់",
    generalJournalBatch: "កញ្ចប់សៀវភៅទូទៅ",
    numberSeries: "ស៊េរីលេខ",
    purchaseRequisitionBatch: "កញ្ចប់សំណើទិញ",
    unitOfMeasurement: "ឯកតាវាស់",
    defaultUnitOfMeasurement: "ឯកតាវាស់បញ្ចូលលំនាំដើម",
    baseUnitOfMeasurement: "ឯកតាវាស់មូលដ្ឋាន",
    inputUnitOfMeasurement: "ឯកតាវាស់បញ្ចូល",
    inputUnitOfMeasurementID: "លេខសម្គាល់ឯកតាវាស់បញ្ចូល",
    inputUnitOfMeasurementName: "ឈ្មោះឯកតាវាស់បញ្ចូល",
    generalJournalTemplate: "ពុម្ពសៀវភៅទូទៅ",
    user: "អ្នកប្រើប្រាស់",
    purchaseRequest: "សំណើទិញ",
    purchaseOrder: "បញ្ជាទិញ",
    purchasing: "ការទិញ",
    purchaseReceiving: "បង្កាន់ដៃទទួលទំនិញ",
    purchaseReceiveCanceled: "បង្កាន់ដៃទទួលត្រូវបានបោះបង់",
    outstandingPurchaseRequest: "សំណើទិញមិនទាន់ដោះស្រាយ",
    vatBreakdown: "បំបែកអាករ",
    purchaseRequestList: "បញ្ជីសំណើទិញ",
    storeRequisitionList: "បញ្ជីសំណើស្តុក",
    storeRequisitionDetail: "ព័ត៌មានលម្អិតសំណើស្តុក",
    postedStoreRequisitionList: "បញ្ជីសំណើស្តុកដែលបានចុះបញ្ជី",
    storeRequisition: "សំណើស្តុក",
    outstandingStoreRequisitionList: "បញ្ជីសំណើស្តុកមិនទាន់ដោះស្រាយ",
    outstandingPurchaseRequestList: "បញ្ជីសំណើទិញមិនទាន់ដោះស្រាយ",
    outstandingPurchaseRequestDetail: "ព័ត៌មានលម្អិតសំណើទិញមិនទាន់ដោះស្រាយ",
    purchasePayableSetup: "ការកំណត់បំណុលទិញ",
    salesReceivableSetup: "ការកំណត់បំណុលលក់",
    purchaseOrderDetail: "ព័ត៌មានលម្អិតបញ្ជាទិញ",
    purchaseReceiptDetail: "ព័ត៌មានលម្អិតបង្កាន់ដៃទទួលទំនិញ",
    purchaseRequisitionTemplate: "ពុម្ពសំណើទិញ",
    purchaseRequisition: "សំណើទិញ",
    purchaseRequestDetail: "ព័ត៌មានលម្អិតសំណើទិញ",
    purchaseInvoiceDetail: "ព័ត៌មានលម្អិតវិក្កយបត្រទិញ",
    currency: "រូបិយប័ណ្ណ",
    generalLedgerSetup: "ការកំណត់សៀវភៅធំទូទៅ",
    inventorySetup: "ការកំណត់សន្និធិ",
    documentFlow: "លំហូរឯកសារ",
    masterDocumentFlow: "លំហូរឯកសារមេ",
    documentFlowSequenceType: "ប្រភេទលំដាប់លំហូរឯកសារ",
    purchaseInvoice: "វិក្កយបត្រទិញ",
    purchaseCheck: "ពិនិត្យទិន្នន័យទិញ",
    itemLedgerEntry: "ធាតុចូលសៀវភៅ",
    itemJournalBatch: "កញ្ចប់សៀវភៅធាតុ",
    itemJournal: "សៀវភៅធាតុ",
    physicalInventoryJournal: "សៀវភៅសន្និធិរូបវន្ត",
    vendorLedgerEntry: "ធាតុចូលសៀវភៅអ្នកផ្គត់ផ្គង់",
    vendorLedgerEntryDetail: "ព័ត៌មានលម្អិតធាតុចូលសៀវភៅអ្នកផ្គត់ផ្គង់",
    clientLedgerEntry: "ធាតុចូលសៀវភៅអតិថិជន",
    clientLedgerEntryDetail: "ព័ត៌មានលម្អិតធាតុចូលសៀវភៅអតិថិជន",
    bankAccountLedgerEntry: "ធាតុចូលសៀវភៅគណនីធនាគារ",
    bankAccountLedgerEntryDetail: "ព័ត៌មានលម្អិតធាតុចូលសៀវភៅគណនីធនាគារ",
    physicalInventoryLedgerEntry: "ធាតុចូលសៀវភៅសន្និធិរូបវន្ត",
    vatEntry: "ធាតុចូលអាករ",
    valueEntry: "ធាតុចូលតម្លៃ",
    itemApplicationEntry: "ធាតុចូលកម្មវិធីទំនិញ",
    averageCostCalculationEntry: "ធាតុចូលគណនាតម្លៃជាមធ្យម",
    generalJournalEntry: "កំណត់ត្រាសៀវភៅទូទៅ",
    postedDocuments: "ឯកសារដែលបានចុះបញ្ជី",
    postedPurchaseRequest: "សំណើទិញដែលបានចុះបញ្ជី",
    postedPurchaseOrder: "បញ្ជាទិញដែលបានចុះបញ្ជី",
    postedPurchaseReceipt: "បង្កាន់ដៃទទួលដែលបានចុះបញ្ជី",
    postedPurchaseInvoice: "វិក្កយបត្រទិញដែលបានចុះបញ្ជី",
    postedPurchaseCreditMemo: "កំណត់ត្រាប្រាក់ឥណទានទិញដែលបានចុះបញ្ជី",
    postedSalesInvoice: "វិក្កយបត្រលក់ដែលបានចុះបញ្ជី",
    postedSalesCreditMemo: "កំណត់ត្រាប្រាក់ឥណទានលក់ដែលបានចុះបញ្ជី",
    purchaseCreditMemo: "កំណត់ត្រាប្រាក់ឥណទានទិញ",
    postedStoreRequisition: "សំណើស្តុកដែលបានចុះបញ្ជី",
    postedReceivableInvoice: "វិក្កយបត្របំណុលត្រូវទទួលដែលបានចុះបញ្ជី",
    entries: "ធាតុចូល",
    outstandingStoreRequisition: "សំណើស្តុកមិនទាន់ដោះស្រាយ",
    adjustmentEntry: "ធាតុចូលកែសម្រួល",
    generalLedgerEntry: "ធាតុចូលសៀវភៅធំទូទៅ",
    paymentJournal: "សៀវភៅបង់ប្រាក់",
    cashReceiptJournal: "សៀវភៅទទួលប្រាក់សុទ្ធ",
    salesInvoice: "វិក្កយបត្រលក់",
    salesInvoiceLine: "បន្ទាត់វិក្កយបត្រលក់",
    salesCreditMemo: "កំណត់ត្រាប្រាក់ឥណទានលក់",
    appliedEntries: "ធាតុចូលដែលបានអនុវត្ត",
    reports: "របាយការណ៍",
    unapplyClientEntries: "ដកអនុវត្តធាតុចូលអតិថិជន",
    applyClientEntries: "អនុវត្តធាតុចូលអតិថិជន",
    unapplyVendorEntries: "ដកអនុវត្តធាតុចូលអ្នកផ្គត់ផ្គង់",
    applyVendorEntries: "អនុវត្តធាតុចូលអ្នកផ្គត់ផ្គង់",
    reverseTransaction: "បញ្ច្រាសប្រតិបត្តិការ",
    vendorBankAccount: "គណនីធនាគារអ្នកផ្គត់ផ្គង់",
    reportSetting: "ការកំណត់របាយការណ៍",
    itemJournalMasterTemplate: "ពុម្ពសៀវភៅធាតុមេ",
    generalJournalMasterTemplate: "ពុម្ពសៀវភៅទូទៅមេ",
    journalVoucher: "ប័ណ្ណសៀវភៅ",
    paymentVoucher: "ប័ណ្ណបង់ប្រាក់",
    receivableInvoice: "វិក្កយបត្របំណុលត្រូវទទួល",
    accountReceivableAgingCreditCard: "បំណុលត្រូវទទួលតាមអាយុបញ្ជីកាតឥណទាន",
    agingCreditCardReport: "របាយការណ៍អាយុបញ្ជីកាតឥណទាន",
    accountReceivablePaymentList: "បញ្ជីបង់ប្រាក់បំណុលត្រូវទទួល",
    accountReceivablePaymentListCard: "បញ្ជីបង់ប្រាក់បំណុលត្រូវទទួលតាមកាត",
    accountReceivablePaymentListLedger: "បញ្ជីបង់ប្រាក់បំណុលត្រូវទទួលតាមសៀវភៅ",
    purchaseRequestApproval: "អនុម័តសំណើទិញ",
    approval: "អនុម័ត",
    printOption: "ជម្រើសបោះពុម្ព",
    purchaseBookOption: "ជម្រើសសៀវភៅទិញ",
    inventoryReconciliation: "តុល្យភាពសន្និធិ",
    entryEditorChangeAccountNumber: "ផ្លាស់ប្តូរលេខគណនី",
    entryEditorChangeDescription: "ផ្លាស់ប្តូរពិពណ៌នា",
    entryEditorChangeBankAccount: "Change Bank Account",
    entryEditorChangesLog: "កំណត់ត្រាប្រែប្រួល",
    accountPayablePaymentList: "បញ្ជីបង់ប្រាក់បំណុលត្រូវបង់",
    deleteBankAccountLedgerEntry: "លុបធាតុចូលសៀវភៅគណនីធនាគារ",
    deleteBankAccountLedgerEntryDialog: "ប្រអប់លុបធាតុចូលសៀវភៅគណនីធនាគារ",
    choose: "ជ្រើសរើស",
    reopen: "បើកឡើងវិញ",
    gle: "GLE",
    baleDetail: "ព័ត៌មានលម្អិត BALE",
    bale: "BALE",
    chooseBaleEntry: "ជ្រើសរើសធាតុចូល BALE",
    confirmReopenClosedEntry: "បញ្ជាក់បើកធាតុចូលដែលបានបិទឡើងវិញ",
    confirmDeleteGLE: "បញ្ជាក់លុប GLE",
    confirmDeleteBaleDetail: "បញ្ជាក់លុបព័ត៌មានលម្អិត BALE",
    confirmDeleteBale: "បញ្ជាក់លុប BALE",
    documentApproval: "អនុម័តឯកសារ",
    deletePostedInvoice: "លុបវិក្កយបត្រដែលបានចុះបញ្ជី",
    movePurchaseInvoiceLines: "ផ្លាស់ទីបន្ទាត់វិកយបត្រទិញ",
    purchaseRequestApprovalDetail: "ព័ត៌មានលម្អិតអនុម័តសំណើទិញ",
    purchaseOrderApprovalDetail: "ព័ត៌មានលម្អិតអនុម័តបញ្ជាទិញ",
    storeRequestApprovalDetail: "ព័ត៌មានលម្អិតអនុម័តសំណើហាង",
    withdrawDocumentApproval: "ដកអនុម័តឯកសារ",
    changeStatus: "ផ្លាស់ប្តូរស្ថានភាព",
    changeStatusPurchaseRequisition: "ផ្លាស់ប្តូរស្ថានភាពសំណើទិញ",
    cle: "CLE",
    vle: "VLE",
    cleDetail: "ព័ត៌មានលម្អិត CLE",
    vleDetail: "ព័ត៌មានលម្អិត VLE",
    chooseCleEntry: "ជ្រើសរើសធាតុចូល CLE",
    chooseVleEntry: "ជ្រើសរើសធាតុចូល VLE",
    confirmDeleteCleDetail: "បញ្ជាក់លុបព័ត៌មានលម្អិត CLE",
    confirmDeleteCle: "បញ្ជាក់លុប CLE",
    confirmDeleteVleDetail: "បញ្ជាក់លុបព័ត៌មានលម្អិត VLE",
    confirmDeleteVle: "បញ្ជាក់លុប VLE",
    deleteClientLedgerEntry: "លុប CLE",
    deleteClientLedgerEntryDialog: "ប្រអប់លុប CLE",
    deleteVendorLedgerEntry: "លុប VLE",
    deleteVendorLedgerEntryDialog: "ប្រអប់លុប VLE",
    updateWitholdingTax: "ធ្វើបច្ចុប្បន្នភាពពន្ធកាត់ទុក",
    adjustmentTools: "ឧបករណ៍កែសម្រួល",
    adjustSingleEntry: "កែសម្រួលធាតុចូលតែមួយ",
    adjustSOH: "កែសម្រួលសន្និធិនៅលើដៃ",
    adjustCostItemEntries: "កែសម្រួលធាតុចូលថ្លៃដើម",
    documentAttachment: "ឯកសារភ្ជាប់",
    recallJournal: "ហៅសៀវភៅវិញ",
    reverseJournal: "បញ្ច្រាសសៀវភៅ",
    inventoryAccountBalanceDetail: "ព័ត៌មានលម្អិតតុល្យភាពសន្និធិ",
    recalled: "បានហៅវិញ",
    changeClient: "ផ្លាស់ប្តូរអតិថិជន",
    itemCostPerLocation: "ថ្លៃដើមទំនិញតាមទីតាំង",
    integration: "ការរួមបញ្ចូល",
    interDepartmentTransfer: "ផ្ទេររវាងនាយកដ្ឋាន",
    interDepartmentTransferDetail: "ព័ត៌មានលម្អិតការផ្ទេររវាងនាយកដ្ឋាន",
    interDepartmentTransferBatch: "កញ្ចប់ផ្ទេររវាងនាយកដ្ឋាន",
    invoiceEmailLog: "កំណត់ត្រាអ៊ីមែលវិក្កយបត្រ",
    revaluationJournalAllItems: "សៀវភៅប៉ាន់ប្រមាណតម្លៃទំនិញទាំងអស់",
    revertPostedSalesInvoice: "បង្វិលវិក្កយបត្រលក់ដែលបានចុះបញ្ជី",
    generalLedgerEntryChangesLogs: "កំណត់ត្រាប្រែប្រួលធាតុចូលសៀវភៅធំទូទៅ",
    changeBankAccount: "ផ្លាស់ប្តូរគណនីធនាគារ",
    purchaseInvoiceApprovalDetail: "ព័ត៌មានលម្អិតអំពីការអនុម័តវិក្កយបត្រ​ទិញ",
    changeItem: "ប្ដូរ {item}",
    itemJournalLog: "កំណត់ហេតុធាតុ",
    changesLogs: "កំណត់ហេតុបម្លែង",
    cancelledPurchaseReceipts: "វិក្កយបត្រទិញដែលបានបោះបង់",
    newPaymentJournal: "កាសែតបង់ប្រាក់ថ្មី",
    newCashReceiptJournal: "កាសែតសាច់ប្រាក់ថ្មី",
    itemsWithIncorrectCosts: "អត្ថបទដែលមានតម្លៃមិនត្រឹមត្រូវ",
    ve: "វេ",
    chooseVeEntry: "ជ្រើសរើស VE ចូល",
    confirmDeleteVe: "បញ្ជាក់លុប VE",
    deleteValueEntry: "លុប VE",
    deleteValueEntryDialog: "លុបចេញតម្លៃ",
    deleteGeneralJournalEntryDialog: "លុបកំណត់ហេតុទូទៅ",
    selfBilledInvoice: "វិក្កយបត្រដែលខ្លួនឯងរៀបចំ",
    taxIntegrationLog: "កំណត់ត្រាអង្គភាពពន្ធ",
    updateStoreRequisition: "កែប្រែស្ថានភាពការស្នើសុំហាង",
    printoutLayout: "ការរៀបចំការបោះពុម្ព",
    adjustPostingDate: "កំណត់ថ្ងៃបោះពុម្ព",
    inventoryPostingGroups: "ក្រុមបោះពុម្ពស្តុក",
    entryEditorChangeAccountNumberAndDescription: "ប្តូរលេខគណនី និងការពិពណ៌នា",
    revertPostedPurchaseInvoice: "បង្រួមវិក្កយបត្រទិញដែលបានបង្ហោះ",
    changeLineStatus: "ប្តូរស្ថានភាពបន្ទាត់",
    dimension: "វិមាត្រ",
    dimensionValueType: "ប្រភេទតម្លៃវិមាត្រ",
    dimensionValue: "តម្លៃវិមាត្រ",
    dimensionOption: "ជម្រើសវិមាត្រ",
    coaDimension: "វិមាត្រ COA",
    coaDimensionOptions: "ជម្រើសវិមាត្រ COA",
    coaDimensionMatrix: "ម៉ាត្រិកវិមាត្រ COA",
    updateCoaDimensionMapping: "អាប់ដេតផែនទីវិមាត្រ COA",
    defaultDimension: "វិមាត្រមូលដ្ឋាន",
    dimensionRule: "ច្បាប់វិមាត្រ",
    dimensionRules: "ច្បាប់វិមាត្រ",
    allowedDimensionValues: "តំលៃវិមាត្រដែលអនុញ្ញាត",
    documentDimension: "វិមាត្រឯកសារ",
    approvalDocumentWithdrawal: "ការទាញយកឯកសារអនុម័ត",
    deleteEntries: "លុបចូលខាងក្នុង",
    confirmDeletePurchaseInvoice: "បញ្ជាក់លុបវិក្កយបត្រ​ទិញ",
    storeRequisitionTemplate: "គំរូស្នើសុំហាង",
    deletePostedMemo: "លុបមេម៉ូរ៉ាដែលបានបង្ហោះ",
    entryEditorChangeDimensionSet: "ប្តូរ​កំណត់​មាត្រា",
    revertPostedPurchaseCreditMemo: "បង្រួមវិញសម្រង់ឥណទានការទិញ",
    ytdAddAdditionalYear: "បន្ថែមឆ្នាំបន្ថែម (ការប្រៀបធៀបរបាយការណ៍ YTD)",
    revertPostedInterDepartmentTransfer: "Revert Posted Inter Department Transfer",
    depositAccountPostingGroup: "ក្រុមបញ្ចូលគណនីប្រាក់កក់",
    depositAccount: "គណនីដាក់ប្រាក់",
    depositAccountLedgerEntry: "កំណត់ត្រាអាករ​ប្រាក់បញ្ញើ",
    depositAccountLedgerEntryDetail: "ព័ត៌មានបញ្ជីគណនីដាក់ប្រាក់",
    deleteDepositAccountLedgerEntry: "លុប DALE",
    deleteDepositAccountLedgerEntryDialog: "លុបចេញកំណត់ត្រាផ្ទុកប្រាក់",
    daleDetail: "ព័ត៌មានលម្អិត DALE",
    dale: "ដេឡេ",
    chooseDaleEntry: "ជ្រើសរើសការបញ្ចូលដេល",
    confirmDeleteDaleDetail: "បញ្ជាក់លុបព័ត៌មាន DALE",
    confirmDeleteDale: "បញ្ជាក់លុប DALE",
    interDepartmentTransferApprovalDetail: "ព័ត៌មានលម្អិតអនុម័តការផ្ទេររវាងនាយកដ្ឋាន",
    dimensionLevel: "កម្រិតវិមាត្រ",
    generalBudgetEntry: "ការបញ្ចូលថវិកាទូទៅ",
    generalBudgetJournal: "កំណត់ហេតុថវិកាសាធារណៈ",
    reportByDimension: "របាយការណ៍តាមវិមាត្រ",
    profitAndLossBudgetSource: "ប្រាក់ចំណេញ និងខាតបង់ប្រភពថវិកា",
    deleteSelectedInvoices: "លុបវិក័យប័ត្រដែលបានជ្រើសរើស",
    confirmDimensionSet: "បញ្ជាក់ការកំណត់វិមាត្រ",
    cashFlowBudget: "ថវិកាប្រាក់ចំណូល",
    expenseAllocation: "ការបែងចែកចំណាយ",
    newReconciliationJournal: "កាសែតសម្របសម្រួលថ្មី",
  },
  word: {
    entryNo: "លេខធាតុចូល",
    chooseThePrintingPageSize: "ជ្រើសរើសទំហំទំព័របោះពុម្ព",
    changedTo: "ទៅ",
    chooseThePurchaseBookOption: "ជ្រើសរើសជម្រើសសៀវភៅទិញ",
    importRejected: "ការនាំចូលត្រូវបានបដិសេធ។ សូមកែសម្រួលជួរទាំងនេះ និងនាំចូលម្តងទៀត។",
    importWithReservationSuccess: "នាំចូលវិក្កយបត្រ {invoices} និងការកក់ {reservations}។",
  },
  main: {
    search: "ស្វែងរក",
    account: "គណនី",
    interimAccount: "គណនីបណ្តោះអាសន្ន",
  },
  form: {
    purchaseOrders: "បញ្ជាទិញ",
    purchaseRequest: "សំណើទិញ",
    outstandingPurchaseRequest: "សំណើទិញមិនទាន់ដោះស្រាយ",
    receiving: "ការទទួល",
    info: "ព័ត៌មាន",
    vendors: "អ្នកផ្គត់ផ្គង់",
    items: "ទំនិញ",
    breakdowns: "បំបែក",
  },
  button: {
    directExpense: "កំណត់ជាចំណាយផ្ទាល់",
    correction: "ធ្វើការកែសម្រួលអនុវត្តថេរ",
    setVendor: "កំណត់អ្នកផ្គត់ផ្គង់",
    getLastDirectCost: "យកថ្លៃដើមផ្ទាល់ចុងក្រោយ",
    preview: "មើលជាមុន",
    resetEntry: "កំណត់ឡើងវិញធាតុចូលទាំងអស់",
    manageBankAccount: "គ្រប់គ្រងគណនីធនាគារ",
    viewDetail: "មើលព័ត៌មានលម្អិត",
    viewAppliedEntries: "ធាតុចូលដែលបានអនុវត្ត",
    viewEntries: "មើលធាតុចូល",
    previewUndoReceipt: "មើលជាមុនមិនធ្វើវិញបង្កាន់ដៃទទួល",
    cancelReceipt: "តើអ្នកប្រាកដថាចង់បោះបង់ការទទួល {f} ឬ? ដំណើរការនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    cancelReceiptSuccess: "{f} ត្រូវបានបោះបង់ដោយជោគជ័យ!",
    cancelReceiptFailed: "កំហុស មិនអាចបោះបង់ {f} បានទេ។",
    cancelReceiptHeader: "បោះបង់ការទទួល {f}",
    undoReceipt: "តើអ្នកប្រាកដថាចង់មិនធ្វើវិញការទទួល {f} ឬ? ដំណើរការនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    undoReceiptSuccess: "មិនធ្វើវិញ {f} ជោគជ័យ!",
    undoReceiptFailed: "កំហុស មិនអាចមិនធ្វើវិញ {f} បានទេ។",
    undoReceiptHeader: "មិនធ្វើវិញការទទួល {f}",
    forceCloseHeader: "បិទដោយបង្ខំ {f}",
    forceClose: "តើអ្នកប្រាកដថាចង់បិទដោយបង្ខំ {f1} ជួរនៃ {f2} ឬ? ដំណើរការនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    addfromReceiptSuccess: "{f} ត្រូវបានបន្ថែមដោយជោគជ័យជាមួយ {d} ស្ទួនរកឃើញ",
    incompleteSearch: "{f} ត្រូវការតម្រងទីតាំង ឬទំនិញ",
    postedFailedNoItems: "កំហុស មិនអាចចុះបញ្ជី {f} បានទេ។ ត្រូវមានយ៉ាងហោចណាស់ 1 ធាតុត្រូវទទួល។",
    postFailedNoItems: "កំហុស មិនអាចចុះបញ្ជី {f} បានទេ។ ត្រូវមានយ៉ាងហោចណាស់ 1 ធាតុក្នុងឯកសារ។",
    updateFailedOnUnitEmpty: "កំហុស មិនអាចរក្សាទុក {f1} បានទេ។<br/>ធាតុទាំងនេះគ្មានឯកតាវាស់:<br/>{f2}",
    printFailedNoActiveFlow: "កំហុស មិនអាចបោះពុម្ពឯកសារនេះបានទេ។<br/>គ្មានលំហូរឯកសារដែលសកម្មនៅលើកញ្ចប់ {f}។",
    deleteFailedAlreadyReleased: "កំហុស មិនអាចលុប {f} បានទេ។<br/>ឯកសារនេះបានចេញផ្សាយរួចហើយ។",
    previewCancelReceipt: "មើលជាមុនបោះបង់បង្កាន់ដៃទទួល",
    delete: "លុប",
    createCreditMemo: "បង្កើតកំណត់ត្រាប្រាក់ឥណទានកែតម្រូវ",
    calculateInventory: "គណនាសន្និធិ",
    refreshUnitCost: "ធ្វើបច្ចុប្បន្នភាពថ្លៃដើមឯកតា",
    upload: "ផ្ទុកឡើង",
    download: "ទាញយក",
    downloadTemplate: "ទាញយកគំរូ",
    previewData: "មើលទិន្នន័យជាមុន",
    import: "នាំចូល",
    view: "មើល",
    new: "ថ្មី",
    edit: "កែសម្រួល",
    ok: "យល់ព្រម",
    cancel: "បោះបង់",
    save: "រក្សាទុក",
    recalculateAverageCost: "គណនាថ្លៃដើមមធ្យមឡើងវិញ",
    add: "បន្ថែម",
    choose: "ជ្រើសរើស",
    print: "បោះពុម្ព",
    post: "ចុះបញ្ជី",
    unpost: "ដកចេញពីបញ្ជី",
    previewPost: "មើលជាមុនការចុះបញ្ជី",
    printSupplierComparison: "បោះពុម្ពប្រៀបធៀបអ្នកផ្គត់ផ្គង់",
    insertFromTemplate: "បញ្ចូលពីពុម្ព",
    applyEntries: "អនុវត្តធាតុចូល",
    unapplyEntries: "ដកអនុវត្តធាតុចូល",
    process: "ដំណើរការ",
    processToPo: "ដំណើរការទៅ PO",
    reject: "បដិសេធ",
    decline: "បដិសេធ",
    approve: "អនុម័ត",
    submitApproval: "ដាក់ស្នើសុំអនុម័ត",
    reopen: "បើកឡើងវិញ",
    release: "ចេញផ្សាយ",
    select: "ជ្រើសរើស",
    close: "បិទ",
    move: "ផ្លាស់ទី",
    clear: "សម្អាត",
    saveChange: "រក្សាទុកការផ្លាស់ប្តូរ",
    saveAsTemplate: "រក្សាទុកជាពុម្ព",
    addNewTemplate: "បន្ថែមពុម្ពថ្មី",
    AddFromReceipt: "បន្ថែមពីបង្កាន់ដៃទទួល",
    reset: "កំណត់ឡើងវិញ",
    apply: "អនុវត្ត",
    addFilter: "បន្ថែមតម្រង",
    navigate: "រុករក",
    reverse: "បញ្ច្រាស",
    receiveAll: "កំណត់ទទួលទាំងអស់",
    ClearReceive: "សម្អាតការទទួល",
    closePeriod: "បិទរយៈពេល",
    reopenPeriod: "បើកឡើងវិញរយៈពេល",
    reopenPeriodForce: "បើកឡើងវិញរយៈពេល (បង្ខំ)",
    closeMonthPeriod: "បិទខែ",
    reopenMonthPeriod: "បើកខែឡើងវិញ",
    reopenMonthPeriodForce: "បើកខែឡើងវិញ (បង្ខំ)",
    closeYearPeriod: "បិទឆ្នាំ",
    reopenYearPeriod: "បើកឆ្នាំឡើងវិញ",
    viewPrice: "មើលតម្លៃ",
    newItem: "ទំនិញថ្មី",
    splitItem: "បំបែកទំនិញ",
    postAndPrint: "ចុះបញ្ជី & បោះពុម្ព",
    vendorEntries: "ធាតុចូលអ្នកផ្គត់ផ្គង់",
    postBatch: "ចុះបញ្ជីកញ្ចប់",
    getPostedSalesInvoice: "យកវិក្កយបត្រលក់ដែលបានចុះបញ្ជី",
    setQtyToZero: "កំណត់បរិមាណទៅសូន្យ",
    showOpenOnly: "បង្ហាញតែដែលបើក",
    history: "ប្រវត្តិ",
    released: "បានចេញផ្សាយ",
    deleted: "បានលុប",
    showData: "បង្ហាញទិន្នន័យ",
    newItemFromPR: "ទំនិញថ្មីពី PR",
    setReconciled: "កំណត់ជាតុល្យភាព",
    unsetReconciled: "ដកតុល្យភាពចេញ",
    downloadToGSheet: "ទៅ GSheet",
    downloadToExcel: "ទៅ Excel",
    downloadToPDF: "ទៅ PDF",
    goToSetup: "ទៅកាន់ការកំណត់",
    goToInvReconSetup: "ទៅកាន់ការកំណត់តុល្យភាពសន្និធិ",
    goToInventorySetup: "ទៅកាន់ការកំណត់សន្និធិ",
    applyEntriesFromInvoice: "អនុវត្តធាតុចូលពីវិក្កយបត្រ",
    applyEntriesFromCreditMemo: "អនុវត្តធាតុចូលពីកំណត់ត្រាប្រាក់ឥណទាន",
    submit: "ដាក់ស្នើ",
    submitForApproval: "ដាក់ស្នើសុំអនុម័ត",
    deleteAll: "លុបទាំងអស់",
    approvalDetail: "ព័ត៌មានលម្អិតអនុម័ត",
    delegate: "ផ្ទេរ",
    withdraw: "ដកចេញ",
    previewAdjustCostEntries: "មើលជាមុនកែសម្រួលថ្លៃដើម",
    adjustCostEntries: "កែសម្រួលថ្លៃដើម",
    splitInvoice: "បំបែកវិក្កយបត្រ",
    selectAll: "ជ្រើសរើសទាំងអស់",
    unselectAll: "ដកជ្រើសរើសទាំងអស់",
    back: "ថយក្រោយ",
    next: "បន្ទាប់",
    confirm: "បញ្ជាក់",
    recall: "ហៅវិញ",
    refresh: "ធ្វើបច្ចុប្បន្នភាព",
    viewAccount: "មើលគណនី",
    viewDimension: "មើលវិមាត្រ",
    undoForceClose: "មិនធ្វើវិញបិទដោយបង្ខំ",
    adjustValueEntryAmount: "កែសម្រួលចំនួនធាតុចូលតម្លៃ",
    updateLowestUnitCostVendorComparison: "ធ្វើបច្ចុប្បន្នភាពថ្លៃដើមឯកតាតាមតម្លៃទាបបំផុតរបស់អ្នកផ្គត់ផ្គង់",
    importHOAInvoice: "នាំចូលវិក្កយបត្រ HOA",
    deleteBy: "លុបដោយ {f}",
    deleteByIleId: "លុបដោយ ILE ID",
    deleteByDocumentNo: "លុបដោយលេខឯកសារ",
    newSet: "កំណត់ថ្មី",
    invoicedOnly: "វិក្កយបត្រ​តែប៉ុណ្ណោះ",
    updateStatus: "អាប់ដេតស្ថានភាព",
    undo: "បោះបង់",
    clearAll: "លុបអស់គ្នា",
    recalculateInventory: "គណនាថ្មីស្តុក",
    revert: "ត្រឡប់វិញ",
    lineStatusFilter: "ច្រកស្ថានភាព",
    create: "បង្កើត",
    selectDimensionValues: "ជ្រើសរើសតម្លៃវិមាត្រ",
    includeClosedInvoice: "រួមបញ្ចូលវិក្កយបត្របិទ",
    includeClosedEntry: "រួមបញ្ចូលការបញ្ចូលដែលបានបិទ",
    addDimension: "បន្ថែមវិមាត្រ",
    approvalNotes: "កំណត់សម្គាល់អនុម័ត",
    importInvoiceWithReservation: "នាំចូលវិក្កយបត្រជាមួយការកក់",
    readSheet: "អានសន្លឹក",
    newLine: "បន្ទាត់ថ្មី",
    generateAccrual: "បង្កើតការបូកសរុប",
    googleSheetJournalFormat: "ក្រដាសកុំព្យូទ័រ (ទម្រង់កាសែត)",
    excelJournalFormat: "Excel (ទម្រង់កាសែត)",
    journalExcelTemplate: "គំរូ Excel (ទម្រង់កាសែត)",
    printReceipt: "បោះពុម្ពវិក្កយបត្រ",
    postAllBatch: "បោះពុម្ពគ្រប់កញ្ចប់",
    deleteAllBatch: "លុបបាច់ទាំងអស់",
  },
  excel: {
    excel: "Excel",
    upload: "ផ្ទុកឡើង",
    uploadInsert: "ផ្ទុកឡើង (បញ្ចូល)",
    uploadUpdate: "ផ្ទុកឡើង (កែសម្រួល)",
    download: "ទាញយក",
    downloadTemplate: "ទាញយកគំរូ",
    preview: "មើលទិន្នន័យជាមុន",
    import: "នាំចូល",
    cancel: "បោះបង់",
    importSuccess: "ការនាំចូលជោគជ័យ",
    importFailed: "ការនាំចូលបានបរាជ័យ",
    downloadFailed: "មិនអាចទាញយកទិន្នន័យបានទេ",
    parseFailed: "មិនអាចញែកឯកសារ Excel បានទេ",
    noValidRows: "គ្មានជួរត្រឹមត្រូវសម្រាប់នាំចូល",
    noDataRows: "ឯកសារមិនមានទិន្នន័យ",
    invalidFileType: "មានតែឯកសារ .xlsx ដែលត្រូវបានគាំទ្រ",
    fileTooLarge: "ទំហំឯកសារត្រូវតិចជាង {size}MB",
    missingColumns: "ការនាំចូលត្រូវបានបិទ — បាត់ជួរឈរដែលរំពឹងទុក: {columns}។ សូមទាញយកគំរូម្តងទៀត។",
  },
  select: {
    base: "ជ្រើសរើស {f}",
  },
  reports: {
    allVendor: "អ្នកផ្គត់ផ្គង់ទាំងអស់",
    noVendor: "គ្មានអ្នកផ្គត់ផ្គង់",
    vendorList: "បញ្ជីអ្នកផ្គត់ផ្គង់",
    earliestPostingDate: "កាលបរិច្ឆេទចុះបញ្ជីដំបូងបង្អស់",
    latestPostingDate: "កាលបរិច្ឆេទចុះបញ្ជីចុងក្រោយបង្អស់",
    selectVendor: "ជ្រើសរើសអ្នកផ្គត់ផ្គង់",
    detailLocationSummary: "សង្ខេបទីតាំងលម្អិត",
    pnlFileID: "លេខសម្គាល់ឯកសារ P&L Excel {f}",
    exportPnl: "ប្រាក់ចំណេញនិងខាត {f}",
    pnlID: "លេខសម្គាល់ P&L {f}",
    downloadToExcel: "ទៅ Excel",
    profitAndLossCurrentMonthConsolidationExcelFileID: "លេខសម្គាល់ឯកសារ P&L ប្រចាំខែបញ្ចូល Excel",
    profitAndLossYTDConsolidationExcelFileID: "លេខសម្គាល់ឯកសារ P&L YTD បញ្ចូល Excel",
    profitAndLossYTDSummaryExcelFileID: "លេខសម្គាល់ឯកសារ P&L YTD សង្ខេប Excel",
    balanceSheetExcelFileID: "លេខសម្គាល់ឯកសារ Balance Sheet Excel",
    dailyFlashCostExcelFileID: "លេខសម្គាល់ឯកសារ Daily Flash Cost Excel",
    DRRExcelFileID: "លេខសម្គាល់ឯកសារ DRR Excel",
    FBMealCoverExcelFileID: "លេខសម្គាល់ឯកសារ FB Meal Cover Excel",
    profitAndLossCurrentMonthConsolidationGoogleSheetFileID: "លេខសម្គាល់ឯកសារ P&L ប្រចាំខែបញ្ចូល Google Sheet",
    profitAndLossYTDConsolidationGoogleSheetFileID: "លេខសម្គាល់ឯកសារ P&L YTD បញ្ចូល Google Sheet",
    profitAndLossYTDSummaryGoogleSheetFileID: "លេខសម្គាល់ឯកសារ P&L YTD សង្ខេប Google Sheet",
    balanceSheetGoogleSheetFileID: "លេខសម្គាល់ឯកសារ Balance Sheet Google Sheet",
    dailyFlashCostGoogleSheetFileID: "លេខសម្គាល់ឯកសារ Daily Flash Cost Google Sheet",
    DRRGoogleSheetFileID: "លេខសម្គាល់ឯកសារ DRR Google Sheet",
    FBMealCoverGoogleSheetFileID: "លេខសម្គាល់ឯកសារ FB Meal Cover Google Sheet",
    startInventoryAccountNumber: "លេខគណនីសន្និធិចាប់ផ្តើម",
    endInventoryAccountNumber: "លេខគណនីសន្និធិបញ្ចប់",
    accountPayableInterim: "បំណុលត្រូវបង់បណ្តោះអាសន្ន",
    inventoryDiscrepancyReport: "របាយការណ៍ភាពខុសគ្នាសន្និធិ",
    inventoryFoodDiscrepancy: "ភាពខុសគ្នាសន្និធិអាហារ",
    inventoryBeverageDiscrepancy: "ភាពខុសគ្នាសន្និធិភេសជ្ជៈ",
    invAccBalanceSOHDiscrepancy: "ភាពខុសគ្នារវាងតុល្យភាពសន្និធិ និង SOH",
    financialReport: "របាយការណ៍ហិរញ្ញវត្ថុ",
    accountPayableReport: "របាយការណ៍បំណុលត្រូវបង់",
    accountReceivableReport: "របាយការណ៍បំណុលត្រូវទទួល",
    inventoryReport: "របាយការណ៍សន្និធិ",
    frontOfficeReport: "របាយការណ៍ស្នាក់នៅមុខ",
    balanceSheet: "តារាងតុល្យភាព",
    trialBalance: "តុល្យភាពសាកល្បង",
    profitAndLoss: "ប្រាក់ចំណេញនិងខាត",
    profitAndLossYTDSummary: "សង្ខេបប្រាក់ចំណេញនិងខាត YTD",
    profitAndLossCurrentMonthConsolidation: "បញ្ចូលប្រាក់ចំណេញនិងខាតប្រចាំខែ",
    profitAndLossYTDConsolidation: "បញ្ចូលប្រាក់ចំណេញនិងខាត YTD",
    accountPayableAging: "អាយុបំណុលត្រូវបង់",
    accountPayableInterimAging: "អាយុបំណុលត្រូវបង់បណ្តោះអាសន្ន",
    accountPayablePaymentList: "បញ្ជីបង់ប្រាក់បំណុលត្រូវបង់",
    accountReceivableAging: "អាយុបំណុលត្រូវទទួល",
    accountReceivableAgingCard: "អាយុបំណុលត្រូវទទួលតាមកាត",
    accountReceivablePaymentList: "បញ្ជីបង់ប្រាក់បំណុលត្រូវទទួល",
    accountReceivablePaymentListCard: "បញ្ជីបង់ប្រាក់បំណុលត្រូវទទួលតាមកាត",
    accountReceivablePaymentListLedger: "បញ្ជីបង់ប្រាក់បំណុលត្រូវទទួលតាមសៀវភៅ",
    inventoryAccountBalanceDetail: "ព័ត៌មានលម្អិតតុល្យភាពសន្និធិ",
    stockOnHand: "សន្និធិនៅលើដៃ",
    topPurchaseItem: "ទំនិញទិញច្រើនបំផុត",
    topPurchaseByVendor: "ទិញច្រើនបំផុតតាមអ្នកផ្គត់ផ្គង់",
    topPurchaseByVendorReport: "របាយការណ៍ទិញច្រើនបំផុតតាមអ្នកផ្គត់ផ្គង់",
    vendorReport: "របាយការណ៍អ្នកផ្គត់ផ្គង់",
    dailyFlashCost: "ថ្លៃដើមប្រចាំថ្ងៃ",
    slowMovingInventory: "សន្និធិចលនាថយចុះ",
    itemExpense: "ចំណាយទំនិញ",
    receivingReport: "របាយការណ៍ទទួល",
    inventoryReconciliation: "តុល្យភាពសន្និធិ",
    itemReorder: "បញ្ជាទិញឡើងវិញ",
    outstandingPurchaseOrder: "បញ្ជាទិញមិនទាន់ដោះស្រាយ",
    forceClosedPurchaseOrder: "បញ្ជាទិញដែលបានបិទដោយបង្ខំ",
    purchasingReport: "របាយការណ៍ការទិញ",
    inventoryMovementReport: "របាយការណ៍ចលនាសន្និធិ",
    guestAccountBalance: "តុល្យភាពគណនីភ្ញៀវ",
    FOClosingCashier: "បិទបេឡាករមុខ",
    POSClosingCashier: "បិទបេឡាករផ្នែកលក់",
    dailyRevenueReport: "របាយការណ៍ប្រាក់ចំណូលប្រចាំថ្ងៃ",
    FBMealCover: "FB Meal Cover",
    incomeAudit: "សវនកម្មប្រាក់ចំណូល",
    budgetRevenue: "ប្រាក់ចំណូលថវិកា",
    budgetStatistic: "ស្ថិតិថវិកា",
    showGuestAccountName: "បង្ហាញឈ្មោះភ្ញៀវ/គណនី",
    showSalesPersonName: "បង្ហាញឈ្មោះបុគ្គលិកលក់",
    showContactName: "បង្ហាញឈ្មោះទំនាក់ទំនងអតិថិជន",
    agingDate: "កាលបរិច្ឆេទអាយុបំណុល",
    discrepancyReport: "របាយការណ៍ភាពខុសគ្នា",
    discrepancy: "ភាពខុសគ្នា",
    agingBy: "អាយុតាម",
    arAgingReport: "របាយការណ៍អាយុបំណុលត្រូវទទួល",
    cardAgingReport: "របាយការណ៍អាយុបំណុលតាមកាត",
    arAgingAccountSetup: "ការកំណត់គណនីអាយុ AR",
    arAgingAccountSetupNotes: "ប្រើសម្រាប់ភាពខុសគ្នាតុល្យភាពរបាយការណ៍អាយុ AR",
    apAgingAccountSetup: "ការកំណត់គណនីអាយុ AP",
    apAgingAccountSetupNotes: "ប្រើសម្រាប់ភាពខុសគ្នាតុល្យភាពរបាយការណ៍អាយុ AP",
    arAgingDiscrepancyReport: "របាយការណ៍ភាពខុសគ្នាអាយុ AR",
    arAgingDiscrepancy: "ភាពខុសគ្នាអាយុ AR",
    apAgingDiscrepancyReport: "របាយការណ៍ភាពខុសគ្នាអាយុ AP",
    apAgingDiscrepancy: "ភាពខុសគ្នាអាយុ AP",
    bankAccountAgingDiscrepancyReport: "របាយការណ៍ភាពខុសគ្នាអាយុគណនីធនាគារ",
    bankAccountAgingDiscrepancy: "ភាពខុសគ្នាអាយុគណនីធនាគារ",
    arAgingCardAndLedger: "អាយុបំណុលត្រូវទទួលតាមកាតនិងសៀវភៅ",
    arAgingCardAndLedgerReport: "របាយការណ៍អាយុបំណុលត្រូវទទួលតាមកាតនិងសៀវភៅ",
    revenueCenterCode: "កូដមជ្ឈមណ្ឌលប្រាក់ចំណូល",
    TBSummaryGoogleSheetFileID: "លេខសម្គាល់ឯកសារ Google Sheet សង្ខេបតុល្យភាពសាកល្បង",
    TBSummaryExcelFileID: "លេខសម្គាល់ឯកសារ Excel សង្ខេបតុល្យភាពសាកល្បង",
    gsheetTemplateIsNotConfiguredYet: "គំរូ Ghseet មិនបានកំណត់នៅឡើយ",
    excelTemplateIsNotConfiguredYet: "គំរូ Excel មិនទាន់កំណត់ទេ",
    downloadAsMacro: "ទាញយកជាម៉ាក្រូ",
    balanceSheetYTDSummary: "សេចក្តីសង្ខេបតុល្យភាព YTD",
    accountScheduleConsolidation: "ការប្រមូលផ្តុំកាលវិភាគគណនី",
    accountScheduleConsolidationReport: "របាយការណ៍សម្របសម្រួលកាលវិភាគគណនី",
    accountScheduleConsolidationExcelFileID: "លេខសម្គាល់ឯកសារ Excel សម្រាប់ការប្រមូលផ្តុំកាលវិភាគគណនី",
    accountScheduleConsolidationGoogleSheetFileID: "លេខសម្គាល់ឯកសារ Google Sheet សម្រាប់ការបូកសរុបគណនី",
    notAvailableForPreview: "{item} មិនអាចមើលជាមុនបានទេ។ សូមទាញយករបាយការណ៍ដើម្បីមើលទិន្នន័យនេះ។",
    trialBalanceYTD: "តុល្យភាពសាកល្បង YTD",
    itemConsumptionReport: "របាយការណ៍ប្រើប្រាស់ធាតុ",
    interfaceJournal: "កាសែតអន្តរកម្ម",
    includeDimension: "រួមបញ្ចូលជួរឈរវិមាត្រ",
    useReceivableDateAging: "ប្រើកាលបរិច្ឆេទទទួលប្រាក់ / កាលបរិច្ឆេទបញ្ចូល",
    accountPayableInterimIsNotConfiguredYet: "គណនីបង់ប្រាក់អន្តរម៉ោងមិនទាន់បានកំណត់។ សូមកំណត់នៅក្នុងការកំណត់របាយការណ៍។",
    accountPayableInterimAccountNotFound: "គណនីបង់ប្រាក់អន្តរាយដែលបានកំណត់មិនត្រូវបានរកឃើញនៅក្នុងតារាងគណនី។",
    cashFlowExcelFileID: "អត្តសញ្ញាណឯកសារ Excel ប្រាក់ចំណូល",
    cashFlowYTDSummaryExcelFileID: "ឯកសារ Excel សង្ខេបលំហូរប្រាក់ YTD",
    excelTemplateNotUploaded: "គំរូ Excel មិនទាន់បានផ្ទុកឡើងទេ។ ផ្ទុកឡើងនៅក្នុង ទិន្នន័យមេ > ការកំណត់ទូទៅ > ការកំណត់របាយការណ៍។",
    cashFlow: "ប្រាក់ចំណូល",
    cashFlowYTDSummary: "សេចក្តីសង្ខេបលំហូរកាក់ YTD",
    cashFlowNotConfigured: "មិនមានវិមាត្រប្រាក់ចូលចេញដែលបានកំណត់ទេ។ បន្ថែមមួយនៅក្រោមការកំណត់បញ្ជីទូទាត់ → របាយការណ៍តាមវិមាត្រ → ប្រាក់ចូលចេញ។",
    actualCurrentMonth: "ខែបច្ចុប្បន្ន",
    budgetCurrentMonth: "ថវិកាខែបច្ចុប្បន្ន",
    actualLastMonth: "ខែមុនពិត",
    actualLastYear: "ឆ្នាំមុនពិត",
    actualYTDCurrentMonth: "មួយខែបច្ចុប្បន្ន YTD",
    budgetYTDCurrentMonth: "ថវិកាដល់បច្ចុប្បន្នខែ",
    actualYTDLastYear: "ឆ្នាំមុន YTD",
    cashFlowByDepartmentExcelFileID: "លេខសម្គាល់ឯកសារ Excel ប្រាក់ចំណូលតាមផ្នែក",
    cashFlowByDepartment: "ប្រាក់ចំណូលតាមផ្នែក",
    cashFlowByDepartmentNotConfigured: "កំណត់ពីរម៉ាស៊ីនក្រោមការកំណត់សៀវភៅទូទៅ → របាយការណ៍តាមម៉ាស៊ីន → ប្រាក់ចំណូលតាមផ្នែក: មួយគឺអ័ក្សជួរ, មួយគឺអ័ក្សជួរ.",
    cashFlowMonthToDate: "ខែនេះដល់ថ្ងៃ",
    cashFlowYearToDate: "ឆ្នាំដល់ថ្ងៃនេះ",
    cashFlowUnassigned: "មិនបានកំណត់",
    cashFlowTotal: "សរុប",
  },
  status: {
    pleaseWait: "សូមរង់ចាំ...",
    loadingpleaseWait: "កំពុងផ្ទុក... សូមរង់ចាំ",
    trialBalanceDetail: {
      generatingData: "កំពុងបង្កើតព័ត៌មានលម្អិតតុល្យភាពសាកល្បង។ សូមរង់ចាំ វាអាចចំណាយពេល។ អ្នកអាចបិទផ្ទាំង/បង្អួច ឬប្ដូរទៅទំព័រផ្សេងបាន ដំណើរការនឹងបន្ត។",
      readyForDownload: "ឯកសារ Excel ទាំងអស់សម្រាប់រយៈពេលនេះរួចរាល់សម្រាប់ទាញយក",
      sendEmail: "និងផ្ញើទៅអ៊ីមែល:",
      exclusiveDownload: "លទ្ធផលលម្អិតនៃតុល្យភាពសាកល្បងមិនអាចបង្ហាញលើវេបសាយបានទេ ហើយអាចទាញយកតាមឯកសារប៉ុណ្ណោះ។ <br> សម្រាប់ទិន្នន័យលើស 5,000 ជួរ សូមប្រើជម្រើសទាញយក Excel។",
      gsheeRowLimitExceeded: "ចំនួនជួរលើសកំណត់សម្រាប់ Google Sheets។ សូមពិចារណាទាញយកឯកសារជា Excel វិញ។",
      downloadPartialMessage: "ឯកសារទាញយកតុល្យភាពសាកល្បងនឹងត្រូវបែងចែកតាមខែ។ សូមកុំបិទកម្មវិធីរុករកក្នុងដំណើរការនេះ។",
      periodStarted: "ការបង្កើតឯកសារ Excel សម្រាប់រយៈពេលចាប់ផ្តើមពី {p} បានចាប់ផ្តើម។",
      inProgressFile: "កំពុងបង្កើតឯកសារ:",
      willSendToEmail: "ឯកសារព័ត៌មានតុល្យភាពកំពុងត្រូវបានបង្កើត ហើយនឹងត្រូវផ្ញើទៅ {email} បន្ទាប់ពីបញ្ចប់។",
      csvOptionDownload: "សម្រាប់រយៈពេលលើសមួយខែ សូមប្រើការទាញយក CSV។",
      rowLimitExceeded: "This range has {rows} ledger entries (max {max}). Narrow the date range or use the CSV download.",
    },
    purchaseReceivingDetail: {
      generatingData: "កំពុងបង្កើតព័ត៌មានលម្អិតរបាយការណ៍ទទួល។ សូមរង់ចាំ វាអាចចំណាយពេល។ អ្នកអាចបិទផ្ទាំង/បង្អួច ឬប្ដូរទៅទំព័រផ្សេងបាន ដំណើរការនឹងបន្ត។",
      readyForDownload: "ឯកសារព័ត៌មានលម្អិតរបាយការណ៍ទទួលរួចរាល់សម្រាប់ទាញយក: ",
      sendEmail: "និងផ្ញើទៅអ៊ីមែល:",
      exclusiveDownload: "លទ្ធផលលម្អិតនៃរបាយការណ៍ទទួលមិនអាចបង្ហាញលើវេបសាយបានទេ ហើយអាចទាញយកតាមឯកសារប៉ុណ្ណោះ។ <br> សម្រាប់ទិន្នន័យលើស 5,000 ជួរ សូមប្រើជម្រើសទាញយក Excel។",
      gsheeRowLimitExceeded: "ចំនួនជួរលើសកំណត់សម្រាប់ Google Sheets។ សូមពិចារណាទាញយកឯកសារជា Excel វិញ។",
    },
    commonReportDetail: {
      generatingData: "កំពុងបង្កើតព័ត៌មានលម្អិត {f1}។ សូមរង់ចាំ វាអាចចំណាយពេល។ អ្នកអាចបិទផ្ទាំង/បង្អួច ឬប្ដូរទៅទំព័រផ្សេងបាន ដំណើរការនឹងបន្ត។",
      readyForDownload: "ឯកសារព័ត៌មានលម្អិត {f1} រួចរាល់សម្រាប់ទាញយក: ",
      sendEmail: "និងផ្ញើទៅអ៊ីមែល:",
      exclusiveDownload: "លទ្ធផលលម្អិតនៃ {f1} មិនអាចបង្ហាញលើវេបសាយបានទេ ហើយអាចទាញយកតាមឯកសារប៉ុណ្ណោះ។ <br> សម្រាប់ទិន្នន័យលើស {f2} ជួរ សូមប្រើជម្រើសទាញយក Excel។",
      gSheetRowLimitExceeded: "ចំនួនជួរលើសកំណត់សម្រាប់ Google Sheets។ សូមពិចារណាទាញយកឯកសារជា Excel វិញ។",
    },
    disabledDueToQuantityReceived: "បានបិទដោយសារតែមានបរិមាណទទួលរួចហើយ",
    exclusiveDownload: "លទ្ធផលលម្អិតមិនអាចបង្ហាញនៅលើវេបសាយបានទេ។ សូមប្រើជម្រើសទាញយកដើម្បីមើលលម្អិតពេញលេញ។",
    willSendToEmail: "ឯកសារនេះកំពុងត្រូវបានបង្កើត ហើយនឹងត្រូវផ្ញើទៅ {email} នៅពេលបញ្ចប់។",
  },
  confirm: {
    processing: "កំពុងដំណើរការ សូមរង់ចាំ",
    noAccess: "មិនមានសិទ្ធិចូល",
    correctionTitle: "កែសម្រួលអនុវត្តថេរ",
    correction: "តើអ្នកប្រាកដថាចង់កែសម្រួលសម្រាប់ {f} ឬ?",
    receiveAllHeader: "កំណត់ទទួលទាំងអស់",
    receiveAll: "តើអ្នកចង់កំណត់ទទួលបរិមាណទាំងអស់ឬ?",
    receiveAllFailed: "កំណត់ទទួលទាំងអស់បរាជ័យ",
    noEntryPreviewPost: "ការចុះបញ្ជីនេះមិនមានធាតុចូលណាមួយទេ",
    deleteHeader: "លុប {f}",
    deleteCanUndo: "តើអ្នកប្រាកដថាចង់លុប {f} ឬ?",
    delete: "តើអ្នកប្រាកដថាចង់លុប {f} ឬ? ដំណើរការនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    deleteBatch: "តើអ្នកប្រាកដថាចង់លុប {f1} ជួរនៃ {f2} ឬ? ដំណើរការនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    deleteSuccess: "{f} ត្រូវបានលុបដោយជោគជ័យ!",
    deleteFailed: "កំហុស មិនអាចលុប {f} បានទេ។",
    updateSuccess: "{f} ត្រូវបានរក្សាទុកដោយជោគជ័យ!",
    updateFailed: "កំហុស មិនអាចរក្សាទុក {f} បានទេ។",
    printFailed: "កំហុស មិនអាចបោះពុម្ព {f} បានទេ។",
    importSuccess: "{f} ត្រូវបាននាំចូលដោយជោគជ័យ!",
    importFailed: "កំហុស មិនអាចនាំចូល {f} បានទេ។",
    dialogClosing: "កំពុងបិទប្រអប់",
    releaseSuccess: "{f} ត្រូវបានចេញផ្សាយដោយជោគជ័យ!",
    releaseFailed: "កំហុស មិនអាចចេញផ្សាយ {f} បានទេ។",
    reopenSuccess: "{f} ត្រូវបានបើកឡើងវិញដោយជោគជ័យ!",
    reopenFailed: "កំហុស មិនអាចបើកឡើងវិញ {f} បានទេ។",
    reopenFailedAlreadyProcessed: "កំហុស មិនអាចបើកឡើងវិញ {f} បានទេ។ ការបញ្ជាទិញត្រូវបានទទួលរួចហើយ",
    closeSuccess: "{f} ត្រូវបានបិទដោយជោគជ័យ!",
    closeFailed: "កំហុស មិនអាចបិទ {f} បានទេ។",
    restore: "តើអ្នកប្រាកដថាចង់ស្តារ {f} ឬ?",
    restoreHeader: "ស្តារ {f}",
    restoreFailed: "កំហុស មិនអាចស្តារ {f} ឡើងវិញបានទេ។",
    restoreSuccess: "{f} ត្រូវបានស្តារឡើងវិញដោយជោគជ័យ!",
    setToNonDirectExpense: "តើអ្នកប្រាកដថាចង់កំណត់ជាចំណាយមិនផ្ទាល់ {f} ឬ?",
    setToNonDirectExpenseHeader: "កំណត់ជាចំណាយមិនផ្ទាល់ {f}",
    setToNonDirectExpenseFailed: "កំហុស មិនអាចកំណត់ជាចំណាយមិនផ្ទាល់ {f} បានទេ។",
    setToNonDirectExpenseSuccess: "{f} ត្រូវបានកំណត់ជាចំណាយមិនផ្ទាល់ដោយជោគជ័យ!",
    applyEntriesSuccess: "ធាតុចូលត្រូវបានអនុវត្តដោយជោគជ័យ!",
    applyEntriesFailed: "កំហុស មិនអាចអនុវត្តធាតុចូល {f} បានទេ។",
    unapplyEntriesSuccess: "ធាតុចូលត្រូវបានដកអនុវត្តដោយជោគជ័យ!",
    unapplyEntriesFailed: "កំហុស មិនអាចដកអនុវត្តធាតុចូល {f} បានទេ។",
    reverseEntriesSuccess: "ធាតុចូលត្រូវបានបញ្ច្រាសដោយជោគជ័យ!",
    reverseEntriesFailed: "កំហុស មិនអាចបញ្ច្រាសធាតុចូល {f} បានទេ។",
    postedSuccess: "{f} ត្រូវបានចុះបញ្ជីដោយជោគជ័យ!",
    postedFailed: "កំហុស មិនអាចចុះបញ្ជី {f} បានទេ។",
    postedFailedUnitCostZero: "កំហុស មិនអាចចុះបញ្ជី {f} បានទេ។ ថ្លៃដើមឯកតាមិនអាចសូន្យ។",
    postHaveNegativeAdjustment: "ការព្រមាន ការចុះបញ្ជីនេះនឹងបន្ថែមការកែសម្រួលអវិជ្ជមាន។ បន្ត?",
    processSuccess: "{f} ត្រូវបានដំណើរការដោយជោគជ័យ!",
    processedItems: "- {f1} ({f2}), បរិមាណ {f3} {f4}",
    processAlready: "ធាតុទាំងនេះបានដំណើរការជា PO រួចហើយ:<br/>{f}",
    hasZeroUnitCost: "មានធាតុខ្លះមានថ្លៃដើមឯកតាសូន្យ។ សូមពិនិត្យម្តងទៀត!",
    hasZeroQuantity: "មានធាតុខ្លះមានបរិមាណសូន្យ។ សូមពិនិត្យម្តងទៀត!",
    hasZeroStockOnHand: "មានធាតុខ្លះមានសន្និធិនៅលើដៃសូន្យ។ សូមពិនិត្យម្តងទៀត!",
    hasQtyGreatedThanStockOnHand: "មានធាតុខ្លះមានបរិមាណធំជាងសន្និធិនៅលើដៃ។ សូមពិនិត្យម្តងទៀត!",
    rejectHeader: "បដិសេធ {f}",
    rejectAlready: "ធាតុទាំងនេះបានបដិសេធរួចហើយ:<br/>{f}",
    reject: "តើអ្នកប្រាកដថាចង់បដិសេធ {f} ឬ?<br/>ដំណើរការនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    splitHeader: "បំបែក {f}",
    splitSuccess: "ទំនិញត្រូវបានបំបែកដោយជោគជ័យ!",
    splitFailed: "កំហុស មិនអាចបំបែកទំនិញបានទេ។<br/>{f}",
    splitMultipleFailed: "កំហុស មិនអាចបំបែកធាតុច្រើនជាមួយគ្នា។",
    setVendorSuccess: "{f} ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ!",
    cancelReceipt: "តើអ្នកប្រាកដថាអ្នកចង់បោះបង់វិក័យប័ត្រ {f} ទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    cancelReceiptSuccess: "{f} បានបោះបង់ដោយជោគជ័យ!",
    cancelReceiptFailed: "កំហុស មិនអាចបោះបង់ {f} បានទេ។",
    cancelReceiptHeader: "បោះបង់វិក្កយបត្រ {f}",
    undoReceipt: "តើអ្នកប្រាកដថាអ្នកចង់អនុវត្តវិញការទទួល {f} ទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    undoReceiptSuccess: "បោះបង់ {f} សម្រេច!",
    undoReceiptFailed: "កំហុស, មិនអាចត្រឡប់វិញ {f}។",
    undoReceiptHeader: "បដិសេធវិក័យប័ត្រ {f}",
    forceCloseHeader: "បិទកម្លាំង {f}",
    forceClose: "តើអ្នកប្រាកដថាចង់បិទជាបន្ទាន់ {f1} បន្ទាត់នៃ {f2} មែនទេ? ដំណើរការនេះមិនអាចត្រលប់វិញបានទេ។",
    addfromReceiptSuccess: "{f} ត្រូវបានបន្ថែមដោយជោគជ័យ មាន {d} ចម្លងបានរកឃើញ",
    incompleteSearch: "{f} ត្រូវការកន្លែងឬតម្រងធាតុ",
    postedFailedNoItems: "កំហុស, មិនអាចបញ្ចូល {f} បានទេ។ ត្រូវមានយ៉ាងហោចណាស់ 1 ធាតុដើម្បីទទួល។",
    postFailedNoItems: "កំហុស, មិនអាចបង្ហោះ {f} បានទេ។ ត្រូវមានយ៉ាងហោចណាស់ ១ ធាតុក្នុងឯកសារ។",
    updateFailedOnUnitEmpty: "កំហុស, មិនអាចរក្សាទុក {f1} បានទេ។<br/>អង្គភាពវាស់មិនមានសម្រាប់វត្ថុ(ៗ)៖ <br/>{f2}",
    printFailedNoActiveFlow: "កំហុស, មិនអាចបោះពុម្ពឯកសារនេះបាន។<br/>មិនមានចរន្តឯកសារដែលសកម្មសម្រាប់កញ្ចប់ {f}។",
    deleteFailedAlreadyReleased: "កំហុស, មិនអាចលុប {f} បានទេ។<br/>ឯកសារនេះបានចេញផ្សាយរួចរាល់។",
    processToPoFailedOnVendorEmpty: "មិនអាចបន្តដំណើរការទិញបញ្ជាទិញបានទេ។ សូមបញ្ចូលបន្ទាត់សំណើទិញឱ្យពេញ។",
    invalidAmount: "កំហុស, ចំនួនមិនត្រឹមត្រូវសម្រាប់ការដាក់ពាក្យ",
    postedFailedNoItemsOnTable: "កំហុស, មិនអាចបញ្ចេញកញ្ចប់ {f} បានទេ។ ត្រូវមានឯកសារមួយនៅលើតារាង។",
    postBatchCompleted: "បញ្ចប់កញ្ចប់!",
    failedDocumentToPost: "ឯកសារមួយមិនអាចបញ្ចេញបានទេ:<br/>{f}",
    deleteAllSelected: "តើអ្នកប្រាកដថាចង់លុបវត្ថុដែលបានជ្រើសទាំងអស់មែនទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    deleteFailedNoItemsSelected: "កំហុស, មិនអាចលុប {f} បានទេ។ ត្រូវមានអត្ថបទយ៉ាងហោចណាស់ ១ ធ្វើជាជម្រើសនៅលើតារាង។",
    deleteFailedNoItems: "កំហុស, មិនអាចលុប {f} បានទេ។ ត្រូវមានយ៉ាងហោចណាស់ ១ ធាតុនៅលើតារាង។",
    setVendorFailedNoItemsSelected: "កំហុស, មិនអាចកំណត់អ្នកផ្គត់ផ្គង់បានទេ។ ត្រូវមានអង្គភាពយ៉ាងហោចណាស់ ១ ធ្វើជាជម្រើសនៅលើតារាង។",
    deleteFailedForStatus: "កំហុស មិនអាចលុប {f1} បានទេ។ {f2} បាន {f3} រួចហើយ។",
    deleteItemFailedForStatus: "កំហុស, មិនអាចលុបវត្ថុបានទេ។ ស្ថានភាពវត្ថុបានផ្លាស់ប្តូរហើយ។",
    processedItemsStatus: "- {f1} ({f2}) {f3} {f4} => <b>{f5}</b>",
    reopenFailedProcessedAlready: "บางធាតុបានដំណើរការ។ មិនអាចបើកឡើងវិញបានទេ!",
    postBatchConfirm: "តើអ្នកប្រាកដថាអ្នកចង់បង្ហោះទិន្នន័យទាំងអស់នៅលើតារាងទេ?",
    postSelectedConfirm: "តើអ្នកប្រាកដថាអ្នកចង់បញ្ចេញឯកសារដែលបានជ្រើសរើសទេ?",
    noItemSelected: "កំហុស, មិនមានអត្ថបទណាមួយបានជ្រើសរើស",
    postSRFailedPostingDateLessThanDocumentDate: "កំហុស, មិនអាចបោះពុម្ព {f} បានទេ។ ថ្ងៃបោះពុម្ពមិនអាចមុនថ្ងៃឯកសារបានទេ។",
    setAllQtyToZero: "តើអ្នកប្រាកដថាចង់កំណត់បរិមាណទាំងអស់ឲ្យសូន្យទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបាន។",
    updateLocationHeader: "ធ្វើបច្ចុប្បន្នភាពទីតាំងអត្ថបទ",
    updateLocation: "តើអ្នកចង់ធ្វើបច្ចុប្បន្នភាពទីតាំងទាំងអស់ក្នុងបន្ទាត់ទៅ {f} មែនទេ?<br/>ដំណើរការនេះមិនអាចត្រឡប់វិញបាន។",
    setLocationSuccess: "ទីតាំងវត្ថុបានអាប់ដេតដោយជោគជ័យ!",
    allQtyToZeroSuccess: "បរិមាណទាំងអស់ត្រូវបានកំណត់ទៅសូន្យដោយជោគជ័យ!",
    allQtyToZeroFailed: "កំហុស, មិនអាចកំណត់ចំនួនទាំងអស់ទៅសូន្យបានទេ!",
    refreshPhysInvUnitCost: "តើអ្នកប្រាកដថាចង់កែសម្រួលថ្លៃដើមទាំងអស់មែនទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    refreshPhysInvUnitCostSuccess: "តម្លៃឯកតាទាំងអស់ត្រូវបានអាប់ដេតដោយជោគជ័យ!",
    refreshPhysInvUnitCostFailed: "កំហុស, មិនអាចធ្វើបច្ចុប្បន្នភាពតម្លៃឯកតា!",
    itemMassRecalculate: "តើអ្នកប្រាកដថាអ្នកចង់គណនាឡើងវិញថ្លៃដើមឯកតាទាំងអស់ដែលបានជ្រើសរើសទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបាន។",
    storeRequisitionRefreshUnitCost: "តើអ្នកប្រាកដថាអ្នកចង់គណនាឡើងវិញទាំងអស់ និងអាប់ដេតថ្លៃឯកតាសម្រាប់បន្ទាត់ទាំងអស់ក្នុងឯកសារនេះទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    revertPostedStoreRequisition: "តើអ្នកប្រាកដថាអ្នកចង់បង្វិលការស្នើសុំហាងដែលបានបង្ហោះនេះទេ? ដំណើរការនេះនឹងលុបចេញពីការបញ្ចូលទាំងអស់ដែលពាក់ព័ន្ធនឹងឯកសារនេះ ហើយនឹងបង្វិល SR ទៅជាដំណោះស្រាយម្ដងទៀត។ ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    revertPostedStoreRequisitionSuccess: "ការស្នើសុំហាងបានបង្វិលដោយជោគជ័យ!",
    revertPostedStoreRequisitionFailed: "កំហុស, មិនអាចបង្វិលការស្នើសុំហាងដែលបានបង្ហោះបានទេ!",
    deleteItemLedgerEntry: "តើអ្នកប្រាកដថាអ្នកចង់លុបចេញកំណត់ត្រានេះទេ? ដំណើរការនេះនឹងលុបចេញកំណត់ត្រាទាំងអស់ដែលពាក់ព័ន្ធនឹងឯកសារនេះ។ ដំណើរការនេះមិនអាចត្រឡប់មកវិញបានទេ។",
    deleteItemLedgerEntrySuccess: "ការបញ្ចូលកំណត់ត្រាសម្ភារៈត្រូវបានលុបចោលដោយជោគជ័យ!",
    deleteItemLedgerEntryFailed: "កំហុស, មិនអាចលុបចេញកំណត់ត្រាធាតុបានទេ!",
    deleteItemLedgerEntryTypeNotAllowed: "ប្រភេទចូលនេះមិនអនុញ្ញាតឲ្យលុបបានទេ។",
    itemMassRecalculateSuccess: "តម្លៃឯកតាទាំងអស់ត្រូវបានគណនាឡើងវិញ!",
    itemMassRecalculateFailed: "កំហុស, ការគណនាតម្លៃឯកតាមិនបានជោគជ័យ!",
    itemMassRecalculateNoData: "ការគណនាឡើងវិញមិនត្រូវបានអនុវត្ត, មិនមានទិន្នន័យ!",
    refreshUnitCostSuccess: "តម្លៃឯកតាទាំងអស់បានអាប់ដេតថ្មី!",
    refreshUnitCostFailed: "កំហុស មិនអាចធ្វើបច្ចុប្បន្នភាពតម្លៃឯកតា!",
    itemTypeIsNotGl: "ប្រភេទធាតុមិនអនុញ្ញាតទេ",
    withdrawHeader: "ដកប្រាក់ {f}",
    withdraw: "តើអ្នកប្រាកដថាចង់ដកប្រាក់ {f} មែនទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    withdrawSuccess: "{f} បានដកចេញដោយជោគជ័យ!",
    delegateSuccess: "{f} ត្រូវបានផ្តល់អំណាចដោយជោគជ័យ!",
    delegate: "តើអ្នកប្រាកដថាអ្នកចង់ផ្តល់អំណាច <strong>{t}</strong> ជំនួស <strong>{f}</strong> ឬទេ? អ្នកប្រើដែលពាក់ព័ន្ធនឹងត្រូវបានជូនដំណឹង។",
    delegateHeader: "បញ្ជូន {t}",
    viewReportFailedNoSetup: "មិនអាចមើលរបាយការណ៍បានទេ ពីព្រោះមានការចុះបញ្ជីខ្វះនៅក្នុងការកំណត់ការប្រមូលផ្តុំស្តុក។<br/>សូមបញ្ចប់ការកំណត់ទាំងអស់មុន!",
    approvalSubmissionSuccess: "{f} បានដាក់ស្នើសម្រាប់ការអនុម័តដោយជោគជ័យ!",
    closeIncomeStatementSuccess: "ការបិទចំណូលបានបង្កើតចូលក្នុងកំណត់ត្រាដោយជោគជ័យ។ សូមមើលកំណត់ត្រាដែលបានបង្កើតក្នុងក្រុមដែលបានកំណត់។",
    closeIncomeStatementFailed: "កំហុស, បិទការបង្កើតកាសែតប្រាក់ចំណូលបានបរាជ័យ",
    entryEditorSuccess: "ការបញ្ចូលបានអាប់ដេតដោយជោគជ័យ!",
    removeApplyToJournalIdAndAmountToApplyWithId: "លុបកាសែតដែលបានអនុវត្តនៅលើអត្តសញ្ញាណ : {f}",
    removeApplyToJournalIdAndAmountToApplyFailed: "កំហុស, មិនអាចលុប {f} បានទេ។ អត្តសញ្ញាណកាសែតនៅតែមាន។",
    removeApplyToJournalIdAndAmountToApplyErrorFailed: "កំហុស, ការលុបកាសែតមិនបានជោគជ័យ",
    removeApplyToJournalIdAndAmountToApplyErrorCheckJournal: "កំហុស, មិនអាចលុបបានដោយសារកំហុសនៅលើការត្រួតពិនិត្យកាសែត",
    removeApplyToJournalIAndAmountToApplydNotAllowed: "មិនអនុញ្ញាតឱ្យលុបកាសែតដែលបានអនុវត្ត",
    submitSuccess: "{f} បានដាក់ស្នើដោយជោគជ័យ!",
    withdrawDocument: "តើអ្នកប្រាកដថាអ្នកចង់ដកឯកសារទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបាន។",
    adjustAllConfirmation: "តើអ្នកប្រាកដចង់កែសម្រួលវត្ថុទាំងអស់ទេ?<br/>ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    adjustConfirmation: "តើអ្នកប្រាកដចិត្តចង់កែប្រែតែវត្ថុដែលបានតម្រងទេ?<br/>ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    viewReportFailedNoAccountSetup: "មិនអាចមើលរបាយការណ៍បាន។ ត្រូវមានគណនីយ៉ាងហោចណាស់ 1 គណនីនៅក្នុងការកំណត់!",
    defaultDirectExpenseChanged: "ការចំណាយផ្ទាល់លំនាំដើមបានផ្លាស់ប្តូរ",
    overwriteDirectExpenseLineConfirm: "តើអ្នកចង់ជំនួសបន្ទាត់ទាំងអស់ជាមួយលំនាំថ្មីទេ?",
    existingLineRemovalConfirm: "បន្ទាត់ដែលមានស្រាប់នឹងត្រូវបានលុប។ តើអ្នកប្រាកដទេ?",
    undoForceCloseHeader: "បដិសេធការបិទបង្ហាប់ {f}",
    undoForceClose: "តើអ្នកប្រាកដទេថាអ្នកចង់បោះបង់ការបិទឧបករណ៍នេះ?",
    undoForceCloseFailed: "មិនអាចត្រឡប់ក្រោយបានទេ, ធាតុខ្លះមិនទាន់បានបិទទេ!",
    errorEmptyLines: "បន្ទាត់មិនអាចទទេ",
    failedGetSOHForItem: "កំហុស, មិនអាចទទួលបានស្តុកនៅដៃសម្រាប់បន្ទាត់/ធាតុនេះទេ",
    invalidThresholdItems: "- {f1} ({f2}), តម្លៃឯកតា {f3} ជាមួយតម្លៃផ្ទាល់ចុងក្រោយ {f4}",
    filteringWillBeReleased: "លក្ខខណ្ឌត្រងទាំងអស់នឹងត្រូវលុបចេញ ដូច្នេះវត្ថុទាំងអស់នឹងត្រូវដំណើរការ។ តើអ្នកប្រាកដទេ?",
    areYouSure: "តើអ្នកប្រាកដទេ?",
    setToCompletelyReceivedConfirmation: "តើអ្នកប្រាកដថាចង់កំណត់នេះទៅជារក្សាទុកទាំងស្រុង?",
    unsetCompletelyReceivedConfirmation: "តើអ្នកប្រាកដថាចង់លុបចោលការទទួលទាំងស្រុង?",
    confirmAction: "បញ្ជាក់សកម្មភាព",
    areYouSureToAction: "តើអ្នកប្រាកដថាអ្នកចង់ {action} មែនទេ?",
    costsUpdated: "តម្លៃអត្ថបទត្រូវបានអាប់ដេតដោយជោគជ័យ!",
    costsUpdateFailed: "កំហុស, មិនអាចអាប់ដេតតម្លៃធាតុបានទេ។",
    incorrectCostsWarning: "អត្ថបទខាងក្រោមមានតម្លៃឯកតាដែលខុសគ្នាពីតម្លៃស្តុកដែលមាន។ អ្នកអាចបោះបង់ឬអាប់ដេតតម្លៃឯកតាទាំងអស់ដោយស្វ័យប្រវត្តិ។",
    incorrectCostsTitle: "អត្ថបទដែលមានតម្លៃមិនត្រឹមត្រូវ",
    incorrectCostsContinueAnyway: "បន្តទៅទៀត",
    incorrectCostsUpdate: "កែប្រែតម្លៃឯកតា",
    incorrectCostsItemCode: "កូដទំនិញ",
    incorrectCostsLocation: "ទីតាំង",
    incorrectCostsCurrentUnitCost: "តម្លៃឯកតាបច្ចុប្បន្ន",
    incorrectCostsStockOnHandCost: "តម្លៃស្តុកនៅដៃ",
    incorrectCostsDifference: "ភាពខុសគ្នា",
    incorrectCostsStockOnHand: "ស្តុកនៅដៃ",
    confirmDelete: "តើអ្នកប្រាកដទេថាអ្នកចង់លុប {f} នេះ?",
    confirmDeleteMultiple: "តើអ្នកប្រាកដថាចង់លុប {f} ទាំងនេះមែនទេ?",
    setVatFailedNoItemsSelected: "កំហុស, មិនអាចកំណត់ VAT បានទេ។ ត្រូវមានអង្គភាពយ៉ាងហោចណាស់ ១ ធ្វើជាជម្រើសនៅលើតារាង។",
    confirmUpdate: "តើអ្នកប្រាកដទេថាអ្នកចង់អាប់ដេត {f} នេះ?",
    postSelectedConfirmWithCount: "តើអ្នកប្រាកដជាចង់បង្ហោះឯកសារទាំង {v} ទេ?",
    confirmSendEmail: "តើអ្នកប្រាកដចង់ផ្ញើអ៊ីមែលទៅវិក្កយបត្រដែលបានជ្រើសរើសទេ?",
    updatePurchaseOrderStatusConfirmation: "តើអ្នកប្រាកដទេថាអ្នកចង់បម្លែងស្ថានភាពពី '{f1}' ទៅ '{f2}'?",
    updatePurchaseOrderStatusConfirmationWithDoc: "តើអ្នកប្រាកដថាអ្នកចង់ផ្លាស់ប្តូរស្ថានភាពនៃការបញ្ជាទិញ '{f1}' ពី '{f2}' ទៅ '{f3}' ទេ?",
    updateUnitCostVendorComparisonLowestSuccess: "{f} បានធ្វើបច្ចុប្បន្នភាពជាមួយតម្លៃទាបបំផុតដោយប្រើប្រាស់ការប្រៀបធៀបអ្នកផ្គត់ផ្គង់!",
    updateUnitCostVendorComparisonLowestFailed: "កំហុស, មិនអាចអាប់ដេតតម្លៃឯកតាបានដោយប្រើតម្លៃប្រៀបធៀបអ្នកផ្គត់ផ្គង់ (ទាបបំផុត)។",
    successRecalculateInventory: "កំណត់ហេតុសារពើភ័ណ្ឌរាងកាយបានកំណត់ឡើងវិញ!",
    failedRecalculateInventory: "កំហុស, មិនអាចគណនាឡើងវិញបានទេ។",
    revertSuccess: "{f} ត្រូវបានត្រឡប់មកវិញដោយជោគជ័យ!",
    revertFailed: "កំហុស មិនអាចត្រឡប់ {f} បានទេ។",
    dimensionBulkImportSuccess: "{dimensions} ទំហំបានបន្ថែម, {values} តម្លៃបានបន្ថែម",
    coaDimensionBulkImportSuccess: "{mappings} ប៉ារ៉ាម៉ែត្របន្ថែម, {rules} ច្បាប់បន្ថែម",
    updateCoaDimensionMappingConfirmation: "តើអ្នកប្រាកដថាអ្នកចង់ធ្វើបច្ចុប្បន្នភាពផែនទីនេះទេ?",
    downloadFailedActiveFlowIsEmpty: "កំហុស, មិនអាចទាញយកឯកសារនេះបាន។<br/>ដំណើរការឯកសារបច្ចុប្បន្នមិនបានកំណត់ ឬនៅទទេ។",
    calculateInventoryFilterWarning: "បើប្រើតម្រងខាងក្រោម ការគណនាសារពើភ័ណ្ឌនឹងបង្កើតការបញ្ចូលថ្មី ជំនួសការបញ្ចូលដែលមាន។",
    processExpiredWarning: "តើអ្នកប្រាកដថាអ្នកចង់បញ្ចប់ចំណុចចាស់ទេ? ចំណុចដែលចាស់ជាង {x} នឹងត្រូវបានសម្គាល់ថាបញ្ចប់។ សកម្មភាពនេះអាចត្រូវបានត្រឡប់វិញ ប៉ុន្តែត្រូវធ្វើដោយដៃសម្រាប់ចំណុចនីមួយៗ។",
    forceCloseWarning: "តើអ្នកប្រាកដថាអ្នកចង់បិទចូលចាស់ទេ? ចូលទាំងអស់ដែលចាស់ជាង {x} នឹងត្រូវបានបិទយ៉ាងថេរ។ សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។",
    revertExpiredWarning: "តើអ្នកប្រាកដថាអ្នកចង់ត្រឡប់វិញចូលចិត្តដែលបានផុតកំណត់ទេ?",
    addfromReceiptRejected: "{f} បន្ទាត់(ៗ) ត្រូវបានបដិសេធ: {m}",
    postPositiveAdjustmentNotAllowed: "មិនអាចបញ្ចេញបាន៖ ការកែប្រែវិជ្ជមានមិនអនុញ្ញាតសម្រាប់ {f}។",
    postAllBatchHeader: "បោះពុម្ពទាំងអស់ {f} កញ្ចប់",
    deleteAllBatchHeader: "លុបបញ្ជី {f} ទាំងអស់",
    deleteAllBatch: "តើអ្នកប្រាកដថាចង់លុបបន្ទាត់កាសែតទាំងអស់ {f1} នៅក្នុង {f2} {f3} កញ្ចប់ទេ? <br> ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    postAllBatch: "តើអ្នកប្រាកដថាអ្នកចង់បញ្ចេញ {f1} ក្រុម {f2} ដែរឬទេ? ក្រុមនីមួយៗត្រូវបានពិនិត្យមុនពេលបញ្ចេញ; ក្រុមដែលបរាជ័យត្រូវបានរំលង។ <br> ដំណើរការនេះមិនអាចត្រឡប់មកវិញបានទេ។",
    inputQuantityMustBeGreaterThanZero: "ចំនួនត្រូវតែធំជាងសូន្យ។",
  },
  data: {
    clientLedgerEntryId: "លេខសម្គាល់ធាតុចូលអតិថិជន",
    vendorLedgerEntryId: "លេខសម្គាល់ធាតុចូលអ្នកផ្គត់ផ្គង់",
    isReconciled: "តើបានតុល្យភាពរួចហើយឬ?",
    isCloseYearEntry: "តើជាការចុះបញ្ជីបិទឆ្នាំឬ?",
    stockOnHand: "សន្និធិនៅលើដៃ",
    inputStockOnHand: "បញ្ចូលសន្និធិនៅលើដៃ",
    inputStockOnHandFrom: "បញ្ចូលសន្និធិនៅលើដៃ (ពី)",
    inputStockOnHandTo: "បញ្ចូលសន្និធិនៅលើដៃ (ទៅ)",
    stockOnHandFrom: "សន្និធិនៅលើដៃ (ពី)",
    stockOnHandTo: "សន្និធិនៅលើដៃ (ទៅ)",
    reconciliationGlAccount: "គណនី GL លំនាំដើម",
    virtualAccount: "គណនីវើចួល",
    accountName: "ឈ្មោះគណនី",
    accountNameList: "បញ្ជីឈ្មោះគណនី",
    accountNumber: "លេខគណនី",
    bankAccountPostingGroupCode: "កូដក្រុមចុះបញ្ជីគណនីធនាគារ",
    bankAccountPostingGroupName: "ឈ្មោះក្រុមចុះបញ្ជីគណនីធនាគារ",
    reconciliationAccount: "គណនីតុល្យភាព",
    reconciliationBankAccount: "គណនីធនាគារតុល្យភាព",
    isReconciliationAccount: "តើជាគណនីតុល្យភាពឬ?",
    showOppositeSigninReport: "បង្ហាញសញ្ញាផ្ទុយក្នុងរបាយការណ៍",
    setWidenedPhysicalInventoryRow: "កំណត់ជួរសន្និធិរូបវន្តឲ្យទូលាយ",
    itemVendorPurchaseprice: "តម្លៃទិញអ្នកផ្គត់ផ្គង់ទំនិញ",
    startDate: "កាលបរិច្ឆេទចាប់ផ្តើម",
    endDate: "កាលបរិច្ឆេទបញ្ចប់",
    startDateWithPlaceholderDDMMYYYY: "កាលបរិច្ឆេទចាប់ផ្តើម (DD-MM-YYYY)",
    endDateWithPlaceholderDDMMYYYY: "កាលបរិច្ឆេទបញ្ចប់ (DD-MM-YYYY)",
    purchasePrice: "តម្លៃទិញ",
    year: "ឆ្នាំ",
    lastIleId: "លេខសម្គាល់ ILE ចុងក្រោយ",
    inventoryPostingType: "ប្រភេទចុះបញ្ជីសន្និធិ",
    isFlashCostStoreRequisition: "តើជាថ្លៃដើមរហ័សសំណើស្តុកឬ?",
    isFlashCostPurchaseRequisition: "តើជាថ្លៃដើមរហ័សសំណើទិញឬ?",
    requestStatus: "ស្ថានភាពសំណើ",
    receiptStatus: "ស្ថានភាពទទួល",
    created: "បានបង្កើត",
    createdBy: "បង្កើតដោយ",
    createdAt: "បង្កើតនៅ",
    lastModified: "បានកែប្រែចុងក្រោយ",
    lastModifiedBy: "កែប្រែចុងក្រោយដោយ",
    swiftCode: "កូដ SWIFT",
    defaultBank: "គណនីលំនាំដើម",
    destinationName: "គោលដៅ",
    destinationID: "លេខសម្គាល់គោលដៅ",
    department: "នាយកដ្ឋាន",
    clientInfo: "ព័ត៌មានអតិថិជន",
    clientCode: "កូដអតិថិជន",
    clientName: "ឈ្មោះអតិថិជន",
    clientId: "លេខសម្គាល់អតិថិជន",
    guestName: "ឈ្មោះភ្ញៀវ",
    appliedVendorLedgerEntryId: "លេខសម្គាល់ដែលបានអនុវត្ត",
    appliedClientLedgerEntryId: "លេខសម្គាល់ដែលបានអនុវត្ត",
    appliedBankAccountLedgerEntryId: "លេខសម្គាល់ដែលបានអនុវត្ត",
    defaultGuestInhouseAccountId: "គណនីភ្ញៀវស្នាក់នៅលំនាំដើម",
    isReceivedCompletely: "ទទួលបានពេញលេញ",
    termCode: "កូដលក្ខខណ្ឌ",
    termName: "ឈ្មោះលក្ខខណ្ឌ",
    searchBar: "ស្វែងរកអ្វីមួយនៅទីនេះ...",
    netChange: "ការផ្លាស់ប្តូរទាំងស្រុង",
    entry: "ធាតុចូល",
    totalDocument: "ឯកសារសរុប",
    vendorCode: "កូដអ្នកផ្គត់ផ្គង់",
    vendorName: "ឈ្មោះអ្នកផ្គត់ផ្គង់",
    itemCode: "កូដទំនិញ",
    itemName: "ឈ្មោះទំនិញ",
    itemID: "លេខសម្គាល់ទំនិញ",
    itemTypeName: "ឈ្មោះប្រភេទទំនិញ",
    itemTypeID: "លេខសម្គាល់ប្រភេទទំនិញ",
    itemDescription: "ពិពណ៌នាទំនិញ",
    itemUnitCost: "ថ្លៃដើមឯកតាទំនិញ",
    vatAmount: "ចំនួនអាករ VAT",
    autoRecalculateCost: "គណនាថ្លៃដើមឡើងវិញដោយស្វ័យប្រវត្តិ",
    step: "ជំហាន",
    allowMultiple: "អនុញ្ញាតច្រើន",
    posting: "ការចុះបញ្ជី",
    invoice: "វិក្កយបត្រ",
    receipt: "បង្កាន់ដៃទទួល",
    receiptPosting: "ការចុះបញ្ជីបង្កាន់ដៃទទួល",
    order: "បញ្ជាទិញ",
    wording: "ពាក្យសម្រួល",
    defaultName: "ឈ្មោះលំនាំដើម",
    defaultRoleName: "ឈ្មោះតួនាទីលំនាំដើម",
    role: "តួនាទី",
    defaultVatProductPostingGroup: "ក្រុមចុះបញ្ជីផលិតផល VAT លំនាំដើម",
    conversion: "ការបម្លែង",
    email: "អ៊ីមែល",
    accountNo: "លេខគណនី",
    glAccount: "គណនី G/L",
    location: "ទីតាំង",
    offsetLocation: "ទីតាំងបង្វិល",
    defaultFromLocation: "ទីតាំងចេញលំនាំដើម",
    defaultToLocation: "ទីតាំងចូលលំនាំដើម",
    invPostGroup: "ក្រុមចុះបញ្ជីសន្និធិ",
    accountCode: "កូដគណនី",
    interimAccountName: "ឈ្មោះគណនីបណ្តោះអាសន្ន",
    interimAccountNo: "លេខគណនីបណ្តោះអាសន្ន",
    purchaseAccount: "គណនីទិញ",
    accrualInterimAccount: "គណនីបណ្តោះអាសន្ន Acc.",
    inventoryAdjustmentAccount: "គណនីកែសម្រួលសន្និធិ",
    expenseInventoryAdjustmentAccount: "គណនីកែសម្រួលសន្និធិចំណាយ",
    directCostAppliedAccount: "គណនីអនុវត្តថ្លៃដើមផ្ទាល់",
    vatBusPostGroup: "ក្រុមចុះបញ្ជីអាករអាជីវកម្ម",
    vatBusPostGroupCode: "កូដក្រុមចុះបញ្ជីអាករអាជីវកម្ម",
    vatBusPostGroupID: "លេខសម្គាល់ក្រុមចុះបញ្ជីអាករអាជីវកម្ម",
    vatProductPostingGroup: "ក្រុមចុះបញ្ជីផលិតផលអាករ",
    vatProductPostingGroupID: "លេខសម្គាល់ក្រុមចុះបញ្ជីផលិតផលអាករ",
    whtVatProductPostingGroup: "ក្រុមចុះបញ្ជីអាករកាត់ទុក VAT",
    genBusPostGroup: "ក្រុមចុះបញ្ជីអាជីវកម្មទូទៅ",
    genBusPostGroupCode: "កូដក្រុមចុះបញ្ជីអាជីវកម្មទូទៅ",
    genBusPostGroupID: "លេខសម្គាល់ក្រុមចុះបញ្ជីអាជីវកម្មទូទៅ",
    genProdPostGroup: "ក្រុមចុះបញ្ជីផលិតផលទូទៅ",
    genProdPostGroupID: "លេខសម្គាល់ក្រុមចុះបញ្ជីផលិតផលទូទៅ",
    bankAccPostGroup: "ក្រុមចុះបញ្ជីគណនីធនាគារ",
    documentNo: "លេខឯកសារ",
    batch: "កញ្ចប់",
    description: "ពិពណ៌នា",
    postingDate: "កាលបរិច្ឆេទចុះបញ្ជី",
    expectedDate: "កាលបរិច្ឆេទរំពឹងទុក",
    debitAmount: "ចំនួនឥណពន្ធ",
    creditAmount: "ចំនួនឥណទាន",
    amount: "ចំនួន",
    isApplied: "បានអនុវត្ត",
    appliedSalesInvoiceId: "លេខសម្គាល់វិក្កយបត្រលក់ដែលបានអនុវត្ត",
    appliedSalesCreditMemoId: "លេខសម្គាល់កំណត់ត្រាប្រាក់ឥណទានលក់ដែលបានអនុវត្ត",
    cashDeskMovementId: "លេខសម្គាល់ចលនាបេឡា",
    businessRegistrationNumberNew: "លេខចុះបញ្ជីអាជីវកម្ម (ថ្មី)",
    businessActivityDescription: "ការពិពណ៌នាអំពីសកម្មភាពអាជីវកម្ម",
    sstRegistrationNumber: "លេខចុះបញ្ជីពន្ធសេវាកម្ម និងលក់",
    msicCodeNumber: "លេខកូដ MSIC",
    msicDescription: "ការពិពណ៌នាអំពី MSIC",
    no: "មិនមាន",
    code: "កូដ",
    name: "ឈ្មោះ",
    glAccountNo: "លេខគណនី G/L",
    paymentTerm: "ពេលវេលាចំណាយ",
    directExpenseGenBusPostGroup: "ចំណាយផ្ទាល់ Gen.Bus.Post. ក្រុម",
    directExpenseGenProdPostGroup: "ចំណាយផ្ទាល់ ក្រុមផលិតផល",
    directExpenseAdjustmentAccount: "គណនីកែតម្រូវចំណាយផ្ទាល់",
    defaultDirectExpenseGenBusPostGroup: "ក្រុមចំណាយផ្ទាល់លំនាំ",
    custPostGroup: "ក្រុមបញ្ជូនអតិថិជន",
    vendorPostGroup: "ក្រុមបង្ហោះអ្នកលក់",
    journalTemplate: "គំរូកាសែត",
    noSeries: "គ្មានស៊េរី",
    journalTemplateId: "លេខសម្គាល់គំរូកាសែត",
    journalBatchId: "លេខសម្គាល់កញ្ចប់កាសែត",
    revenueLineId: "លេខសម្គាល់បន្ទាត់ប្រាក់ចំណូល",
    defaultLocation: "ទីតាំងលំនាំដើម",
    prefix: "មុន",
    startingNumber: "លេខចាប់ផ្តើម",
    lastNumberUsed: "លេខចុងក្រោយដែលបានប្រើ",
    lengthOfNumber: "ប្រវែងលេខ",
    includeYear: "បញ្ចូលឆ្នាំ",
    includeMonth: "រួមបញ្ចូលខែ",
    includeDate: "រួមបញ្ចូលកាលបរិច្ឆេទ",
    isEditable: "អាចកែប្រែបាន",
    branch: "សាខា",
    bankAccountNo: "លេខគណនីធនាគារ",
    virtualAccountNo: "លេខគណនីវីរុស",
    allowPostingFrom: "អនុញ្ញាតឱ្យបញ្ចេញពី",
    allowPostingTo: "អនុញ្ញាតឱ្យបញ្ចេញទៅ",
    receivableAccount: "គណនីដែលអាចទទួលបាន",
    receivableAccountNo: "លេខគណនីទទួលប្រាក់",
    payableAccount: "គណនីដែលត្រូវបង់",
    balanceAccount: "គណនីសមតុល្យ",
    accountCategory: "ប្រភេទគណនី",
    accountType: "ប្រភេទគណនី",
    directPost: "ផុសដោយផ្ទាល់",
    blocked: "បានបិទ",
    vatPercentage: "ភាគរយ VAT",
    startingDate: "កាលបរិច្ឆេទចាប់ផ្តើម",
    closed: "បិទ",
    endingDate: "ថ្ងៃបញ្ចប់",
    dueDateCalc: "កំណត់ថ្ងៃផុតកំណត់",
    address: "អាសយដ្ឋាន",
    city: "ទីក្រុង",
    country: "ប្រទេស",
    phoneNo: "លេខទូរស័ព្ទ",
    contactName: "ឈ្មោះអ្នកទំនាក់ទំនង",
    unit: "ឯកតា",
    costingMethod: "វិធីគណនាហិរញ្ញវត្ថុ",
    unitCost: "តម្លៃឯកតា",
    baseUnitCost: "តម្លៃឯកតាមូលដ្ឋាន",
    inputUnitCost: "ចំណាយឯកតា",
    lastDirectCost: "ចំណាយផ្ទាល់ចុងក្រោយ",
    reorderQuantity: "បរិមាណបញ្ជាទិញឡើងវិញ",
    totalling: "សរុប",
    totallingFrom: "សរុបពី",
    totallingTo: "សរុបទៅ",
    directPosting: "ការបង្ហោះដោយផ្ទាល់",
    batchName: "ឈ្មោះក្រុម",
    lineNo: "លេខបន្ទាត់",
    inventory: "សារពើភ័ណ្ឌ",
    vendorAccount: "គណនីអ្នកផ្គត់ផ្គង់",
    clientAccount: "គណនីអតិថិជន",
    totalAmount: "ចំនួនសរុប",
    selectedTotalAmount: "ចំនួនសរុបដែលបានជ្រើសរើស",
    status: "ស្ថានភាព",
    purchasingStatus: "ស្ថានភាពការទិញ",
    quantity: "ចំនួន",
    value: "តម្លៃ",
    inputQuantity: "បញ្ចូលបរិមាណ",
    inputUom: "ឯកតារង្វាស់បញ្ចូល",
    forceCloseReason: "មូលហេតុនៃការបិទដោយបង្ខំ",
    unitPrice: "តម្លៃឯកតា",
    totalPrice: "តម្លៃសរុប",
    closedByUser: "បិទដោយអ្នកប្រើ",
    includeAutoClosed: "រួមបញ្ចូលការបិទស្វ័យប្រវត្តិ",
    baseQuantity: "បរិមាណមូលដ្ឋាន",
    id: "អត្តសញ្ញាណលេខ",
    orderDate: "កាលបរិច្ឆេទបញ្ជាទិញ",
    amountIncVat: "ចំនួនរួម VAT",
    amountExcVat: "ចំនួនមិនរាប់VAT",
    unitCostIncVat: "តម្លៃឯកតា រួមជាមួយ VAT",
    itemNo: "លេខទំនិញ",
    purchaseRequestNo: "លេខ PR",
    purchaseOrderNo: "លេខ PO",
    deliveryDate: "កាលបរិច្ឆេទដឹកជញ្ជូន",
    quantityOutstanding: "ចំនួននៅសល់",
    type: "វាយ",
    balance: "សមតុល្យ",
    balanceToDate: "សមតុល្យដល់ថ្ងៃ",
    subTotal: "សរុបរង",
    vat: "អាករ VAT",
    totalIncVat: "សរុប រួមជាមួយ VAT",
    vendorDeliveryNo: "លេខដឹកជញ្ជូនអ្នកផ្គត់ផ្គង់",
    poNo: "លេខ PO",
    salesTaxAccount: "គណនីពន្ធលក់",
    purchaseTaxAccount: "គណនីពន្ធទិញ",
    total: "សរុប",
    totalRows: "ចំនួនជួរ:",
    purchaseRequestSeries: "សំណើរការទិញ",
    purchaseOrderSeries: "ស៊េរីការទិញកម្មវិធី",
    purchaseReceiptSeries: "ស៊េរីវិក្កយបត្រ",
    purchaseInvoiceSeries: "ស៊េរីវិក្កយបត្រ​ទិញ",
    purchaseInvoiceLabel: "ស្លាកវិក្កយបត្រ​ទិញ",
    purchaseReceiptLabel: "ស្លាកវិក្កយបត្រ​ទិញ",
    purchaseCreditMemoSeries: "ទិញសេរ៉ីឥណទាន",
    salesInvoiceSeries: "ស៊េរីវិក្កយបត្រ",
    salesCreditMemoSeries: "ស៊េរីឥណទានលក់",
    receivableInvoiceSeries: "ស៊េរីវិក្កយបត្រ",
    symbol: "សញ្ញា",
    transferOrderSeries: "បញ្ជាទិញផ្ទេរ",
    defaultCostingMethod: "វិធីកំណត់ថ្លៃដើម",
    quantityReceived: "ចំនួនដែលទទួលបាន",
    quantityInvoiced: "ចំនួនដែលបានវិក័យប័ត្រ",
    quantityPO: "ចំនួនដែលបានបញ្ជាទិញ",
    quantityToReceive: "ចំនួនដែលត្រូវទទួល",
    quantityOrdered: "ចំនួនដែលបានបញ្ជាទិញ",
    purchaseReceivingList: "បញ្ជីប្រវត្តិវិក្កយបត្រ​ការទិញ",
    quantityToInvoice: "បរិមាណសម្រាប់វិក័យប័ត្រ",
    prNumber: "លេខសំណើរការទិញ",
    vendorOneName: "អ្នកផ្គត់ផ្គង់ ១",
    vendorOnePrice: "តម្លៃ ១",
    vendorTwoName: "អ្នកផ្គត់ផ្គង់ ២",
    vendorTwoPrice: "តម្លៃ ២",
    vendorThreeName: "អ្នកផ្គត់ផ្គង់ ៣",
    vendorThreePrice: "តម្លៃ ៣",
    showVendorColumns: "បង្ហាញជួរប្រៀបធៀបអ្នកផ្គត់ផ្គង់",
    showVendorDetail: "បង្ហាញអ្នកផ្គត់ផ្គង់",
    showSOHByInputUOM: "បង្ហាញស្តុកនៅដៃតាមអង្គភាពវាស់បញ្ចូល",
    showByInputUOM: "បង្ហាញតាមអង្គភាពវាស់បញ្ចូល",
    expirationDate: "កាលបរិច្ឆេទផុតកំណត់",
    vendorInvoiceNo: "លេខវិក្កយបត្រ​អ្នកផ្គត់ផ្គង់",
    receiptNo: "លេខបញ្ជាក់",
    invoiceNo: "លេខវិក្កយបត្រ",
    sourcePurchaseInvoice: "វិកយបត្រទិញប្រភព",
    targetPurchaseInvoice: "វិកយបត្រទិញគោលដៅ",
    movePreview: "មើលសាកល្បងការផ្លាស់ទី",
    from: "ពី",
    to: "ទៅ",
    dueDate: "កាលបរិច្ឆេទផុតកំណត់",
    documentFlow: "ចរន្តឯកសារសកម្ម",
    receivableInvoiceDocumentFlow: "ឯកសារការទូទាត់ដែលអាចទទួលបាន",
    quantityToBeReceive: "នៅសល់ដើម្បីទទួល",
    detail: "ព័ត៌មានលម្អិត",
    purchaseRequisitionTemplate: "គំរូសំណើរការទិញ",
    entryType: "ប្រភេទការបញ្ចូល",
    documentType: "ប្រភេទឯកសារ",
    invoicedQuantity: "បរិមាណដែលបានវិក័យប័ត្រ",
    ileQuantity: "បរិមាណ ILE",
    ileBaseQuantity: "បរិមាណមូលដ្ឋាន ILE",
    remainingQuantity: "ចំនួននៅសល់",
    remainingQuantityToInvoice: "នៅសល់សម្រាប់វិក័យប័ត្រ",
    outboundIle: "ILE ចេញ",
    inboundIle: "ILE ចូល",
    costAmountExpected: "ចំនួនថ្លៃដែលរំពឹងទុក",
    costAmountActual: "ចំនួនថ្លៃពិត",
    valuationDate: "កាលបរិច្ឆេទវាយតម្លៃ",
    averageCostEntryType: "ប្រភេទចំណាយមធ្យម",
    glRegisterId: "អត្តសញ្ញាណចុះឈ្មោះ GL",
    reconciledGlRegisterId: "បានសម្របសម្រួលដោយលេខសម្គាល់ GL",
    isAdjustment: "ការកែសម្រួល",
    valuedQuantity: "ចំនួនដែលមានតម្លៃ",
    applyToEntry: "អនុវត្តទៅលេខចូល",
    fixedApply: "អនុវត្តជាប់",
    sourceDocumentNo: "លេខឯកសារប្រភព",
    sourceIdtDocumentNo: "លេខឯកសារ IDT ប្រភព",
    removeApplyToJournalIdAndAmountToApply: "លុបកាសែតដែលបានអនុវត្ត",
    applyToJournalIdAndAmountToApply: "ដាក់ពាក្យសុំលេខកូដកាសែត និងចំនួនដាក់ពាក្យសុំ",
    applyToJournalId: "អនុវត្តទៅកាន់លេខសម្គាល់កាសែត",
    amountToApply: "ចំនួនដើម្បីអនុវត្ត",
    applied: "បានអនុវត្ត",
    invoiceDate: "កាលបរិច្ឆេទវិក្កយបត្រ",
    remainingAmount: "ចំនួននៅសល់",
    remainingAmountIncVat: "ចំនួននៅសល់ រួមជាមួយ VAT",
    unapplied: "មិនបានអនុវត្ត",
    unappliedById: "មិនបានអនុវត្តដោយអត្តសញ្ញាណ",
    currencyCode: "កូដរូបិយប័ណ្ណ",
    reversed: "ត្រឡប់",
    reversedBy: "ត្រូវបានបង្វិលដោយ",
    open: "បើក",
    vendorInfo: "ព័ត៌មានអ្នកផ្គត់ផ្គង់",
    itemNotOnInventory: "វត្ថុមិនមាននៅក្នុងស្តុក",
    dateFilterStart: "កាលបរិច្ឆេទចាប់ផ្តើម",
    dateFilterEnd: "ថ្ងៃបញ្ចប់",
    dateFilter: "កាលបរិច្ឆេទតម្រង",
    locationFilter: "ការតម្រងទីតាំង",
    batchFilter: "ច្រកចេញក្រុម",
    itemFilter: "ច្រាសធាតុ",
    quantityPhysicalInventory: "ចំនួន (ស្តុករាងកាយ)",
    quantityCalculated: "ចំនួន (គណនាឡើង)",
    documentDate: "កាលបរិច្ឆេទឯកសារ",
    requestByUser: "ស្នើសុំដោយ",
    fromLocation: "ពី",
    toLocation: "ទៅ",
    postingUser: "បង្ហោះដោយ",
    posted: "បានបង្ហោះ",
    isPosted: "បានបង្ហោះ",
    quantityShipped: "បរិមាណដែលបានផ្ញើ",
    baseQuantityShipped: "ចំនួនគ្រឿងដែលបានដឹកជញ្ជូន",
    locationCode: "កូដទីតាំង",
    locationName: "ឈ្មោះទីតាំង",
    chartOfAccountDetail: "តារាងព័ត៌មានគណនី",
    taxType: "ប្រភេទពន្ធ",
    notAvailable: "មិនមាន",
    notApplicable: "មិនអាចប្រើបាន",
    appliesToPostedSalesInvoiceId: "លេខសម្គាល់វិក្កយបត្រលក់ដែលបានអនុវត្ត",
    appliesToPostedPurchaseInvoiceId: "លេខអត្តសញ្ញាណវិក្កយបត្រ​ដែលបានអនុវត្ត",
    appliesToPostedSalesCreditMemoId: "អត្តសញ្ញាណកំណត់ឥណទានលក់ដែលអនុវត្ត",
    isForceClosed: "បិទបង្ខំ",
    monthClosed: "បិទខែ",
    yearClosed: "ឆ្នាំបិទ",
    inventoryClosed: "ស្តុកបានបិទ",
    createYear: "កំណត់សម្រាប់មួយឆ្នាំ",
    includeIncome: "បញ្ចូលការបញ្ចប់ចូល",
    retainedEarningAccount: "គណនីប្រាក់ចំណេញរក្សាទុក",
    closeIncomeStatementJournalBatch: "បិទកំណត់ត្រាថ្លៃចំណូល",
    witholdingTaxDefaultJournalBatch: "កំណត់បញ្ជីករណីពន្ធកាត់បន្ថយ",
    showQuantityCalculated: "បង្ហាញជួរឈរ បរិមាណ (គណនា)",
    showQuantityAdjusted: "បង្ហាញជួរឈរ បរិមាណ (កែប្រែ)",
    showAgedColumn: "បង្ហាញជួរពេលវេលា",
    showAgingDays: "បង្ហាញថ្ងៃចាស់",
    coaApInterim: "COA AP អន្តរាគមន៍",
    originalQuantity: "បរិមាណដើម",
    splitQuantity: "ចំនួនដែលត្រូវបែងចែក",
    appliesToInvoiceNo: "អនុវត្តទៅវិក្កយបត្រទិញដែលបានបង្ហោះ",
    appliesToSalesInvoiceNo: "អនុវត្តទៅវិក័យប័ត្រ​លក់​ដែលបានបង្ហោះ",
    vendorId: "លេខសម្គាល់អ្នកផ្គត់ផ្គង់",
    itemJournalMasterTemplate: "គំរូមាស្ទ័រនៃកាសែតទំនិញ",
    generalJournalMasterTemplate: "គំរូមាសសៀវភៅទូទៅ",
    checkIn: "ចុះឈ្មោះ",
    checkOut: "ចេញពីការទិញ",
    night: "រាត្រី",
    roomNo: "លេខបន្ទប់",
    receivableInvoiceFooter: "ជួរដើមវិក្កយបត្រ",
    receivableInvoiceHeader: "ក្បាលវិក្កយបត្រ​ទទួលប្រាក់",
    allowBiggerQuantityInPurchaseOrder: "អនុញ្ញាតអង្គភាពធំក្នុងការបញ្ជាទិញ",
    defaultPrintPOGroupLocation: "តម្លៃលំនាំត្រូវបានក្រុមតាមទីតាំងពេលបោះពុម្ពការបញ្ជាទិញ",
    footerAutoColumn: "ជួរដេកអូតូ",
    allowAddNewItemInPOFromPR: "អនុញ្ញាតឲ្យបន្ថែមធាតុថ្មីក្នុងPOពីPR",
    allowFlexibleItemInPO: "អនុញ្ញាតឱ្យមានភាពបត់បែនក្នុងអត្ថបទ PO (ដៃ និងអត្ថបទ PR)",
    allowChangePriceWhenPOIsReleased: "អនុញ្ញាតឱ្យប្តូរប្រាក់នៅពេល PO ត្រូវបានចេញផ្សាយ",
    useCompanyNameForPrintout: "ប្រើឈ្មោះក្រុមហ៊ុនតាមច្បាប់នៅក្បាលការបោះពុម្ព",
    useBrandHotelNameForPrintout: "ប្រើឈ្មោះសណ្ឋាគារលើក្បាលព្រីន",
    purchaseOrderFooter: "ជើងក្រោមការបញ្ជាទិញ",
    customFooterPurchaseOrderText: "អត្ថបទជំពូកការបញ្ជាទិញផ្ទាល់ខ្លួន",
    customFooterPurchaseRequestText: "អត្ថបទជំពូកការស្នើសុំទិញផ្ទាល់ខ្លួន",
    customFooterPurchaseInvoiceText: "អត្ថបទជំពូកវិក័យប័ត្រទិញផ្ទាល់ខ្លួន",
    customFooterPurchaseReceiptText: "អត្ថបទជំពូកវិក័យប័ត្រទទួលទិញផ្ទាល់ខ្លួន",
    customFooterStoreRequisitionText: "អត្ថបទជំពូកការស្នើសុំហាងផ្ទាល់ខ្លួន",
    lastPrice: "តម្លៃចុងក្រោយ",
    baseLastPrice: "តម្លៃចុងក្រោយមូលដ្ឋាន",
    isFreeOfCharge: "ឥតគិតថ្លៃ",
    defaultFOCashDesk: "កន្លែងប្រាក់ FO ដើម",
    defaultFOCollectionType: "ប្រភេទប្រមូល FO ដើម",
    documentTitle: "ចំណងជើងឯកសារ",
    startPostingDate: "កាលបរិច្ឆេទចាប់ផ្តើមបោះពុម្ព",
    endPostingDate: "ថ្ងៃបញ្ចប់ការបង្ហោះ",
    allVendors: "អ្នកផ្គត់ផ្គង់ទាំងអស់",
    allGroups: "ក្រុមទាំងអស់",
    inventoryGroup: "ក្រុមស្តុក",
    noteCurrency: "កំណត់ចំណាំ: សាច់ប្រាក់ដែលប្រើនៅក្នុងរបាយការណ៍នេះគឺ {f}",
    otaBookingId: "លេខសម្គាល់ការកក់ OTA",
    otaBookingClientPostingGroup: "ក្រុមបង្ហោះអតិថិជនសម្រាប់បង្ហាញលេខសម្គាល់ការកក់ OTA",
    show: "បង្ហាញ",
    all: "ទាំងអស់",
    fromAccount: "ពីគណនី",
    toAccount: "ទៅគណនី",
    noteAccountFromTo: "កំណត់ចំណាំ: របាយការណ៍នេះនឹងត្រូវបានចម្រាញ់ពីគណនី <strong>{f1}</strong> ដល់ <strong>{f2}</strong>",
    showDetail: "បង្ហាញព័ត៌មានលម្អិត",
    showAllAccounts: "បង្ហាញគណនីទាំងអស់",
    agedAsOfThisDate: "អាយុតាមកាលបរិច្ឆេទនេះ",
    grandTotal: "សរុបធំ",
    receivableNo: "លេខទទួលបាន",
    showAllClients: "បង្ហាញអតិថិជនទាំងអស់",
    copiedToClipboard: "ចម្លងទៅកាន់ក្តារប្រកាស!",
    sortOrder: "លំដាប់តម្រៀប",
    setAppliesTo: "កំណត់អនុវត្តសម្រាប់: {f}",
    date: "កាលបរិច្ឆេទ",
    hotelName: "ឈ្មោះសណ្ឋាគារ",
    source: "ប្រភព",
    days130: "១-៣០ ថ្ងៃ",
    days3160: "៣១-៦០ ថ្ងៃ",
    days6190: "៦១-៩០ ថ្ងៃ",
    days91120: "៩១-១២០ ថ្ងៃ",
    days120: ">១២០ ថ្ងៃ",
    periodLabel: "{d1} ទៅ {d2}",
    downloadGSheet: "ទាញយក GSheet",
    downloadExcel: "ទាញយក Excel",
    downloadPDF: "ទាញយក PDF",
    report: "របាយការណ៍",
    period: "រយៈពេល",
    group: "ក្រុម",
    totalCost: "តម្លៃសរុប",
    totalCostAdjust: "កំណត់ថ្លៃសរុប",
    totalAdjustment: "សរុបការកែប្រែ",
    lineStatus: "ស្ថានភាពបន្ទាត់",
    useSystematicApproval: "ប្រើការអនុម័តប្រព័ន្ធ",
    itemType: "ប្រភេទទំនិញ",
    article: "មុខម្ហូប",
    articleType: "ប្រភេទមុខម្ហូប",
    baseSellingPrice: "តម្លៃលក់មូលដ្ឋាន",
    costPercentage: "ថ្លៃដើម %",
    headerNoSeries: "លេខស៊េរីក្បាល",
    lineNoSeries: "លេខស៊េរីបន្ទាត់",
    lineDocumentNo: "លេខឯកសារបន្ទាត់",
    outlet: "ហាង",
    setDefaultDirectExpense: "កំណត់ចំណាយផ្ទាល់ដើម",
    notesOrReason: "កំណត់ចំណាំ / មូលហេតុ",
    user: "អ្នកប្រើប្រាស់",
    approved: "អនុម័ត",
    rejected: "បដិសេធ",
    declined: "បដិសេធ",
    preparedBy: "រៀបចំដោយ",
    checkedBy: "បានពិនិត្យដោយ",
    approvedBy: "អនុម័តដោយ",
    approverName: "ឈ្មោះអ្នកអនុម័ត",
    sequence: "លំដាប់",
    flowOrder: "បញ្ជាទិញចរន្ត",
    priority: "កំណត់អាទិភាព",
    defaultPurchaseRequestPriority: "កម្រិតអាទិភាពសំណើទិញលំនាំដើម",
    defaultDirectExpenseItemJournalBatch: "កញ្ចប់កំណត់ហេតុចំណាយផ្ទាល់",
    earliest: "ដំបូងបំផុត",
    latest: "ថ្មីៗ",
    showSummary: "បង្ហាញសង្ខេប",
    delegatedTo: "ផ្តល់អំណាចទៅ",
    footerText: "អត្ថបទជើងក្រោម",
    formattingNotes: "ស្លាកបែបផែនទាំងនេះអាចអនុវត្តបានតែសម្រាប់ជួរៗនីមួយៗ: *ក្លែងក្លាយ* _អក្សរបត់_",
    showHotelLogo: "បង្ហាញឡូហូសណ្ឋាគារ",
    showHotelAddress: "បង្ហាញអាសយដ្ឋានសណ្ឋាគារ",
    food: "ម្ហូប",
    beverage: "ភេសជ្ជៈ",
    material: "សម្ភារៈ",
    engineering: "វិស្វកម្ម",
    showEngineering: "បង្ហាញគណនីវិស្វកម្មនៅក្នុងផ្ទាំងបំបែក",
    coaID: "អត្តសញ្ញាណ COA",
    addAccount: "បន្ថែមគណនី",
    selectAccountName: "ជ្រើសរើសឈ្មោះគណនី",
    selectDimensionValue: "ជ្រើសរើសតម្លៃវិមាត្រ",
    restore: "កំណត់ឡើងវិញ",
    setToNonDirectExpense: "កំណត់ទៅចំណាយមិនផ្ទាល់",
    includeApprovalNotes: "បញ្ចូលកំណត់ចំណាំអនុម័ត",
    reviewedBy: "ពិនិត្យដោយ",
    reviewedAt: "បានពិនិត្យនៅ",
    delegatedAt: "បានផ្តល់អំណាចនៅ",
    delegatedFrom: "បានអនុញ្ញាតពី",
    isOpen: "បើកស្រាប់",
    showAllItems: "បង្ហាញទាំងអស់",
    hideUnopenedItems: "លាក់ធាតុដែលមិនបានបើក",
    summaryByLocation: "សេចក្តីសង្ខេបតាមទីតាំង",
    showAllBanks: "បង្ហាញធនាគារទាំងអស់",
    splitVendorDescription: "បំបែកការពិពណ៌នាអ្នកផ្គត់ផ្គង់",
    creditAccount: "គណនីឥណទាន",
    debitAccount: "គណនីឥណទាន",
    totalCredit: "សរុបឥណទាន",
    totalDebit: "សរុបឥណទាន",
    totalLedger: "សរុបកំណត់ហេតុ",
    totalPayment: "សរុបការទូទាត់",
    summary: "សង្ខេប",
    hideAmountInPurchaseRequestPrintout: "លាក់ចំនួនក្នុងការស្នើសុំទិញ",
    showTotalCostInPurchaseRequestPrintVendorComparison: "បង្ហាញថ្លៃសរុបក្នុងការស្នើសុំទិញ ប្រៀបធៀបអ្នកផ្គត់ផ្គង់",
    enableDescriptionCopyToRemark: "អនុញ្ញាតឲ្យចម្លងការពិពណ៌នាទៅកាន់កំណត់សម្គាល់នៅលើការស្នើសុំទិញ",
    allowSOHZeroWhenStoreRequisitionIsSaved: "អនុញ្ញាត SOH សូន្យ នៅពេលដែលការទាមទារម៉ាស៊ីនត្រូវបានរក្សាទុក",
    allowRequestedQtyBiggerThanSoh: "អនុញ្ញាតឱ្យបរិមាណដែលបានស្នើសុំធំជាង SOH",
    useLastDirectCostWhenNoContract: "ប្រើតម្លៃចំណាយចុងក្រោយពេលមិនមានតម្លៃកិច្ចសន្យា",
    useLastDirectCostWhenNoContractNote: "ពេលកំណត់អ្នកផ្គត់ផ្គង់ក្នុងការស្នើរសុំទិញដែលមិនមានតម្លៃកិច្ចសន្យា សូមប្តូរព័ត៌មានដែលអ្នកប្រើបញ្ចូល និងប្រើតម្លៃផ្ទាល់ចុងក្រោយ (នេះគឺត្រូវបានអនុវត្តសម្រាប់ការបញ្ជាទិញ)",
    itemCodeGeneratedBySystem: "កូដធាតុត្រូវបានបង្កើតដោយប្រព័ន្ធ",
    mdrFee: "អត្រាបញ្ចុះតម្លៃអ្នកជួញដូរ {f} (%)",
    batchHasMdrFee: "កញ្ចប់ <strong>{f}</strong> មានជម្រើសអត្រាបញ្ចុះតម្លៃពាណិជ្ជកម្ម៖",
    showZeroBalance: "បង្ហាញតុល្យភាពសូន្យ",
    targetEntry: "ចូលដំណើរការ",
    approvalPrintout: "ការបោះពុម្ពអនុម័ត",
    document: "ឯកសារ",
    outstanding: "ល្អឥតខ្ចោះ",
    documentsSelected: "ឯកសារដែលបានជ្រើសរើស",
    documentSelected: "ឯកសារត្រូវបានជ្រើសរើស",
    defaultVendorSetup: "ការកំណត់លំនាំសម្រាប់អ្នកផ្គត់ផ្គង់",
    defaultClientSetup: "ការកំណត់លំនាំសម្រាប់អតិថិជន",
    defaultItemSetup: "ការកំណត់លំនាំសម្រាប់ធាតុ",
    noVat: "គ្មាន VAT",
    purchaseOrderDocumentFlow: "ចរាចរណ៍ឯកសារការបញ្ជាទិញ",
    dailyMarketListDocumentFlow: "បញ្ជីទីផ្សារប្រចាំថ្ងៃ",
    remark: "កំណត់សម្គាល់",
    deleteRemark: "លុបកំណត់ចំណាំ",
    taxIdentificationNumber: "លេខសម្គាល់ពន្ធ",
    attachment: "ភ្ជាប់",
    fileFormat: "ទ្រង់ទ្រាយឯកសារ",
    adjustAllItems: "កំណត់ធាតុទាំងអស់",
    adjustFilteredItems: "កំណត់អត្ថបទដែលបានតម្រូវ",
    adjustItem: "កែប្រែធាតុ",
    showItemDetail: "បង្ហាញអត្ថបទ",
    showClientDetail: "បង្ហាញអតិថិជន",
    showPurchaseBook: "បង្ហាញសៀវភៅទិញ",
    queryDate: "កាលបរិច្ឆេទសំណួរ",
    queryAdjustmentDate: "កាលបរិច្ឆេទសំណួរ និងកែប្រែ",
    adjustmentPostingDate: "កាលបរិច្ឆេទបញ្ចូលកែប្រែ",
    valueEntryID: "លេខសម្គាល់ការបញ្ចូលតម្លៃ",
    costAmountAdjustment: "កំណត់ប្រាក់ចំណាយ",
    viewData: "មើលទិន្នន័យ",
    ileID: "អត្តសញ្ញាណ ILE",
    lastValueEntryID: "លេខសម្គាល់ចូលតម្លៃចុងក្រោយ",
    unitCostThreshold: "កម្រិតថ្លៃដើម",
    unitCostThresholdUsingLastDirectCost: "កម្រិតថ្លៃដើមប្រើថ្លៃដើមចុងក្រោយ",
    minUnitCost: "តម្លៃអប្បបរមា (%)",
    maxUnitCost: "តម្លៃអង្គភាពអតិបរមា (%)",
    isReversed: "ត្រូវបានត្រឡប់",
    reversedPostingDate: "កាលបរិច្ឆេទបញ្ចូលត្រឡប់",
    descriptionForVendor: "ការពិពណ៌នា (សម្រាប់អ្នកលក់)",
    remarkInternalOnly: "កំណត់សម្គាល់ការទិញ (សម្រាប់ប្រើប្រាស់ក្នុងស្ថាប័នប៉ុណ្ណោះ)",
    remarkInternalNoteForPurchasingOnly: "ចំណាំ (កំណត់សម្គាល់សម្រាប់ការទិញប៉ុណ្ណោះ)",
    isDirectExpense: "ចំណាយផ្ទាល់",
    isDML: "ជាដំណោះស្រាយ DML",
    inputUOMID: "បញ្ចូលលេខសម្គាល់ UoM",
    inputUOMCode: "កូដ UoM បញ្ចូល",
    inputUOMName: "បញ្ចូលឈ្មោះUoM",
    transferOrder: "បញ្ជាទិញផ្ទេរ",
    negativeAdjustment: "កំណែប្រែអវិជ្ជមាន",
    quantityEqualZero: "ចំនួន = ០",
    quantityGreaterThanZero: "ចំនួន > ០",
    costNegative: "ថ្លៃអវិជ្ជមាន",
    groupByLocation: "ក្រុមតាមទីតាំង",
    groupByVendor: "ច្រៀងតាមអ្នកផ្គត់ផ្គង់",
    showAllARCard: "បង្ហាញកាត A/R ទាំងអស់",
    setToCompletelyReceived: "កំណត់ជាស្រេចទាំងស្រុង",
    unsetCompletelyReceived: "លុបចោលបានទាំងស្រុង",
    defaultChartOfAccount: "គណនីលំនាំដើម",
    defaultCOAAmount: "ចំនួន COA ដើម",
    defaultDescription: "ការពិពណ៌នាមានលំនាំ",
    salesInvoiceNumberSeries: "លេខវិក្កយបត្រលក់",
    invoiceHeaderAddress: "អាសយដ្ឋានក្បាលវិក្កយបត្រ",
    openingInventory: "បើកស្តុក",
    incomingInventory: "សារពើភ័ណ្ឌមកដល់",
    closingInventory: "បិទស្តុក",
    inventoryAvailable: "ស្តុកមាន",
    grossConsumption: "ការបរិភោគសរុប",
    creditsConsumption: "ឥណទាន - ការប្រើប្រាស់",
    creditsComplimentaryCost: "កិច្ចសន្យា - ថ្លៃឈ្នួលឥតគិតថ្លៃ",
    creditsInterDepartmentTransfer: "ក្របខ័ណ្ឌ - ការផ្ទេរប្រាក់អន្តរប្រភេទ",
    otherAdjustment: "ការកែសម្រួលផ្សេងទៀត",
    netConsumption: "ការប្រើប្រាស់សុទ្ធ",
    netBeverageSales: "លក់ភេសជ្ជៈសុទ្ធ",
    netFoodSales: "លក់អាហារសុទ្ធ",
    costOfSales: "តម្លៃលក់",
    debitCost: "ថ្លៃដេបិត",
    generalSetup: "ការកំណត់ទូទៅ",
    onlyShowSameQuantity: "បង្ហាញតែបរិមាណដូចគ្នា",
    excludedHotel: "សណ្ឋាគារដែលបានច្រានចោល",
    idExcludedAutomatically: "អត្តសញ្ញាណខាងក្រោម {item} ត្រូវបានច្រានចោលដោយស្វ័យប្រវត្តិ",
    ileDocumentNo: "លេខឯកសារ ILE",
    adjust: "កំណត់",
    importFromExcel: "នាំចូលពី Excel",
    chooseFile: "ជ្រើសឯកសារ",
    previewData: "មើលមុនទិន្នន័យ",
    adjustingPleaseWait: "កំពុងកែប្រែ សូមរង់ចាំ...",
    showCoaDestination: "បង្ហាញទីតាំង COA",
    defaultPrintShowCoaDestination: "កំណត់បោះពុម្ពបង្ហាញគោលដៅ COA",
    directExpense: "ចំណាយផ្ទាល់",
    movementType: "ប្រភេទចលនា",
    excelFile: "ឯកសារ Excel",
    businessRegistrationNumber: "លេខចុះឈ្មោះអាជីវកម្ម",
    appliedInMalaysia: "កំពុងអនុវត្តនៅម៉ាឡេស៊ី",
    inventoryAvailableFormula: "បើក + មក + បង់",
    grossConsumptionFormula: "មាន - បិទ",
    otherAdjustmentFormula: "ការប្រើប្រាស់សរុប - ថ្លៃឈ្នួលឥតគិតថ្លៃ - អន្តរេនដេប៉ាតមិន",
    journalDetail: "ព័ត៌មានលម្អិតសៀវភៅកំណត់ហេតុ",
    sohDate: "កាលបរិច្ឆេទ SOH",
    revaluationJournal: "កំណត់ហេតុការវាយតម្លៃ",
    revaluateCost: "វាយតម្លៃឡើងវិញ",
    purchaseCost: "ថ្លៃទិញ",
    getPurchaseCost: "ទិញថ្លៃ",
    valueEntriesToAdjust: "ចំនួនតម្លៃដើម្បីកែប្រែ",
    getValueEntriesToAdjust: "ទទួលបានចំនួនតម្លៃដើម្បីកែប្រែ",
    processAdjustment: "កែប្រែដំណើរការ",
    updateUnitCost: "អាប់ដេតថ្លៃឯកតា",
    unitCostPurchase: "តម្លៃឯកតាដែលទិញ",
    expectedTotalCost: "ចំណាយសរុបដែលរំពឹងទុក",
    currentTotalCost: "តម្លៃសរុបបច្ចុប្បន្ន",
    currentUnitCost: "តម្លៃឯកតាបច្ចុប្បន្ន",
    purchaseUnitCost: "តម្លៃឯកតាទិញ",
    diffUnitCost: "តម្លៃឯកតាដែលខុសគ្នា",
    locationID: "អត្តសញ្ញាណទីតាំង",
    minimumCostDifference: "ភាពខុសគ្នានៃថ្លៃដើមអប្បបរមា",
    showInvoiceTaxBreakdown: "បង្ហាញការបំបែកពន្ធវិក្កយបត្រ",
    documentStartDate: "កាលបរិច្ឆេទចាប់ផ្តើមឯកសារ",
    documentEndDate: "ថ្ងៃចប់ឯកសារ",
    beginning: "ចាប់ផ្តើម",
    beginningQty: "ចំនួនដំបូង",
    beginningValue: "តម្លៃដំបូង",
    incomingQty: "ចំនួនចូល",
    outgoingQty: "ចំនួនចេញ",
    endingQty: "ចំនួនបញ្ចប់",
    endingValue: "តម្លៃបញ្ចប់",
    averagePrice: "តម្លៃមធ្យម",
    changeAppliedSalesInvoiceID: "ប្តូរលេខសំគាល់វិក្កយបត្រលក់",
    currentAppliedSalesInvoiceID: "លេខសម្គាល់វិក្កយបត្រលក់ដែលបានអនុវត្តបច្ចុប្បន្ន",
    newAppliedSalesInvoiceID: "អត្តសញ្ញាណវិក្កយបត្រ​លក់​ថ្មី",
    changeAppliedID: "ប្តូរលេខសម្គាល់ ID",
    taxNo: "លេខពន្ធ",
    taxID: "លេខសម្គាល់ពន្ធ",
    showTaxForm: "បង្ហាញទម្រង់ពន្ធ",
    taxNoLabel: "លេខអត្តសញ្ញាណពន្ធ",
    taxIDLabel: "លេខសម្គាល់ពន្ធ",
    additionalTopMargin: "ចំណាត់ថ្នាក់ខាងលើបន្ថែម",
    additionalTopMarginHints: "កន្លែងបន្ថែមខាងលើសម្រាប់បោះពុម្ពវិក្កយបត្រ",
    endingBalance: "ប្រាក់នៅសល់",
    ledgerMutation: "ការប្រែប្រួលកំណត់ហេតុ",
    display: "បង្ហាញ",
    receiptDate: "កាលបរិច្ឆេទវិក្កយបត្រ",
    aging: "ចាស់ទុំ",
    detailByDay: "ព័ត៌មានតាមថ្ងៃ",
    showPODetail: "បង្ហាញព័ត៌មានលម្អិត PO",
    logNo: "លេខកូដចុះបញ្ជី",
    itemJournalLogSeries: "កំណត់ហេតុអត្ថបទ",
    printOptions: "ជម្រើសបោះពុម្ព",
    allowChangeUnitCostGreaterThanOriginal: "អនុញ្ញាតឱ្យប្តូរគុណតម្លៃឯកតាដែលលើសពីដើម",
    allowChangeUnitCostLessThanOriginal: "អនុញ្ញាតឱ្យប្ដូរប្រាក់ឯកតាដែលតិចជាងដើម",
    actual: "ពិតប្រាកដ",
    deliveryNo: "លេខការដឹកជញ្ជូន",
    showVendorDeliveryNoOnPrintout: "បង្ហាញលេខដឹកជញ្ជូនអ្នកផ្គត់ផ្គង់នៅលើការបោះពុម្ព",
    amountWithCurrency: "ចំនួន ({c})",
    balanceWithCurrency: "សមតុល្យ ({c})",
    centerHotelLogo: "បង្ហាញឡូហ្គូសណ្ឋាគារនៅកណ្តាលក្រដាស",
    showPostingDateColumn: "បង្ហាញជួរដេកកាលបរិច្ឆេទបង្ហោះ",
    tin1Label: "ស្លាក TIN 1",
    tin1Value: "តម្លៃ TIN 1",
    tin2Label: "ស្លាក TIN 2",
    tin2Value: "តម្លៃ TIN 2",
    welcomeText: "សូមអរគុណចំពោះការជ្រើសរើស {h} - សូមមើលវិក្កយបត្រដែលភ្ជាប់មកជាមួយនេះ:",
    totalBalance: "សមតុល្យសរុប",
    showWithdrawApproval: "បង្ហាញការអនុម័តការដកប្រាក់",
    paidAmount: "ចំនួនប្រាក់ដែលបានបង់",
    remaining: "នៅសល់",
    allowCreateNewSetPaymentJournal: "អនុញ្ញាតឱ្យបង្កើតកំណត់ត្រាបង់ប្រាក់ថ្មី",
    allowCreateNewSetCashReceiptJournal: "អនុញ្ញាតឱ្យបង្កើតសំណុំកាសសម្រាប់កំណត់ចំណូលថ្មី",
    journalNotAllowForDirectPosting: "កាសែតសម្រាប់ {f} មិនអនុញ្ញាតឱ្យបញ្ចេញដោយផ្ទាល់ទេ",
    journalHasZeroValue: "កាសែតសម្រាប់ {f} មិនមានតម្លៃ",
    journalNotBalanced: "កាសែតសម្រាប់ {f} មិនតុល្យ",
    showPreviousMonthAdjustment: "បង្ហាញការកែប្រែខែមុន",
    noDimensionValue: "(គ្មានវិមាត្រ)",
    isPreviousMonth: "ខែមុន",
    showAdjustmentEntry: "បង្ហាញការកំណត់ចូល",
    adjustmentSource: "ប្រភពកែប្រែ",
    distributeAmount: "ចែកចាយចំនួន",
    distributeAmountEnablement: "សូមបន្ថែមគណនីធនាគារមួយចំនួនដើម្បីអនុញ្ញាតឱ្យប្រើជម្រើសនេះ",
    distributeAmountMessage: "នេះនឹងចែកចាយចំនួនសរុបទៅគណនីធនាគារ secara tự động",
    allowChangeItemLastDirectCost: "អនុញ្ញាតឱ្យប្តូរគ្រឿងសង្ហារិមចុងក្រោយ",
    allowDirectReleasePO: "អនុញ្ញាតឱ្យបញ្ចេញ PO ដោយផ្ទាល់",
    useSystematicApprovalDML: "ប្រើការអនុម័តប្រព័ន្ធ (DML)",
    allowFreeOfChargeOnDirectExpense: "អនុញ្ញាតឱ្យឥតគិតថ្លៃលើចំណាយផ្ទាល់",
    statistic: "ស្ថិតិ",
    chequeNumber: "លេខសម្គាល់ចែកចាយ",
    showSignatureOnApproval: "បង្ហាញហត្ថលេខានៅលើការអនុម័ត",
    setVatProduct: "កំណត់ផលិតផល VAT",
    locations: "ទីតាំង",
    allLocations: "ទីតាំងទាំងអស់",
    itemCodeOrItemName: "កូដធាតុ ឬ ឈ្មោះធាតុ",
    account: "គណនី",
    onBehalfOfLabel: "តំណាងឱ្យស្លាក",
    sendEmail: "ផ្ញើអ៊ីមែល",
    useHOAInvoice: "ប្រើវិក្កយបត្រ HOA",
    telephone: "ទូរស័ព្ទ",
    mobilePhone: "ទូរស័ព្ទចល័ត",
    purchaseOrderNO: "លេខការបញ្ជាទិញ",
    requestNo: "សំណើលេខ",
    costCenter: "មជ្ឈមណ្ឌលថ្លៃដើម",
    tax: "ពន្ធ",
    loc: "ទីតាំង",
    uom: "មហាវិទ្យាល័យ",
    qty: "ចំនួន",
    dis: "បដិសេធ",
    supplierAddress: "អាសយដ្ឋានអ្នកផ្គត់ផ្គង់",
    voucherNo: "លេខកូដវ៉ូឌឺ",
    refNo: "លេខយោង",
    paymentDueDate: "កាលបរិច្ឆេទបង់ប្រាក់",
    bankCode: "កូដធនាគារ",
    showAsGroup: "បង្ហាញជា {s} ក្រុម",
    showAllVendor: "បង្ហាញអ្នកផ្គត់ផ្គង់ទាំងអស់",
    affectedData: "ទិន្នន័យដែលទទួលផល",
    newPostingDate: "កាលបរិច្ឆេទបញ្ចេញថ្មី",
    hide: "លាក់",
    endingNumber: "លេខបញ្ចប់",
    downloadPrintoutPDF: "ទាញយក PDF បោះពុម្ព",
    taxNumberSeries: "លេខសម្គាល់ពន្ធ",
    taxCompany: "ក្រុមហ៊ុនពន្ធ",
    taxExpiryDate: "កាលបរិច្ឆេទផុតកំណត់ពន្ធ",
    taxPhone: "ទូរស័ព្ទពន្ធ",
    taxEmail: "អ៊ីមែលពន្ធ",
    taxReceiptNo: "លេខវិក្កយបត្រពន្ធ",
    unitNo: "លេខឯកតា",
    unitOwnerName: "ឈ្មោះម្ចាស់ឯកតា",
    company: "ក្រុមហ៊ុន",
    selectedItems: "អត្ថបទដែលបានជ្រើសរើស",
    hoaCompanyName: "ឈ្មោះក្រុមហ៊ុន HOA",
    hoaRoomType: "ប្រភេទបន្ទប់ HOA",
    hoaUnitNo: "លេខឯកតា HOA",
    emailTemplate: "គំរូអ៊ីមែល",
    salesInvoiceSendEmailTemplate: "គំរូអ៊ីមែលផ្ញើវិក្កយបត្រ​លក់",
    templateVariables: "អថេរ​គំរូ",
    exampleTemplate: "គំរូឧទាហរណ៍",
    invoiceLabelSetup: "កំណត់ស្លាកវិក្កយបត្រ",
    updatePurchaseOrderStatus: "អាប់ដេតស្ថានភាពការបញ្ជាទិញ",
    updatePurchaseOrderStatusDescription: "ជ្រើសរើសស្ថានភាពថ្មីសម្រាប់ការបញ្ជាទិញពីបញ្ជីដាក់ក្រោមនេះ។",
    currentStatus: "ស្ថានភាពបច្ចុប្បន្ន",
    newStatus: "ស្ថានភាពថ្មី",
    preview: "មើលមុន",
    sortBy: "តម្រៀបដោយ",
    allowEditPurchaseRequestInApproval: "អនុញ្ញាតឱ្យកែប្រែសំណើទិញនៅក្នុងការអនុម័ត",
    allowEditPurchaseRequestInApprovalNote: "អ្នកប្រើប្រាស់ដែលមិននៅក្នុងបញ្ជីអនុម័តអាចកែប្រែបាន។ នេះធ្វើការជាមួយអនុសាសន៍ 'អនុញ្ញាតឱ្យអ្នកប្រើប្រាស់កែប្រែ PR ក្នុងការអនុម័ត'។",
    processToPoCopyDescription: "ដំណើរការទៅកាន់ការចម្លង PO",
    show0Quantity: "បង្ហាញចំនួន ០",
    selectedLocations: "ទីតាំងដែលបានជ្រើសរើស",
    selectedInventoryPostingGroups: "ក្រុមបញ្ជីស្តុកដែលបានជ្រើសរើស",
    noItemsSelected: "មិនមានអត្ថបទណាមួយបានជ្រើសរើស",
    noLocationsSelected: "មិនមានទីតាំងណាមួយបានជ្រើសរើស",
    noInventoryPostingGroupsSelected: "មិនមានក្រុមបញ្ជីស្តុកដែលបានជ្រើសរើសទេ",
    vendorSource: "ប្រភពអ្នកផ្គត់ផ្គង់",
    downloadCSV: "ទាញយក CSV",
    delegatedBy: "ផ្ដល់អំណាចដោយ",
    showCustomerAccountType: "បង្ហាញប្រភេទគណនីអតិថិជន",
    printGeneralLedgerInformationonPostedDocument: "បោះពុម្ពព័ត៌មានកំណត់ហេតុទូទៅនៅលើឯកសារដាក់បញ្ចូល",
    submittedAt: "ដាក់ស្នើនៅថ្ងៃ",
    submittedBy: "ដាក់ស្នើដោយ",
    withdrawalAt: "ដកប្រាក់នៅ",
    withdrawalBy: "ការដកប្រាក់ដោយ",
    expectedDueDate: "កាលបរិច្ឆេទដែលរំពឹង / កាលបរិច្ឆេទដល់កំណត់",
    documentApprovalType: "ប្រភេទអនុម័តឯកសារ",
    useExtendedPRDescriptionLength: "ប្រើកំណត់រយៈពេលពិពណ៌នាផ្សព្វផ្សាយបន្ថែម (255 តួអក្សរ)",
    allowMultilineDescription: "អនុញ្ញាតឱ្យពិពណ៌នាច្រើនបន្ទាត់នៅលើ PR/PO",
    showUpdateLowestCostVendorComparisonPurchaseRequest: "បង្ហាញការប្រៀបធៀបអ្នកផ្គត់ផ្គង់ថ្លៃទាបបំផុតក្នុងការស្នើសុំទិញ",
    printPreview: "មើលមុនបោះពុម្ព",
    descriptionMultiLineHint: "ចុច Enter ឬវាយ ; (សញ្ញាផ្នែក) ដើម្បីបន្ថែមជួរ​ថ្មី",
    appliesToPostedPurchaseCreditMemoId: "លេខសម្គាល់កំណត់ចំណាំឥណទានដែលបានអនុវត្ត",
    createPaymentJournal: "បង្កើតកាសែតបង់ប្រាក់",
    createCashReceiptJournal: "បង្កើតកាសសន្និដ្ឋានប្រាក់",
    lockPostingDateTheSameAsWorkingDateInFO: "ចាក់កាលបរិច្ឆេទបោះពុម្ពដូចកាលបរិច្ឆេទធ្វើការ នៅក្នុង FO",
    lockPostingDateTheSameAsWorkingDateInFONote: "សម្រាប់កាសសន្និដ្ឋាន និងកាសសម្របសម្រួលគណនី",
    totaling: "សរុប",
    defaultDimensionValue: "តម្លៃទំហំលំនាំ",
    dimensionSetID: "អត្តសញ្ញាណកំណត់វិមាត្រ",
    dimensionName: "ឈ្មោះវិមាត្រ",
    dimensionCode: "កូដវិមាត្រ",
    optionCode: "កូដជម្រើស",
    defaultValueCode: "កូដតម្លៃលំនាំ",
    allowed: "អនុញ្ញាត",
    allowedValueCode: "កូដតម្លៃដែលអនុញ្ញាត",
    dimensionValueName: "ឈ្មោះតម្លៃវិមាត្រ",
    dimensionValueCode: "កូដតម្លៃវិមាត្រ",
    selectAllowedDimensionValues: "ជ្រើសរើសតម្លៃវិមាត្រដែលអនុញ្ញាតសម្រាប់វិមាត្រនេះ",
    selectDimensionToViewAllowedValues: "ជ្រើសរើសមាត្រ ដើម្បីមើលតម្លៃដែលអនុញ្ញាត",
    selectedValues: "តម្លៃដែលបានជ្រើសរើស",
    showPositive: "បង្ហាញវិជ្ជមាន",
    showBankAccountOnPaymentListReport: "បង្ហាញគណនីធនាគារនៅក្នុងរបាយការណ៍បញ្ជីការទូទាត់ទាំងអស់",
    footerFontType: "ប្រភេទអក្សរ Footer",
    standardFontHint: "អក្សរយ៉ាងស្តង់ដារដោយប្រព័ន្ធ",
    monospaceFontHint: "អក្សរ រៀងរាល់អក្សរ រួមមាន អក្សរ លេខ និងកន្លែង ទាំងអស់ មានទំហំទទឹងដូចគ្នា",
    signatureAlignment: "ការតំរូវហត្ថលេខា",
    allowEditReleasedPOLineZeroQtyReceived: "អនុញ្ញាតឱ្យកែប្រែបន្ទាត់ PO ដែលបើក និងបានចេញផ្សាយ នៅពេលចំនួនដែលទទួលបានគឺសូន្យ",
    overridePrLineFromPo: "ប្តូរ បន្ទាត់ PR ពេលដែលបន្ទាត់ PO ត្រូវបានកែប្រែ",
    month1: "១ ខែ",
    month2: "២ ខែ",
    month3: "៣ ខែ",
    month4: "៤ ខែ",
    moreThan4Months: "> ៤ ខែ",
    printingDateTime: "កាលបរិច្ឆេទ និងម៉ោងបោះពុម្ព",
    disc: "ឌីសក",
    allowDeletePrSourcedPoLine: "អនុញ្ញាតឱ្យលុបបន្ទាត់ PO ដែលមានប្រភពពី PR (ត្រឡប់បន្ទាត់ PR ទៅ Open)",
    purchaseRequestExpiredRange: "សំណើការទិញបានផុតកំណត់ (ថ្ងៃ)",
    purchaseOrderExpiredRange: "រយៈពេលបញ្ជាទិញបានផុតកំណត់ (ថ្ងៃ)",
    enablePrintButtonForOnlyReleasedDocuments: "អនុញ្ញាតប៊ូតុងបោះពុម្ពតែប៉ុណ្ណោះ ប្រសិនបើស្ថានភាពឯកសារត្រូវបានចេញផ្សាយ",
    currentDimensionSetID: "អត្តសញ្ញាណកំណត់វិមាត្របច្ចុប្បន្ន",
    newDimensionSetID: "អត្តសញ្ញាណកំណត់វិមាត្រថ្មី",
    lastMovement: "ចលនាធ្វើចុងក្រោយ",
    age: "អាយុ",
    soh: "សូហ៍",
    changeGLAccount: "ប្តូរគណនី GL",
    postPurchaseInvoice: "វិក័យប័ត្រ​ក្រោយ​ការទិញ",
    draft: "គំរូ",
    setZeroQuantityPhysicalAsBlank: "កំណត់ចំនួន ០ (ស្តុករាងកាយ) ជាអត់",
    reviewYtdReportComparisonYear: "សម្រួលប្រាក់ចំណូល YTD ប្រៀបធៀបឆ្នាំ",
    reviewPnlYtdSummaryComparisonYear: "សង្ខេបប្រាក់ចំណេញ និងខាត YTD ប្រៀបធៀបឆ្នាំ",
    reviewPnlYtdConsolidationComparisonYear: "ប្រាក់ចំណេញ និងខាត YTD ការបូកសរុបប្រៀបធៀបឆ្នាំ",
    reviewBalanceSheetYtdSummaryComparisonYear: "សេចក្តីសង្ខេបតុល្យភាព YTD ប្រៀបធៀបឆ្នាំ",
    budget: "ថវិកា",
    taxRegisterNumber: "លេខចុះឈ្មោះពន្ធ",
    purchaseReceiptNo: "លេខ PR",
    purchaseReceiptPostingDate: "កាលបរិច្ឆេទបោះពុម្ព PR",
    amountDue: "ចំនួនដែលត្រូវបង់",
    periodDate: "កាលបរិច្ឆេទរដូវកាល",
    parafInitial: "ហត្ថលេខា / ដំបូង",
    appliesToPostedPurchaseInvoiceNo: "លេខវិក្កយបត្រទិញដែលបានអនុវត្ត",
    showContactNameOnPrintSummary: "បង្ហាញឈ្មោះទំនាក់ទំនងនៅលើសង្ខេបបោះពុម្ព",
    depositAccountCode: "កូដគណនីដាក់ប្រាក់",
    depositAccountName: "ឈ្មោះគណនីដាក់ប្រាក់",
    boDepositAccountCode: "កូដគណនីប្រាក់បញ្ញើ BO",
    boDepositAccountName: "ឈ្មោះគណនីប្រាក់ចំណូល BO",
    foDepositAccountNo: "គណនីប្រាក់កក់ FO",
    foDepositAccountName: "ឈ្មោះគណនីដាក់ប្រាក់ FO",
    depositAccountPostingGroupCode: "កូដក្រុមបញ្ជាក់គណនីដាក់ប្រាក់",
    depositAccountPostingGroupName: "ក្រុមឈ្មោះការដាក់ប្រាក់",
    appliedDepositAccountLedgerEntryId: "អត្តសញ្ញាណដែលបានអនុវត្ត",
    showInDocument: "បង្ហាញក្នុងឯកសារ",
    showInDocumentHint: "កម្រិតដែលបានសម្គាល់បង្ហាញក្នុងឯកសារ បន្ថែមជួរ កូដ និងឈ្មោះទៅ: សំណើរការទិញ, ការបញ្ជាទិញ, វិក័យប័ត្រទិញ, វិក័យប័ត្រប្រាក់កម្ចី, វិក័យប័ត្រប្រាក់កម្ចីទិញ, សំណើរការទុក, វិក័យប័ត្រលក់, វិក័យប័ត្រប្រាក់កម្ចីលក់, ការពិពណ៌នាទូទៅ, ការពិពណ៌នាប្រាក់ចំណាយទូទៅ, ការពិពណ៌នាធាតុ, ការពិពណ៌នាស្តុក.",
    automaticFillInvoiceNo: "បញ្ចូលលេខវិក័យប័ត្រដោយស្វ័យប្រវត្តិជាមួយលេខដឹកជញ្ជូនអ្នកផ្គត់ផ្គង់",
    useGeneralBudgetEntryForPnlBudget: "ប្រើការបញ្ចូលថវិកាទូទៅសម្រាប់ថវិកា P&L",
    recalledAt: "បានហៅត្រឡប់",
    recalledBy: "បានហៅត្រឡប់",
    hideUnitCostColumn: "លាក់ជួរឈរ​តម្លៃ​ឯកតា",
    hideTotalAmountColumn: "លាក់ជួរទឹកប្រាក់សរុប",
    showPrintedDateTime: "បង្ហាញកាលបរិច្ឆេទ និងម៉ោងបោះពុម្ព",
    printedAt: "បោះពុម្ពនៅ",
    includedInGop: "រួមបញ្ចូលក្នុង GOP",
    bankAccountName: "ឈ្មោះគណនីធនាគារ",
    chargeDate: "កាលបរិច្ឆេទបង់ប្រាក់",
    banquet: "បុណ្យ",
    secondaryAccountNo: "លេខគណនីរង",
    currentStockOnHand: "ស្ថានភាព SOH បច្ចុប្បន្ន",
    baseCurrentStockOnHand: "ស្ថានភាព SOH មូលដ្ឋាន",
    showCurrentSohInPurchaseRequest: "បង្ហាញ SOH បច្ចុប្បន្នក្នុងការស្នើសុំទិញ",
    showCurrentSohInPurchaseOrder: "បង្ហាញ SOH បច្ចុប្បន្នក្នុងការបញ្ជាទិញ",
    allowPositiveAdjustmentPhysicalInventory: "អនុញ្ញាតឱ្យកែប្រែវិជ្ជមានលើកាស្រាវជ្រាវសារពើភ័ណ្ឌ",
    dimensionValueID: "អត្តសញ្ញាណតម្លៃវិមាត្រ",
    purchaseRequestMaxBackdatedDays: "ថ្ងៃបញ្ចប់អតិបរិមា",
    purchaseOrderMaxBackdatedDays: "ថ្ងៃអតិបរិមាដែលត្រឡប់ក្រោយ",
    purchaseInvoiceMaxBackdatedDays: "ថ្ងៃក្រោយកំណត់អតិបរិមា",
    storeRequisitionMaxBackdatedDays: "ថ្ងៃបញ្ជូនក្រោយអតិបរិមា",
    newQuantity: "បរិមាណថ្មី",
    editQuantity: "កែប្រែបរិមាណ",
    requestedQuantity: "បរិមាណដែលបានស្នើសុំ",
    allowApproverEditQuantityLessThanOriginal: "អនុញ្ញាតឱ្យអ្នកអនុម័តកែប្រែចំនួនតិចជាងដើម",
    wht: "WHT\" in Khmer Cambodian is: \"អត្រា",
    hideWhtWhenZero: "លាក់ WHT នៅពេលចំនួនសូន្យ",
    useImportWithReservation: "ប្រើការនាំចូលជាមួយការកក់",
    includeReservationDetail: "បញ្ចូលព័ត៌មានការកក់",
    contractValidFrom: "សន្យាអនុវត្តចាប់ពី",
    contractValidTo: "កិច្ចសន្យាអនុវត្តដល់",
    reconciliationWhtGlAccount: "គណនីពន្ធបញ្ច្រាស",
    whtAccountMustDiffer: "គណនីពន្ធចាំបាច់ត្រូវខុសពីគណនី GL ដើម",
    whtFee: "ពន្ធកាត់ទុក (%)",
    batchHasWhtFee: "ពន្ធកាត់បន្ថយ <strong>{f} %</strong> ត្រូវបានអនុវត្តនៅលើក្រុមនេះ។",
    batchHasWhtOptions: "អត្រាពន្ធកាន់កាប់:",
    freePercentage: "ភាគរយឥតគិតថ្លៃ",
    feeRoundingDigits: "លេខរាងសេវាកម្ម (០-៣)",
    feeRoundingDigitsRange: "លេខរាងសម្រាប់កម្រៃត្រូវតែជាចំនួនពេញពី ០ ដល់ ៣",
    reconciliationFeeRoundingDigits: "លេខរាងសម្រាប់គណនាប្រាក់កំណត់ (០-៣)",
    reconciliationFeeRoundingDigitsHint: "លេខទសភាគរក្សាទុកលើការបញ្ចុះតម្លៃពាណិជ្ជកម្ម និងប្រាក់ពន្ធកាត់ចេញក្នុងកាសែតសម្របសម្រួលគណនី",
    paymentStatus: "ស្ថានភាពការទូទាត់",
    useCompanyHeaderAndLogoOnPrintout: "ប្រើក្បាលក្រុមហ៊ុន និងឡូហ្គូនៅក្បាលការបោះពុម្ព",
    supplierAndHotelVatLabel: "ស្លាក VAT អ្នកផ្គត់ផ្គង់ និងសណ្ឋាគារ",
    supplierInfo: "ព័ត៌មានអ្នកផ្គត់ផ្គង់",
    shipToBillTo: "ដឹកជញ្ជូនទៅ / គិតថ្លៃទៅ",
    creditAccountName: "ឈ្មោះគណនីឥណទាន",
    debitAccountName: "ឈ្មោះគណនីឥណពន្ធ",
    defaultCreditAccountName: "ឈ្មោះគណនីឥណទានលំនាំដើម",
    defaultDebitAccountName: "ឈ្មោះគណនីឥណពន្ធលំនាំដើម",
    defaultCreditAccount: "គណនីឥណទានលំនាំដើម",
    defaultDebitAccount: "គណនីឥណទានលំនាំដើម",
    chequeNo: "លេខសម្គាល់ឆែក",
    allowOverReceipt: "អនុញ្ញាតឱ្យចំនួនទទួលលើ",
    overReceiptTolerancePercentage: "អត្រាអតិបរិមាអំពីបរិមាណទទួល (%)",
    inventoryAdjustmentAccountCode: "កូដគណនីកែប្រែវិក្កយបត្រ",
    inventoryAdjustmentAccountName: "ឈ្មោះគណនីកែសម្រួលវិក្កយបត្រ",
    genBusPostGroupName: "ឈ្មោះក្រុមសាធារណៈ",
    aePurchasingAccount: "គណនីទិញ A/E",
    accrualJournalBatch: "កំណត់ហេតុប្រព័ន្ធបញ្ចូល",
    accrualJournalBatchTemplate: "កំណត់ហេតុបូកសរុប (គំរូ ACCRUAL)",
    accrualDate: "កាលបរិច្ឆេទបូកសរុប",
    quantityToAccrue: "បរិមាណដែលត្រូវបន្ថែម",
    mdrOptionsPerBatch: "អត្រាបញ្ចុះតម្លៃជាអ្នកជួញដូរ (រាល់កញ្ចប់ប្រើអត្រារបស់ខ្លួន)",
    batchWhtRate: "អត្រាបេត្ដ",
    batchAccountTotals: "សរុបតាមគណនី",
    createReconciliationJournal: "បង្កើតកាសែតសម្របសម្រួល",
    message: "សារណា",
    postAllBatchResultTitle: "ផ្សាយលទ្ធផលបាច់ទាំងអស់",
    postAllBatchSummary: "{succeeded} បានជោគជ័យ, {failed} បានបរាជ័យ, {skipped} បានរំលង",
    postAllBatchNothingToPost: "មិនមានកញ្ចប់ណាមួយដែលមានកំណត់ត្រាសម្រាប់បង្ហោះទេ។",
    deleteAllBatchNothing: "មិនមានកញ្ចប់ណាមួយដែលមានកំណត់ត្រាសម្រាប់លុប។",
    deleteAllBatchSummary: "{deleted} ក្រុមត្រូវបានទទេ, {failed} បរាជ័យ",
    postAllBatchEmpty: "កញ្ចប់មិនមានកំណត់ត្រា",
    postAllBatchStatus: {
      succeeded: "ជោគជ័យ",
      failed: "បរាជ័យ",
      skipped: "រំលង",
    },
    displayGuestAsGuestList: "បង្ហាញភ្ញៀវជា​បញ្ជីភ្ញៀវ",
    allowEditOpenPOLineWhenZeroQtyReceived: "អនុញ្ញាតឱ្យកែប្រែបន្ទាត់ PO បើបរិមាណដែលទទួលបានគឺសូន្យ",
    allowEditReleasedPOLineWhenZeroQtyReceived: "អនុញ្ញាតឱ្យកែប្រែបន្ទាត់ PO ដែលបានចេញផ្សាយ នៅពេលចំនួនទទួលបានគឺសូន្យ",
    debitDimensions: "វិមាត្របង់ប្រាក់",
    creditDimensions: "វិមាត្រប្រាក់កម្ចី",
    saveBatchFirstForDimensions: "រក្សាទុកកញ្ចប់ជាមួយគណនីនេះដំបូងដើម្បីកំណត់វិមាត្រ",
    applyMaxBackdatedDays: "អនុវត្តថ្ងៃចាស់អតិបរិមា",
    showDocumentStatusOnPrintout: "បង្ហាញស្ថានភាពឯកសារលើការបោះពុម្ព",
    printedAtStatus: "បោះពុម្ពនៅស្ថានភាព",
  },
  validation: {
    baseRequired: "វាលត្រូវបានទាមទារ",
    required: "{f} ត្រូវបានទាមទារ",
    longerThan: "{f} មិនត្រូវលើស {v} តួអក្សរ",
    lineMoreThan: "{f} មិនត្រូវលើស {v} បន្ទាត់",
    exceed: "{f} មិនត្រូវលើស {v}",
    dateNotAfter: "កាលបរិច្ឆេទ '{f1}' មិនត្រូវនៅក្រោយ '{f2}'",
    dateNotBefore: "កាលបរិច្ឆេទ '{f1}' មិនត្រូវនៅមុន '{f2}'",
    dateNotBefore2: "កាលបរិច្ឆេទ {f1} មិនត្រូវនៅមុន {f2} ({f3})",
    dateNotBefore3: "កាលបរិច្ឆេទ {f1} មិនត្រូវនៅមុន {f2}",
    unitCostExceedOrBelowLastPrice: "ថ្លៃដើមមិនអាចលើស {v1} ឬទាបជាង {v2} ពីថ្លៃចុងក្រោយ",
    greaterThan: "តម្លៃគួរតែធំជាង {v}",
    generalProductPostingGroupRequired: "ក្រុមចុះបញ្ជីផលិតផលទូទៅ តម្រូវឱ្យមាន សូមជ្រើសរើសពីបញ្ជីទម្លាក់ចុះ",
    inventoryPostingGroupRequired: "ក្រុមចុះបញ្ជីសន្និធិ តម្រូវឱ្យមាន សូមជ្រើសរើសពីបញ្ជីទម្លាក់ចុះ",
    baseUnitOfMeasurementRequired: "ឯកតាវាស់វែងមូលដ្ឋាន តម្រូវឱ្យមាន សូមជ្រើសរើសពីបញ្ជីទម្លាក់ចុះ",
    defaultUnitOfMeasurementRequired: "ឯកតាវាស់វែងលំនាំដើម តម្រូវឱ្យមាន សូមជ្រើសរើសពីបញ្ជីទម្លាក់ចុះ",
    max20Lines: "ខ្សែអក្សរមិនគួរតែលើស 20 បន្ទាត់",
    maxLines: "ខ្សែអក្សរមិនគួរប្រែប្រួលលើស {f} បន្ទាត់ទេ",
    completeRequiredFields: "សូមបញ្ចប់វាលទាំងអស់ដែលត្រូវការមុនពេលបង្ហោះ។ សូមពិនិត្យវាលដែលបានរំលឹកក្នុងតារាង។",
    cannotPostWhenUseSystematicApproval: "មិនអាចបញ្ចេញវិក័យប័ត្រទិញបាននៅពេលប្រើការអនុម័តប្រព័ន្ធ",
    dimensionAlreadyInList: "វិមាត្រនេះមានតម្លៃក្នុងបញ្ជីរួចហើយ។ សូមកែសម្រួលជួរដែលមានមុននេះ។",
    incompleteDimensionRow: "ជួរ​នីមួយៗ​ត្រូវការទាំង​មាត្រា និង​តម្លៃ។ សូមបញ្ចប់ ឬ លុបជួរដែលមិនបានបញ្ចប់។",
    dimensionsNotLoaded: "មិនអាចផ្ទុកវិមាត្របច្ចុប្បន្នបានទេ។ បិទ និងបើកឡើងវិញនូវប្រអប់នេះមុនពេលរក្សាទុក។",
    linesTotalCannotBeNegative: "សរុបនៃបន្ទាត់ទាំងអស់មិនអាចអវិជ្ជមានបានទេ",
    fourDigitYear: "បញ្ចូលឆ្នាំ ៤ ខ្ទង់",
    physicalQuantityNegative: "បរិមាណរាងកាយមិនអាចអវិជ្ជមានបានទេ។ សូមបញ្ចូលបរិមាណដែលបានរាប់ (0 ប្រសិនបើគ្មាន)។",
    maxBackdatedDaysRange: "បញ្ចូលចំនួនថ្ងៃពេញចន្លោះពី ០ ដល់ ៣០",
    quantityGreaterThanRequested: "ចំនួនមិនអាចធំជាងចំនួនដែលបានស្នើ ({v})",
    contractValidToBeforeFrom: "កិច្ចសន្យាអនុញ្ញាតឱ្យមានសុពលភាពមិនអាចមុនកិច្ចសន្យាអនុញ្ញាតឱ្យមានសុពលភាពពី",
    idtDeleteOnlyOpen: "អាចលុបបានតែការផ្ទេរដែលបើកឬបដិសេធដែលមិនបានបង្ហោះ",
    overReceiptToleranceRange: "បញ្ចូលភាគរយលើ ០ និងអតិបរិមា ៩៩៩.៩៩ មានអតិបរិមា ២ ចំណុចទាំងអស់",
    overReceiptMaxAllowed: "{f} មិនអាចលើស {v} បានទេ គឺជាអតិបរិមាដែលអនុញ្ញាតនៅលើបន្ទាត់នេះ",
  },
  textFormat: {
    addFromReceipt: "បន្ថែមពីបង្កាន់ដៃទទួល : {f} ",
  },
  l: {
    add: "បន្ថែម",
    addCashDesk: "បន្ថែមបេឡា",
    addChannel: "បន្ថែមឆានែល",
    addCity: "បន្ថែមទីក្រុង",
    addChannelClientCompositionMapping: "បន្ថែមផែនទីបង្កើតអតិថិជនឆានែល",
    addChannelHotelRateCodeMapping: "បន្ថែមផែនទីកូដតម្លៃសណ្ឋាគារឆានែល",
    addChannelHotelRoomTypeMapping: "បន្ថែមផែនទីប្រភេទបន្ទប់សណ្ឋាគារឆានែល",
    addCountry: "បន្ថែមប្រទេស",
    addCreditCardType: "បន្ថែមប្រភេទកាតឥណទាន",
    addGeneralJournal: "បន្ថែមសៀវភៅទូទៅ",
    addJournalAccountType: "បន្ថែមប្រភេទគណនីសៀវភៅ",
    addJournalBatch: "បន្ថែមកញ្ចប់សៀវភៅ",
    addJournalTemplate: "បន្ថែមពុម្ពសៀវភៅ",
    addRoomStatus: "បន្ថែមស្ថានភាពបន្ទប់",
    addRoomType: "បន្ថែមប្រភេទបន្ទប់",
    adminCode: "កូដអ្នកគ្រប់គ្រង",
    adminName: "ឈ្មោះអ្នកគ្រប់គ្រង",
    adminNameAscii: "ឈ្មោះ ASCII អ្នកគ្រប់គ្រង",
    adminType: "ប្រភេទអ្នកគ្រប់គ្រង",
    backOffice: "ការិយាល័យក្រោយ",
    bankAccount: "គណនីធនាគារ",
    bankAccountId: "លេខសម្គាល់គណនីធនាគារ",
    beverage: "ភេសជ្ជៈ",
    beverageToday: "ភេសជ្ជៈថ្ងៃនេះ",
    bookingSource: "ប្រភពកក់",
    breakdownListAt: "បញ្ជីបំបែកនៅ",
    breakdownListOf: "បញ្ជីបំបែកនៃ",
    cancel: "បោះបង់",
    cancelProcess: "បោះបង់ដំណើរការ",
    capital: "ធនធាន",
    cashDesk: "បេឡា",
    changeClientPostingGroup: "ផ្លាស់ប្តូរក្រុមចុះបញ្ជីអតិថិជន",
    channel: "ឆានែល",
    channelAgencyCode: "កូដភ្នាក់ងារឆានែល",
    channelClientCompositionMapping: "ផែនទីបង្កើតអតិថិជនឆានែល",
    channelHotelRateCodeMapping: "ផែនទីកូដតម្លៃសណ្ឋាគារឆានែល",
    channelHotelRoomTypeMapping: "ផែនទីប្រភេទបន្ទប់សណ្ឋាគារឆានែល",
    channelId: "លេខសម្គាល់ឆានែល",
    channelManager: "អ្នកគ្រប់គ្រងឆានែល",
    channelRateCode: "កូដតម្លៃឆានែល",
    channelRoomType: "ប្រភេទបន្ទប់ឆានែល",
    channelRoomTypeCode: "កូដប្រភេទបន្ទប់ឆានែល",
    city: "ទីក្រុង",
    cityAlt: "ទីក្រុងផ្សេងទៀត",
    cityAscii: "ទីក្រុង ASCII",
    code: "កូដ",
    country: "ប្រទេស",
    countryId: "លេខសម្គាល់ប្រទេស",
    credit: "ឥណទាន",
    creditCard: "កាតឥណទាន",
    creditCardType: "ប្រភេទកាតឥណទាន",
    client: "អតិថិជន",
    clientNo: "លេខអតិថិជន",
    clientLedger: "សៀវភៅអតិថិជន",
    currencyID: "លេខសម្គាល់រូបិយប័ណ្ណ",
    currencyName: "ឈ្មោះរូបិយប័ណ្ណ",
    dailyFlashCostReport: "របាយការណ៍ថ្លៃដើមប្រចាំថ្ងៃ",
    dashboard: "ផ្ទាំងគ្រប់គ្រង",
    defaultBookingSource: "ប្រភពកក់លំនាំដើម",
    defaultMarketSegment: "ផ្នែកទីផ្សារលំនាំដើម",
    delete: "លុប",
    deleteConfirmation: "បញ្ជាក់លុប",
    density: "ដង់ស៊ីតេ",
    description: "ពិពណ៌នា",
    documentNo: "លេខឯកសារ",
    documentType: "ប្រភេទឯកសារ",
    documentFlowNotFound: "រកមិនឃើញលំហូរឯកសារដែលមានកូដ {f}",
    downloadExcel: "ទាញយក Excel",
    downloadGSheet: "ទាញយក GSheet",
    downloadPDF: "ទាញយក PDF",
    downloadReport: "ទាញយករបាយការណ៍",
    downloadReportToGSheet: "ទាញយករបាយការណ៍ទៅ GSheet",
    downloadReportToGSheetMacro: "ទាញយករបាយការណ៍ទៅ GSheet (Macro)",
    downloadReportToExcel: "ទាញយករបាយការណ៍ទៅ Excel",
    downloadReportToExcelMacro: "ទាញយករបាយការណ៍ទៅ Excel (Macro)",
    edit: "កែសម្រួល",
    editCashDesk: "កែសម្រួលបេឡា",
    editChannel: "កែសម្រួលឆានែល",
    editCity: "កែសម្រួលទីក្រុង",
    editChannelClientCompositionMapping: "កែសម្រួលផែនទីបង្កើតអតិថិជនឆានែល",
    editChannelHotelRateCodeMapping: "កែសម្រួលផែនទីកូដតម្លៃសណ្ឋាគារឆានែល",
    editChannelHotelRoomTypeMapping: "កែសម្រួលផែនទីប្រភេទបន្ទប់សណ្ឋាគារឆានែល",
    editCountry: "កែសម្រួលប្រទេស",
    editCreditCardType: "កែសម្រួលប្រភេទកាតឥណទាន",
    editGeneralJournal: "កែសម្រួលសៀវភៅទូទៅ",
    editJournalAccountType: "កែសម្រួលប្រភេទគណនីសៀវភៅ",
    editJournalBatch: "កែសម្រួលកញ្ចប់សៀវភៅ",
    editJournalTemplate: "កែសម្រួលពុម្ពសៀវភៅ",
    editRoomStatus: "កែសម្រួលស្ថានភាពបន្ទប់",
    editRoomType: "កែសម្រួលប្រភេទបន្ទប់",
    editCost: "កែសម្រួលថ្លៃដើម",
    editRemainingQuantity: "កែសម្រួលបរិមាណនៅសល់",
    editRemainingAmount: "កែសម្រួលចំនួនទឹកប្រាក់នៅសល់",
    editRemainingAmountWarning: "ប្រយ័ត្ន៖ វាសរសេរជាន់ពីលើចំនួនទឹកប្រាក់នៅសល់ និងស្ថានភាពបើកនៃធាតុបញ្ជីដែលបានចុះបញ្ជីដោយផ្ទាល់។ សូមពិនិត្យធាតុពាក់ព័ន្ធបន្ទាប់ពីនេះ។",
    internalToolsPostBatchReceipt: "Internal Tools Post Batch",
    internalToolsPostBatchReceiptHint: "Posts released purchase orders for this hotel whose order date falls in the range you set, oldest first, as fully received purchase receipts, up to the limit you set. Receipts are numbered with the prefix exactly as typed, including any trailing space, followed by a running number.",
    internalToolsPostBatchReceiptConfirm: "Post all released purchase orders as fully received purchase receipts?",
    internalToolsPostBatchReceiptFailed: "Failed to post",
    internalToolsPostBatchReceiptNoOrders: "There are no released purchase orders to post.",
    internalToolsPostBatchReceiptDone: "Posted {posted}, failed {failed}.",
    orderDateFrom: "Order Date From",
    orderDateTo: "Order Date To",
    documentNoPrefix: "Document No Prefix",
    documentNoPrefixInvalid: "Prefix contains characters that are not allowed.",
    maxOrdersPerRun: "Max Orders Per Run",
    maxOrdersPerRunInvalid: "Enter a whole number between 1 and {v}.",
    numberingByPrefix: "Prefix",
    editStoreRequisitionPosted: "កែសម្រួលសំណើស្តុកដែលបានចុះបញ្ជី",
    entryNo: "លេខធាតុចូល",
    failed: "បរាជ័យ",
    failedToPrint: "បរាជ័យក្នុងការបោះពុម្ព",
    food: "អាហារ",
    foodToday: "អាហារថ្ងៃនេះ",
    frontOffice: "ស្នាក់នៅមុខ",
    generalJournal: "សៀវភៅទូទៅ",
    genProdPostGroupID: "លេខសម្គាល់ក្រុមចុះបញ្ជីផលិតផលទូទៅ",
    glAccountID: "លេខសម្គាល់គណនី GL",
    glAccountName: "ឈ្មោះគណនី GL",
    glAccountNo: "លេខគណនី GL",
    guestNumber: "លេខភ្ញៀវ",
    headerDescription: "ពិពណ៌នាបឋម",
    headerClientName: "ឈ្មោះអតិថិជនបឋម",
    headerClientAddress: "អាសយដ្ឋានអតិថិជនបឋម",
    hotelAgency: "ភ្នាក់ងារសណ្ឋាគារ",
    hotelAgencyGroup: "ក្រុមភ្នាក់ងារសណ្ឋាគារ",
    hotelClient: "អតិថិជនសណ្ឋាគារ",
    hotelRate: "តម្លៃសណ្ឋាគារ",
    hotelRoomType: "ប្រភេទបន្ទប់សណ្ឋាគារ",
    importUnitCost: "នាំចូលថ្លៃដើមឯកតា",
    importQuantity: "នាំចូលបរិមាណ",
    iso2Code: "កូដ ISO2",
    journalAccountNo: "លេខគណនីសៀវភៅ",
    journalAccountType: "ប្រភេទគណនីសៀវភៅ",
    journalBatch: "កញ្ចប់សៀវភៅ",
    journalTemplate: "ពុម្ពសៀវភៅ",
    latitude: "រយៈទទឹង",
    lineDescription: "ពិពណ៌នាបន្ទាត់",
    lineLocationID: "លេខសម្គាល់ទីតាំងបន្ទាត់",
    lineLocationName: "ឈ្មោះទីតាំងបន្ទាត់",
    lineNo: "លេខបន្ទាត់",
    lineUnitOfMeasurementID: "លេខសម្គាល់ឯកតាវាស់បន្ទាត់",
    lineUnitOfMeasurementName: "ឈ្មោះឯកតាវាស់បន្ទាត់",
    longitude: "រយៈបណ្តោយ",
    macro: {
      cost: "ថ្លៃដើម Macro",
      revenue: "ប្រាក់ចំណូល Macro",
    },
    mandatory: "ត្រូវតែបំពេញ",
    marketSegment: "ផ្នែកទីផ្សារ",
    masterData: "ទិន្នន័យមេ",
    month: {
      _: "ខែ",
      list: {
        full: "['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ']",
        abbr: "['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ']",
      },
    },
    name: "ឈ្មោះ",
    new: "ថ្មី",
    no: "លេខ",
    numericCode: "កូដលេខ",
    ofCreditComplimentary: "នៃឥណទាន - ការផ្តល់ជូន",
    ofCreditCover: "នៃឥណទាន - គម្រប",
    ofCreditOfficeCheck: "នៃឥណទាន - សែកការិយាល័យ",
    ofCreditEntertainment: "នៃឥណទាន - ការកម្សាន្ត",
    ofPurchaseReceipt: "នៃបង្កាន់ដៃទិញ",
    ofStoreRequest: "នៃសំណើហាង",
    officialStateName: "ឈ្មោះរដ្ឋផ្លូវការ",
    originalAmount: "ចំនួនដើម",
    paymentTermID: "លេខសម្គាល់លក្ខខណ្ឌបង់ប្រាក់",
    paymentTermCode: "កូដលក្ខខណ្ឌបង់ប្រាក់",
    population: "ប្រជាជន",
    populationProper: "ប្រជាជនត្រឹមត្រូវ",
    postingDate: "កាលបរិច្ឆេទចុះបញ្ជី",
    rate: "អត្រា",
    ranking: "ចំណាត់ថ្នាក់",
    revenueCenterCode: "កូដមជ្ឈមណ្ឌលប្រាក់ចំណូល",
    roomStatus: "ស្ថានភាពបន្ទប់",
    roomType: "ប្រភេទបន្ទប់",
    sameName: "ឈ្មោះដូចគ្នា",
    save: "រក្សាទុក",
    simpleMapsCityId: "អត្តសញ្ញាណទីក្រុងSimpleMaps",
    successful: "ជោគជ័យ",
    timezone: "ម៉ោង",
    vatProdPostGroupCode: "កូដក្រុមផលិតផល VAT",
    vatProdPostGroupID: "អត្តសញ្ញាណក្រុមផលិតផល VAT",
    whtVatProdPostGroupCode: "កូដក្រុមផលិតផល VAT WHT",
    whtVatProdPostGroupID: "អត្តសញ្ញាណក្រុមផលិតផល WHT VAT",
    yes: "បាទ",
    googleSheets: "ក្រដាស Google",
    debit: "កាតឥណទាន",
    previousBalance: "ប្រាក់នៅសល់មុន",
    billDate: "កាលបរិច្ឆេទវិក្កយបត្រ",
    aged: "អាយុ",
    poNoCoa: "លេខ PO / COA",
    receiptNoDesc: "លេខវិក្កយបត្រ / ការពិពណ៌នា",
    and: "និង",
    cents: "សេនត៍",
    processExpired: "ដំណើរការបញ្ចប់",
    revertExpired: "ត្រឡប់ទៅកាន់ស្ថានភាពចាស់",
    notes: "កំណត់ចំណាំ",
    additionalDescription: "ពណ៌នាបន្ថែម",
    additionalDescriptionHint: "បន្ថែមក្នុងក្បាលសរសេរនៃជួរដែលបានបញ្ចូល។ ឧទាហរណ៍: ជួលខែ (តុលា 2026)",
  },
  m: {
    confirmDelete: "តើអ្នកប្រាកដថាចង់លុប {f} ឬ? ដំណើរការនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    err: {
      betLen: "{f} ត្រូវមានចន្លោះពី {v1} ដល់ {v2} តួអក្សរ",
      ge: "{f} ត្រូវធំជាងឬស្មើ {v}",
      gt: "{f} ត្រូវធំជាង {v}",
      le: "{f} ត្រូវតិចជាងឬស្មើ {v}",
      lt: "{f} ត្រូវតិចជាង {v}",
      maxLen: "{f} ច្រើនបំផុត {v} តួអក្សរ",
      maxVal: "តម្លៃអតិបរមារបស់ {f} គឺ {v}{x}",
      minLen: "{f} តិចបំផុត {v} តួអក្សរ",
      minMaxVal: "តម្លៃ {f} ត្រូវមានពី {v1}{x} ដល់ {v2}{x}",
      minVal: "តម្លៃអប្បបរមារបស់ {f} គឺ {v}{x}",
      number: "{f} ត្រូវតែជាលេខ អាចវិជ្ជមាន ឬអវិជ្ជមាន",
      numeric: "{f} ត្រូវតែមានតႂលេខប៉ុណ្ណោះ",
      req: "{f} ត្រូវបានទាមទារ",
    },
    entryEditorWarning: "សូមប្រាកដថារយៈពេលគណនេយ្យនៅបើក និងអ្នកមានសិទ្ធិគ្រប់គ្រងសម្រាប់ការចុះបញ្ជីអ្នកប្រើប្រាស់។ ការផ្លាស់ប្តូរណាមួយលើសំណុំបែបបទនេះនឹងត្រូវកត់ត្រាដោយសុវត្ថិភាព។",
    entryDeleteWarningUpdate: "សូមប្រាកដថាទិន្នន័យទាំងអស់ខាងក្រោមនេះនឹងត្រូវបើកឡើងវិញដោយសារតែសកម្មភាពលុប។ ការផ្លាស់ប្តូរណាមួយនឹងត្រូវកត់ត្រា។",
    entryDeleteBaleWarningDelete: "ប្រុងប្រយ័ត្ន៖ សកម្មភាពនេះនឹងលុបធាតុចូលសៀវភៅគណនីធនាគារទាំងអស់ដែលពាក់ព័ន្ធនឹងលេខឯកសារដែលបានបញ្ជាក់។ សូមប្រាកដថាអ្នកបានពិនិត្យលេខឯកសារត្រឹមត្រូវ។ សកម្មភាពនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    errorEmptyDocumentNumber: "សូមជ្រើសរើសលេខឯកសារជាមុន។",
    successDeleteBale: "ធាតុចូលសៀវភៅគណនីធនាគារត្រូវបានលុប",
    successDeletePostedInvoice: "វិក្កយបត្រដែលបានចុះបញ្ជីត្រូវបានលុប",
    successMovePurchaseInvoiceLines: "បន្ទាត់វិកយបត្រទិញត្រូវបានផ្លាស់ទីដោយជោគជ័យ",
    movePurchaseInvoiceLinesWarning: "សកម្មភាពនេះនឹងផ្លាស់ទីបន្ទាត់ទាំងអស់ពីវិកយបត្រទិញប្រភពដែលបានជ្រើសរើសទៅវិកយបត្រទិញគោលដៅ។ សូមប្រាកដថាអ្នកបានជ្រើសរើសវិកយបត្រត្រឹមត្រូវ ព្រោះប្រតិបត្តិការនេះមិនអាចត្រឡប់វិញបានទេ។",
    pleaseSelectTargetPurchaseInvoice: "សូមជ្រើសរើសវិកយបត្រទិញគោលដៅ",
    sourceTargetPurchaseInvoiceCannotBeSame: "វិកយបត្រទិញប្រភព និងគោលដៅមិនអាចដូចគ្នាបានទេ",
    setVendorChangePriceReminder: "ថ្លៃដើមនឹងកំណត់ដោយតម្លៃកុងត្រារបស់អ្នកផ្គត់ផ្គង់ ប្រសិនបើមាន",
    successChangeStatusPurchaseRequisition: "ស្ថានភាពសំណើទិញត្រូវបានធ្វើបច្ចុប្បន្នភាព",
    successImportGlb: "ថវិកាសៀវភៅធំទូទៅត្រូវបាននាំចូលដោយជោគជ័យ!",
    successSaveGlb: "ថវិកាសៀវភៅធំទូទៅត្រូវបានរក្សាទុកដោយជោគជ័យ!",
    entryDeleteCleWarningDelete: "ប្រុងប្រយ័ត្ន៖ សកម្មភាពនេះនឹងលុបធាតុចូលសៀវភៅអតិថិជនទាំងអស់ដែលពាក់ព័ន្ធនឹងលេខឯកសារដែលបានបញ្ជាក់។ សូមប្រាកដថាអ្នកបានពិនិត្យលេខឯកសារត្រឹមត្រូវ។ សកម្មភាពនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    entryDeleteVleWarningDelete: "ប្រុងប្រយ័ត្ន៖ សកម្មភាពនេះនឹងលុបធាតុចូលសៀវភៅអ្នកផ្គត់ផ្គង់ទាំងអស់ដែលពាក់ព័ន្ធនឹងលេខឯកសារដែលបានបញ្ជាក់។ សូមប្រាកដថាអ្នកបានពិនិត្យលេខឯកសារត្រឹមត្រូវ។ សកម្មភាពនេះមិនអាចត្រឡប់ក្រោយបានទេ។",
    successDeleteCle: "ធាតុចូលសៀវភៅអតិថិជនត្រូវបានលុប",
    successDeleteVle: "ធាតុចូលសៀវភៅអ្នកផ្គត់ផ្គង់ត្រូវបានលុប",
    successUpdateWitholdingTax: "ពន្ធកាត់ទុកត្រូវបានធ្វើបច្ចុប្បន្នភាព",
    successChangeClientSales: "អតិថិជនត្រូវបានធ្វើបច្ចុប្បន្នភាព",
    confirmLogout: "តើអ្នកប្រាកដថាចង់ចាកចេញឬ?",
    confirmFlushSiteData: "តើអ្នកប្រាកដថាចង់សម្អាតទិន្នន័យគេហទំព័រ? វានឹងចាកចេញ និងធ្វើបច្ចុប្បន្នភាពទំព័រ។",
    successFlushSiteData: "ទិន្នន័យគេហទំព័រត្រូវបានសម្អាត។ អ្នកនឹងត្រូវចាកចេញ ហើយទំព័រនឹងធ្វើបច្ចុប្បន្នភាព។",
    successChangeBankAccount: "គណនីធនាគារត្រូវបានផ្លាស់ប្តូរ",
    currBankAccount: "គណនីធនាគារបច្ចុប្បន្ន",
    successChangeVendor: "អ្នកផ្គត់ផ្គង់បានផ្លាស់ប្តូរ",
    currVendor: "អ្នកផ្គត់ផ្គង់បច្ចុប្បន្ន",
    successChangeDeliveryNo: "លេខការដឹកជញ្ជូនត្រូវបានផ្លាស់ប្តូរ",
    currDeliveryNo: "លេខការដឹកជញ្ជូនបច្ចុប្បន្ន",
    newDeliveryNo: "លេខការដឹកជញ្ជូនថ្មី",
    pleaseSelectPurchaseInvoiceFromTheList: "សូមជ្រើសរើសវិក័យប័ត្រទិញពីបញ្ជីមុន",
    entryDeleteVeWarningDelete: "ប្រយ័ត្ន: ការបន្តនឹងអនុវត្តន៍សកម្មភាពនេះនឹងនាំឲ្យមានការលុបចោលច្បាស់លាស់នៃការបញ្ចូលទាំងអស់ដែលពាក់ព័ន្ធនឹងលេខឯកសារដែលបានកំណត់។ សូមប្រាកដថាអ្នកបានពិនិត្យភាពត្រឹមត្រូវនៃលេខឯកសារ ពីព្រោះប្រតិបត្តិការនេះមិនអាចត្រឡប់វិញបានទេ។ ការកែប្រែណាមួយដែលបានធ្វើពីសកម្មភាពនេះនឹងត្រូវបានកត់ត្រាជាធនធានយ៉ាងសុវត្ថិភាព។",
    successDeleteVe: "ការបញ្ចូលតម្លៃត្រូវបានលុបចោល",
    entryDeleteGjeWarningDelete: "ប្រយ័ត្ន: ការបន្តនឹងអនុវត្តន៍សកម្មភាពនេះនឹងនាំឲ្យមានការលុបចោលយ៉ាងថេរនៃកំណត់ហេតុជាសាធារណៈទាំងអស់ដែលពាក់ព័ន្ធនឹងលេខឯកសារដែលបានកំណត់។ សូមប្រាកដថាអ្នកបានផ្ទៀងផ្ទាត់ភាពត្រឹមត្រូវនៃលេខឯកសារ ពីព្រោះប្រតិបត្តិការនេះមិនអាចត្រឡប់វិញបានទេ។ ការកែប្រែណាមួយដែលធ្វើឡើងពីសកម្មភាពនេះនឹងត្រូវបានកត់ត្រាដោយសុវត្ថិភាព។",
    deleteGeneralJournalLogWarning: "នេះនឹងមិនលុបចេញកំណត់ត្រាធនាគារទូទៅទេ គ្រាន់តែជាកំណត់ត្រានេះ។",
    revertPostedInvoiceWarning: "សកម្មភាពនេះនឹងលុបចេញកំណត់ត្រាលេខសំគាល់ទាំងអស់ និងកំណត់ឯកសារការទិញជារូបមន្តឬមិនបានបោះពុម្ព។",
    deletePostedInvoiceWarning: "សកម្មភាពនេះនឹងលុបចេញកំណត់ត្រាលេខកូដទាំងអស់ និងឯកសារទិញវិក្កយបត្រ។",
    changeCOAAndDescriptionWarning: "សកម្មភាពនេះនឹងអាប់ដេតតែពីបន្ទាត់វិក្កយបត្រ។ សូមប្រាកដថាការអាប់ដេតត្រូវបានធ្វើនៅក្នុងកំណត់ត្រាធនាគារទូទៅដោយឡែក។",
    successCreatePaymentJournal: "កាសែតការទូទាត់ត្រូវបានបង្កើត",
    successCreateCashReceiptJournal: "បានបង្កើតកាសសុីបត្រ",
    failedZeroRemainingAmount: "មិនអាចបន្តបានទេ។ ទិន្នន័យខ្លះមានចំនួនសូន្យ។",
    failedAppliedEntries: "មិនអាចបន្តបានទេ។ ទិន្នន័យខ្លះបានអនុវត្តលើការទូទាត់។",
    remainingAmountNotEqualOriginalAmount: "ចំនួនសល់មិនស្មើនឹងចំនួនដើម",
    deletePostedPurchaseCreditMemoWarning: "សកម្មភាពនេះនឹងលុបចេញកំណត់ត្រាឡេជើរ និងឯកសារកំណត់ឥណទានទិញទាំងអស់។",
    successDeletePostedMemo: "កំណត់ចំណាំដែលបានបង្ហោះត្រូវបានលុប",
    revertPostedPurchaseCreditMemoWarning: "ការប្រតិបត្តិនេះនឹងលុបចេញចំណុចកំណត់ Ledger ទាំងអស់ដែលពាក់ព័ន្ធ និងកំណត់ឯកសារ Purchase Credit Memo ជារូបមន្តឬមិនបានបោះពុម្ព។",
    ytdComparisonYearHint: "ចំនួនឆ្នាំប្រវត្តិសាស្ត្របន្ថែមដែលបង្ហាញក្នុងរបាយការណ៍ (0-3, 0 = បិទ)",
    entryDeleteDaleWarningDelete: "ប្រយ័ត្ន: ការបន្តអំពើនេះនឹងនាំឲ្យលុបចេញយ៉ាងថេរ​នូវការចុះកត់គណនីប្រាក់កក់ទាំងអស់ដែលពាក់ព័ន្ធនឹងលេខឯកសារដែលបានកំណត់។ សូមប្រាកដថាអ្នកបានផ្ទៀងផ្ទាត់ភាពត្រឹមត្រូវនៃលេខឯកសារ ពីព្រោះការប្រតិបត្តិនេះមិនអាចត្រឡប់វិញបានទេ។ ការកែប្រែណាមួយដែលបានធ្វើពីអំពើនេះនឹងត្រូវបានកត់ត្រាដោយសុវត្ថិភាព។",
    successDeleteDale: "ការបញ្ចូលកំណត់ត្រាអាកាសប្រាក់បានលុបចោល",
    successChangeClient: "អតិថិជនបានផ្លាស់ប្តូរ",
    currClient: "អតិថិជនបច្ចុប្បន្ន",
    revertPostedInterDepartmentTransferWarning: "This action will remove all related Ledger Entries and set the Inter Department Transfer as unposted. It stays released and can be posted again.",
    successChangeDepositAccount: "គណនីដាក់ប្រាក់បានផ្លាស់ប្តូរ",
    currDepositAccount: "គណនីប្រាក់កក់បច្ចុប្បន្ន",
    noDimensionsConfigured: "មិនមានវិមាត្រដែលបានកំណត់សម្រាប់របាយការណ៍នេះទេ។",
    noDimensionsAvailable: "វិមាត្រទាំងអស់របស់សណ្ឋាគារនេះបានបន្ថែមរួចរាល់។",
    dimensionCountNone: "គ្មានវិមាត្រ",
    dimensionCountOne: "វិមាត្រ ១",
    dimensionCountMany: "វិមាត្រ {count}",
    saveDimensionOrderFirst: "សូមរក្សាទុកលំដាប់បច្ចុប្បន្នមុននឹងបន្ថែមវិមាត្រផ្សេងទៀត។",
    gbeRecallWarning: "ការទៅវិញឯកសារនេះនឹងលុបចេញចូលពីការចុះបញ្ជីថវិកាទូទៅ។ ចូលបានត្រូវបានរក្សាទុកនិងអាចពិនិត្យបានក្រោមការទៅវិញ។ ដើម្បីស្ដារឡើងវិញ សូមបញ្ចូលជួរដេកឡើងវិញនៅក្នុងកាសែតថវិកាទូទៅ និងបោះពុម្ពឡើងវិញ។",
    gbeRecallSuccess: "{n} ការបញ្ចូលថវិកាត្រូវបានអនុញ្ញាត។",
    deleteSelectedInvoicesWarning: "ការប្រតិបត្តិការនេះនឹងលុបវិក័យប័ត្រដែលបានជ្រើសរើស និងបន្ទាត់ទាំងអស់របស់វា។ មិនអាចត្រឡប់វិញបានទេ។",
    deleteSelectedInvoicesCount: "{v} ឯកសារ(អាច) នឹងត្រូវលុបចោល:",
    invoiceWithoutDocumentNo: "(គ្មានលេខឯកសារ)",
    purchaseBookSummaryTruncated: "សរុបគ្របដណ្តប់តែ {v} កំណត់ត្រាដំបូងប៉ុណ្ណោះ។ បន្ថយចន្លោះកាលបរិច្ឆេទសម្រាប់សរុបត្រឹមត្រូវ។",
    changeAccountNumberDimensionNotice: "កំណត់វិមាត្រនៃការបញ្ចូលនេះនឹងត្រូវបានជំនួសដោយតម្លៃខាងក្រោម ដែលបានបញ្ចូលជាមុនពីវិមាត្រដែលត្រូវការរបស់ {account}។ ទុកបញ្ជីឲ្យទទេដើម្បីលុបកំណត់វិមាត្រ។",
    changeAccountNumberDimensionAssignNotice: "ការបញ្ចូលនេះមិនមានវិមាត្រដាក់កំណត់ទេ។ {account} ត្រូវការវីមាត្រខាងក្រោមដែលបានបញ្ចូលជាមុនជាមួយតម្លៃលំនាំដើម។ សូមបញ្ជាក់ឬកែសម្រួលមុនពេលរក្សាទុក។",
    successImportCfb: "ការប៉ាន់ស្មានប្រាក់ចំណូលបាននាំចូលជោគជ័យ!",
    successSaveCfb: "ការប្រាក់ចំណូលបានរក្សាទុកដោយជោគជ័យ!",
    expenseAllocationSelectGroup: "ជ្រើសរើសក្រុមផ្សាយផលិតផលទូទៅនៅផ្ទាំងព័ត៌មានដើម្បីមើលការចូលរួមផ្សាយ។",
    expenseAllocationLoadFailed: "មិនអាចបង្ហាញកម្រិតវិមាត្រ។ សូមបើកកាបូបម្តងទៀតដើម្បីព្យាយាម។",
    accrualSetupMissing: "មិនអាចបង្កើតការបូកសរុបបានទេ។ សូមកំណត់ {f} នៅក្នុងការកំណត់ការទូទាត់ទិញ (ផ្ទាំងផ្សេងៗ) មុន។",
    accrualPeriodAlreadyPosted: "ការប្រមូលសម្រាប់ {f} បានបង្ហោះរួចហើយ។ ការប្រឡងម្តងទៀតសម្រាប់ខែនេះមិនអនុញ្ញាតទេ។",
    accrualDateNotMonthEnd: "{f} មិនមែនជាតារាងបញ្ចប់ខែទេ។ ការបង្វិលនៅតែបង្ហោះនៅ {r}។",
    accrualNoCandidates: "មិនមានបន្ទាត់ទិញ G/L ដែលទទួលបានកំពុងរង់ចាំវិក្កយបត្រ​នៅ {f} ទេ។",
    accrualReplaceNotice: "បន្ទាត់ដែលមិនបានបោះពុម្ពនៃកញ្ចប់ {b} ថ្ងៃទី {f} នឹងត្រូវបានជំនួស។",
    accrualSelectedTotals: "{n} បន្ទាត់(ៗ) បានជ្រើសរើស",
    successGenerateAccrual: "ការបង្កើតសរុបចូលក្នុងកញ្ចប់ {b}: {n} បន្ទាត់ត្រូវបានសរសេរ, {d} បន្ទាត់ដែលមិនបានបោះពុម្ពត្រូវបានជំនួស។",
    successCreateReconciliationJournal: "កំណត់ហេតុការប្រកាសបានបង្កើតឡើង: {f}",
    failedClosedEntries: "មិនអាចបន្តបាន។ ការបញ្ចូលដែលបានជ្រើសខ្លះបានបិទ។",
    reconciliationJournalPerBankAccount: "{n} ឯកសារ(ឬ) នឹងត្រូវបានបង្កើត, មួយសម្រាប់គណនីធនាគារ",
  },
  check: {
    title: "កំណត់ពាក្យសម្ងាត់ថ្មី",
    backtosign: "ត្រឡប់ទៅការចូលប្រើប្រាស់",
    newpassword: "ពាក្យសម្ងាត់ថ្មី",
    button: "កំណត់ពាក្យសម្ងាត់ថ្មី និងចូលប្រើប្រាស់",
    error: "តំណភ្ជាប់សកម្មភាពមិនត្រឹមត្រូវ",
    verifylink: "កំពុងផ្ទៀងផ្ទាត់តំណភ្ជាប់...",
    verifyemail: "កំពុងផ្ទៀងផ្ទាត់អាសយដ្ឋានអ៊ីមែល...",
    emailverified: "អ៊ីមែលត្រូវបានផ្ទៀងផ្ទាត់! កំពុងប្ដូរទិសដៅ...",
  },
  forgot: {
    title: "ភ្លេចពាក្យសម្ងាត់?",
    subtitle: "បញ្ចូលអាសយដ្ឋានអ៊ីមែលគណនីរបស់អ្នក ហើយយើងនឹងផ្ញើតំណភ្ជាប់សម្រាប់កំណត់ពាក្យសម្ងាត់ឡើងវិញ។",
    email: "អ៊ីមែល",
    button: "ស្នើសុំកំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    backtosign: "ត្រឡប់ទៅការចូលប្រើប្រាស់",
  },
  login: {
    title: "ចូលប្រើប្រាស់",
    email: "អ៊ីមែល",
    password: "ពាក្យសម្ងាត់",
    button: "ចូលប្រើប្រាស់",
    orsign: "ឬ ចូលប្រើជាមួយ",
    forgot: "ភ្លេចពាក្យសម្ងាត់?",
    noaccount: "មិនទាន់មានគណនីទេ?",
    create: "បង្កើតថ្មីនៅទីនេះ",
    error: "បន្សំអ៊ីមែល / ពាក្យសម្ងាត់មិនត្រឹមត្រូវ",
  },
  register: {
    title: "បង្កើតគណនី",
    name: "ឈ្មោះពេញ",
    email: "អ៊ីមែល",
    password: "ពាក្យសម្ងាត់",
    passwordRetype: "បញ្ចូលពាក្យសម្ងាត់ម្តងទៀត",
    button: "បង្កើតគណនី",
    orsign: "ឬ ចុះឈ្មោះជាមួយ",
    agree: "ដោយចុះឈ្មោះ អ្នកយល់ព្រមនឹង",
    account: "មានគណនីរួចហើយ?",
    signin: "ចូលប្រើប្រាស់",
  },
  utility: {
    maintenance: "កំពុងថែទាំប្រព័ន្ធ",
  },
  faq: {
    call: "មានសំណួរផ្សេងទៀត? សូមទំនាក់ទំនងមកយើងខ្ញុំ ",
  },
  ecommerce: {
    products: "ផលិតផល",
    filters: "តម្រង",
    collections: "កម្រង",
    priceRange: "ជួរតម្លៃ",
    clientReviews: "សំណើរបស់អតិថិជន",
    up: "និងខ្ពស់ជាងនេះ",
    brand: "ម៉ាក",
    search: "ស្វែងរកផលិតផល",
    results: "លទ្ធផល ( {0} នៃ {1} )",
    orders: "ការបញ្ជាទិញ",
    shipping: "ដឹកជញ្ជូន",
    freeShipping: "ដឹកជញ្ជូនឥតគិតថ្លៃ",
    inStock: "មានស្តុក",
    quantity: "បរិមាណ",
    addToCart: "បន្ថែមទៅរទេះ",
    buyNow: "ទិញឥឡូវនេះ",
    price: "តម្លៃ",
    about: "អំពីធាតុនេះ",
    description: "ពិពណ៌នា",
    reviews: "សំណើរ",
    details: "ព័ត៌មានលម្អិតផលិតផល",
    cart: "រទេះ",
    summary: "សង្ខេបការបញ្ជាទិញ",
    total: "សរុប",
    discount: "បញ្ចុះតម្លៃ",
    subtotal: "សរុបរង",
    continue: "បន្តការជាវ",
    checkout: "បង់ប្រាក់",
  },
  menu: {
    rateManagement: "ការគ្រប់គ្រងអត្រា",
    reservation: "ការកក់បន្ទប់",
    reservationNew: "ថ្មី",
    reservationList: "បញ្ជី",
    frontOffice: "ស្នាក់នៅមុខ",
    generalSettings: "ការកំណត់ទូទៅ",
    guestTitle: "ចំណងជើងភ្ញៀវ",
    guestDocumentType: "ប្រភេទឯកសារភ្ញៀវ",
    manageHotel: "សណ្ឋាគារ",
    hotel: "សណ្ឋាគារ",
    hotelList: "បញ្ជី",
    hotelCategory: "ប្រភេទសណ្ឋាគារ",
    hotelChain: "ខ្សែសណ្ឋាគារ",
    marketSegment: "ផ្នែកទីផ្សារ",
    rooms: "បន្ទប់",
    currency: "រូបិយប័ណ្ណ",
    search: "ស្វែងរក (ចុច \"ctrl + /\" ដើម្បីផ្ដោត)",
    dashboard: "ផ្ទាំងគ្រប់គ្រង",
    logout: "ចាកចេញ",
    flushSiteData: "សម្អាតទិន្នន័យគេហទំព័រ",
    clearCache: "សម្អាតឃ្លាំងបណ្តាញ",
    profile: "ប្រវត្តិរូប",
    blank: "ទំព័រទទេ",
    pages: "ទំព័រ",
    others: "ផ្សេងៗ",
    email: "អ៊ីមែល",
    chat: "ជជែក",
    todo: "ត្រូវធ្វើ",
    board: "ក្តារភារកិច្ច",
    users: "អ្នកប្រើប្រាស់",
    usersList: "បញ្ជី",
    usersEdit: "កែសម្រួល",
    ecommerce: "អ៊ីហ្ស៊ីខមមើស",
    ecommerceList: "ផលិតផល",
    ecommerceProductDetails: "ព័ត៌មានលម្អិតផលិតផល",
    ecommerceOrders: "ការបញ្ជាទិញ",
    ecommerceCart: "រទេះ",
    auth: "ទំព័រផ្នែកសុវត្ថិភាព",
    authLogin: "ចូលប្រើប្រាស់ / ចុះឈ្មោះ",
    authRegister: "ចុះឈ្មោះ / បង្កើតគណនី",
    authVerify: "ផ្ទៀងផ្ទាត់អ៊ីមែល",
    authForgot: "ភ្លេចពាក្យសម្ងាត់",
    authReset: "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    errorPages: "ទំព័រខុសប្រព័ន្ធ",
    errorNotFound: "រកមិនឃើញ / 404",
    errorUnexpected: "មិនរំពឹងទុក / 500",
    utilityPages: "ទំព័រឧបករណ៍",
    utilityMaintenance: "កំពុងថែទាំប្រព័ន្ធ",
    utilitySoon: "មកដល់ឆាប់ៗនេះ",
    utilityHelp: "សំណួរញឹកញាប់ / ជំនួយ",
    levels: "កម្រិតម៉ឺនុយ",
    disabled: "បិទម៉ឺនុយ",
    docs: "ឯកសារ",
    feedback: "មតិយោបល់",
    support: "គាំទ្រ",
    history: "ប្រវត្តិ",
  },
  localColumns: {
    defaultVatProductPostingGroup: "ក្រុមចុះបញ្ជីផលិតផល VAT លំនាំដើម",
    defaultWhtProductPostingGroup: "ក្រុមចុះបញ្ជីផលិតផល WHT លំនាំដើម",
    postingGroup: "ក្រុមចុះបញ្ជី",
    postingType: "ប្រភេទចុះបញ្ជី",
    inventoryPostingType: "ប្រភេទចុះបញ្ជីសន្និធិ",
    isWitholdingTax: "តើជាពន្ធកាត់ទុកឬ?",
    isNoVat: "គ្មានអាករ VAT",
    batchName: "ឈ្មោះកញ្ចប់",
    batchCode: "កូដកញ្ចប់",
    totalRecords: "សរុបទិន្នន័យ",
    totalAmount: "ចំនួនសរុប",
    totalDebit: "បំណុលសរុប",
    totalCredit: "ឥណទានសរុប",
    journalName: "ឈ្មោះសៀវភៅ",
    company: "ក្រុមហ៊ុន",
    offsetCompany: "ក្រុមហ៊ុនបង្វិល",
    offsetAccount: "គណនីបង្វិល",
    isPom: "តើជា POM?",
    sentecAccountNo: "លេខគណនី Sentec",
    sentecAccountName: "ឈ្មោះគណនី Sentec",
    salesPersonName: "ឈ្មោះបុគ្គលិកលក់",
    guestAccountName: "ឈ្មោះភ្ញៀវ/គណនី",
    contactPersonName: "ឈ្មោះបុគ្គលិកទំនាក់ទំនង",
    creditLimit: "ដែនកំណត់ឥណទាន",
    remainingBalance: "សមតុល្យនៅសល់",
    vleAmount: "ចំនួន VLE",
    gleAmount: "ចំនួន GLE",
    cleAmount: "ចំនួន CLE",
    diff: "ភាពខុសគ្នា",
    SOHQuantity: "បរិមាណ SOH",
    IABQuantity: "បរិមាណ IAB",
    SOHTotalCost: "ថ្លៃដើមសរុប SOH",
    COAAmount: "ចំនួន COA",
    costDifference: "ភាពខុសគ្នាតម្លៃ",
    isGeneralStorage: "ជាឃ្លាំងទូទៅ",
    generalLedgerEntryId: "លេខសម្គាល់ធាតុចូលសៀវភៅធំទូទៅ",
    operator: "អ្នកប្រតិបត្តិការ",
    ilePostingDate: "កាលបរិច្ឆេទបោះពុម្ព ILE",
    receivableDate: "កាលបរិច្ឆេទទទួលប្រាក់",
    receivableDueDate: "កាលបរិច្ឆេទកំណត់ទទួលប្រាក់",
    receivablePostingDate: "កាលបរិច្ឆេទបញ្ជូនប្រាក់ចំណូល",
  },
  localCommon: {
    noMenuMatchedWithSearchQuery: "គ្មានម៉ឺនុយដែលផ្គូផ្គងនឹងសំណើស្វែងរក",
    top10VendorByBalance: "អ្នកផ្គត់ផ្គង់ 10 លើសគេតាមសមតុល្យ",
    top10ClientsByBalance: "អតិថិជន 10 លើសគេតាមសមតុល្យ",
    chooseTime: "ជ្រើសរើសពេលវេលា",
    top10PurchaseItem: "ទំនិញទិញច្រើនបំផុត 10 ប្រភេទ",
    adjustEntry: "កែសម្រួលធាតុចូល",
    split: "បំបែក",
    postBatch: "ចុះបញ្ជីកញ្ចប់",
    processing: "កំពុងដំណើរការ",
    generalLedgerBudget: "ថវិកាសៀវភៅធំទូទៅ",
    inventory: "សន្និធិ",
  },
  coaIntegration: {
    title: "ការរួមបញ្ចូល COA",
    titleMapping: "ផែនទី COA",
    provider: "អ្នកផ្តល់សេវា",
    dataLog: "កំណត់ត្រាទិន្នន័យ",
    flushDataLog: "សម្អាតទិន្នន័យ",
    successSaveConfig: "ការកំណត់ត្រូវបានធ្វើបច្ចុប្បន្នភាព",
    successGenerateData: "ទិន្នន័យត្រូវបានបង្កើត",
    successSendData: "ទិន្នន័យត្រូវបានដំណើរការ សូមពិនិត្យចម្លើយ",
    successFlushData: "កំណត់ត្រាទិន្នន័យត្រូវបានសម្អាត",
    successUpdateMappingData: "ផែនទីត្រូវបានធ្វើបច្ចុប្បន្នភាព",
    successDeleteMappingData: "ការបង្ហាញបានលុបចេញ",
    inputSystemChartOfAccount: "ក្រឡាចុះគណនីប្រព័ន្ធ",
    deleteMappingConfirm: "តើអ្នកប្រាកដចង់លុបកំណត់ត្រានេះទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    deleteDataLogByMonthConfirm: "តើអ្នកប្រាកដចង់លុបកំណត់ត្រាទាំងអស់ដែលផ្អែកលើខែដែលបានជ្រើស? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    deleteDataLogAllConfirm: "តើអ្នកប្រាកដថាចង់លុបកំណត់ទាំងអស់មែនទេ? ដំណើរការនេះមិនអាចត្រឡប់វិញបានទេ។",
    baseUrl: "URL មូលដ្ឋាន",
  },
  board: {
    titlePlaceholder: "បញ្ចូលចំណងជើងសម្រាប់កាតនេះ",
    deleteDescription: "តើអ្នកប្រាកដថាចង់លុបកាតនេះឬ?",
    editCard: "កែសម្រួលកាត",
    deleteCard: "លុបកាត",
    state: {
      TODO: "ត្រូវធ្វើ",
      INPROGRESS: "កំពុងដំណើរការ",
      TESTING: "សាកល្បង",
      DONE: "រួចរាល់",
    },
  },
  chat: {
    online: "អ្នកប្រើប្រាស់កំពុងលើបណ្តាញ ({count})",
    addChannel: "បន្ថែមឆានែល",
    channel: "ឆានែល | ឆានែល",
    message: "សារ",
  },
  email: {
    compose: "សរសេរអ៊ីមែល",
    send: "ផ្ញើ",
    subject: "ប្រធានបទ",
    labels: "ស្លាក",
    emptyList: "បញ្ជីអ៊ីមែលទទេ",
    inbox: "ប្រអប់ទទួល",
    sent: "បានផ្ញើ",
    drafts: "ព្រាង",
    starred: "បានដាក់សញ្ញា",
    trash: "ធុងសំរាម",
    work: "ការងារ",
    invoice: "វិក្កយបត្រ",
    recipient: "អ្នកទទួល",
  },
  todo: {
    addTask: "បន្ថែមភារកិច្ច",
    tasks: "ភារកិច្ច",
    completed: "បានបញ្ចប់",
    labels: "ស្លាក",
  },
  dashboard: {
    activity: "សកម្មភាព",
    weeklySales: "ការលក់ប្រចាំសប្តាហ៍",
    sales: "ការលក់",
    recentOrders: "ការបញ្ជាទិញថ្មីៗ",
    sources: "ប្រភពចរាចរណ៍",
    lastweek: "ប្រៀបធៀបនឹងសប្តាហ៍មុន",
    orders: "ការបញ្ជាទិញ",
    clients: "អតិថិជន",
    tickets: "សំបុត្រគាំទ្រ",
    viewReport: "មើលរបាយការណ៍",
  },
  usermenu: {
    profile: "ប្រវត្តិរូប",
    signin: "ចូលប្រើប្រាស់",
    dashboard: "ផ្ទាំងគ្រប់គ្រង",
    signout: "ចាកចេញ",
  },
  error: {
    differentVATGroup: "ក្រុមចុះបញ្ជីផលិតផល VAT ត្រូវតែដូចគ្នា",
    glbImport: "កំហុស មិនអាចនាំចូលថវិកាសៀវភៅធំទូទៅ",
    notfound: "រកមិនឃើញទំព័រ",
    other: "មានកំហុសកើតឡើង",
    invoiceAlreadyHaveCreditMemo: "វិក្កយបត្រនេះមានកំណត់ត្រាប្រាក់ឥណទានរួចហើយ",
    POItemIsFromPR: "ធាតុបញ្ជាទិញដែលប្រភពមកពីសំណើទិញ",
    locationAndPostingGroupDuplicate: "ទីតាំងនេះ ({f1}) និងក្រុមចុះបញ្ជី ({f2}) មានរួចហើយ។<br/>សូមជ្រើសរើសតម្លៃផ្សេងទៀត!",
    businessAndProductPostingGroupDuplicate: "អាជីវកម្មនេះ ({f1}) និងក្រុមចុះបញ្ជីផលិតផល ({f2}) មានរួចហើយ។<br/>សូមជ្រើសរើសតម្លៃផ្សេងទៀត!",
    invoiceAlreadyPaid: "វិក្កយបត្រនេះត្រូវបានបង់រួចជាផ្នែក ឬទាំងស្រុង។<br/>ចំនួនដើម: {f1}<br/>ចំនួននៅសល់: {f2}",
    needConfigureVatProduct: "សូមកំណត់ក្រុមចុះបញ្ជីអាករ VAT នៅក្នុងការកំណត់អតិថិជន ឬបំណុលត្រូវទទួល",
    failedFetchItemCost: "មិនអាចទាញយកតម្លៃធាតុថ្មីបាន",
    syncPrLineFailed: "បរាជ័យក្នុងការសម្របសម្រួលការផ្លាស់ប្តូរទៅកាន់បន្ទាត់សំណើទិញ។ ការផ្លាស់ប្តូរ PO ត្រូវបានរក្សាទុក។",
    needConfigureDirectCostAccount: "សូមកំណត់គណនីចំណាយផ្ទាល់ក្នុងការកំណត់ការទូទាត់ទិញ",
    needConfigurePurchaseAccount: "សូមកំណត់គណនីទិញនៅក្នុងការកំណត់បង់ប្រាក់ទិញ",
    noPermission: "អ្នកមិនមានអាជ្ញាប័ណ្ណសម្រាប់អនុវត្តសកម្មភាពនេះទេ",
    cfbImport: "កំហុស, មិនអាចនាំចូលថវិកាចំណូលប្រាក់បានទេ",
    noAppliedEntriesOnThisDocument: "មិនមានការបញ្ចូលដែលបានអនុវត្តនៅលើឯកសារនេះ",
    noCompanyHeaderInfo: "មិនមានព័ត៌មានក្បាលក្រុមហ៊ុន។ សូមទំនាក់ទំនងអ្នកគ្រប់គ្រងរបស់អ្នក។",
  },
  generalLedgerBudget: {
    editTitle: "កែសម្រួលថវិកា",
    title: "នាំចូលពី XLS",
    successImportData: "ទិន្នន័យត្រូវបាននាំចូល!",
  },
  balanceSheetConsolidation: {
    title: "តារាងតុល្យភាពបញ្ចូល",
    titleReport: "របាយការណ៍តារាងតុល្យភាពបញ្ចូល",
    excelFileID: "លេខសម្គាល់ឯកសារ Excel តារាងតុល្យភាពបញ្ចូល",
    sheetFileID: "លេខសម្គាល់ឯកសារ Google Sheet តារាងតុល្យភាពបញ្ចូល",
  },
  $vuetify: {
    badge: "ស្លាក",
    close: "បិទ",
    dataIterator: {
      noResultsText: "រកមិនឃើញកំណត់ត្រាដែលផ្គូផ្គង",
      loadingText: "កំពុងផ្ទុកធាតុ...",
    },
    dataTable: {
      itemsPerPageText: "ជួរដេកក្នុងមួយទំព័រ:",
      ariaLabel: {
        sortDescending: "តម្រៀបចុះក្រោម។",
        sortAscending: "តម្រៀបឡើងលើ។",
        sortNone: "មិនបានតម្រៀប។",
        activateNone: "បើកដើម្បីយកការតម្រៀបចេញ។",
        activateDescending: "បើកដើម្បីតម្រៀបចុះក្រោម។",
        activateAscending: "បើកដើម្បីតម្រៀបឡើងលើ។",
      },
      sortBy: "តម្រៀបតាម",
    },
    dataFooter: {
      itemsPerPageText: "ធាតុក្នុងមួយទំព័រ:",
      itemsPerPageAll: "ទាំងអស់",
      nextPage: "ទំព័របន្ទាប់",
      prevPage: "ទំព័រមុន",
      firstPage: "ទំព័រដំបូង",
      lastPage: "ទំព័រចុងក្រោយ",
      pageText: "{0}-{1} នៃ {2}",
    },
    datePicker: {
      itemsSelected: "{0} បានជ្រើសរើស",
      nextMonthAriaLabel: "ខែក្រោយ",
      nextYearAriaLabel: "ឆ្នាំក្រោយ",
      prevMonthAriaLabel: "ខែមុន",
      prevYearAriaLabel: "ឆ្នាំមុន",
    },
    noDataText: "គ្មានទិន្នន័យ",
    carousel: {
      prev: "រូបភាពមុន",
      next: "រូបភាពបន្ទាប់",
      ariaLabel: {
        delimiter: "ស្លាយ {0} នៃ {1}",
      },
    },
    calendar: {
      moreEvents: "{0} ច្រើនទៀត",
    },
    fileInput: {
      counter: "{0} ឯកសារ",
      counterSize: "{0} ឯកសារ ({1} សរុប)",
    },
    timePicker: {
      am: "ព្រឹក",
      pm: "ល្ងាច",
    },
    pagination: {
      ariaLabel: {
        wrapper: "ការរុករកទំព័រ",
        next: "ទំព័របន្ទាប់",
        previous: "ទំព័រមុន",
        page: "ទៅកាន់ទំព័រ {0}",
        currentPage: "ទំព័របច្ចុប្បន្ន, ទំព័រ {0}",
      },
    },
  },
  userPostingSetup: {
    setPostingDate: "កំណត់កាលបរិច្ឆេទចុះបញ្ជីអ្នកប្រើប្រាស់ទាំងអស់",
  },
  purchaseRequisitionBatch: {
    allowedApprovalSubmissionDays: "ចំនួនថ្ងៃអនុញ្ញាតសម្រាប់ដាក់ស្នើអនុម័ត",
  },
  common: {
    add: "បន្ថែម",
    cancel: "បោះបង់",
    description: "ពិពណ៌នា",
    delete: "លុប",
    title: "ចំណងជើង",
    save: "រក្សាទុក",
    faq: "សំណួរញឹកញាប់",
    contact: "ទំនាក់ទំនងយើងខ្ញុំ",
    tos: "លក្ខខណ្ឌសេវាកម្ម",
    policy: "គោលការណ៍ឯកជនភាព",
    sunday: "អាទិត្យ",
    monday: "ច័ន្ទ",
    tuesday: "អង្គារ",
    wednesday: "ពុធ",
    thursday: "ព្រហស្បតិ៍",
    friday: "សុក្រ",
    saturday: "សៅរ៍",
    clickHere: "ចុចទីនេះ",
    standard: "ស្តង់ដារ",
    monospace: "មូណូស្ពេស",
    left: "ឆ្វេង",
    center: "មជ្ឈមណ្ឌល",
    right: "ស្តាំ",
  },
  directExpenseGenBusPostGroup: "ក្រុមចុះបញ្ជីអាជីវកម្មចំណាយផ្ទាល់",
  directExpenseGenProdPostGroup: "ក្រុមចុះបញ្ជីផលិតផលចំណាយផ្ទាល់",
  directExpenseAdjustmentAccount: "គណនីកែសម្រួលចំណាយផ្ទាល់",
  defaultDirectExpenseGenBusPostGroup: "ក្រុមចុះបញ្ជីអាជីវកម្មចំណាយផ្ទាល់លំនាំដើម",
  custPostGroup: "ក្រុមចុះបញ្ជីអតិថិជន",
  vendorPostGroup: "ក្រុមចុះបញ្ជីអ្នកផ្គត់ផ្គង់",
  journalTemplate: "ពុម្ពសៀវភៅ",
  noSeries: "ស៊េរីលេខ",
  defaultLocation: "ទីតាំងលំនាំដើម",
  prefix: "បុព្វបទ",
  startingNumber: "លេខចាប់ផ្តើម",
  endingNumber: "លេខបញ្ចប់",
  lastNumberUsed: "លេខចុងក្រោយដែលបានប្រើ",
  lengthOfNumber: "ប្រវែងលេខ",
  includeYear: "រួមបញ្ចូលឆ្នាំ",
  includeMonth: "រួមបញ្ចូលខែ",
  includeDate: "រួមបញ្ចូលកាលបរិច្ឆេទ",
  isEditable: "អាចកែសម្រួលបាន",
  branch: "សាខា",
  bankAccountNo: "លេខគណនីធនាគារ",
  virtualAccountNo: "លេខគណនីវើចួល",
  allowPostingFrom: "អនុញ្ញាតចុះបញ្ជីពី",
  allowPostingTo: "អនុញ្ញាតចុះបញ្ជីដល់",
  receivableAccount: "គណនីបំណុលត្រូវទទួល",
  receivableAccountNo: "លេខគណនីបំណុលត្រូវទទួល",
  payableAccount: "គណនីបំណុលត្រូវបង់",
  balanceAccount: "គណនីតុល្យភាព",
  accountCategory: "ប្រភេទគណនី",
  accountType: "ប្រភេទគណនី",
  directPost: "ចុះបញ្ជីផ្ទាល់",
  blocked: "បានបិទ",
  vatPercentage: "ភាគរយអាករ VAT",
  startingDate: "កាលបរិច្ឆេទចាប់ផ្តើម",
  closed: "បានបិទ",
  endingDate: "កាលបរិច្ឆេទបញ្ចប់",
  dueDateCalc: "ការគណនាកាលបរិច្ឆេទដល់កំណត់",
  documentFlow: {
    purchaseInvoiceDefaultDocumentFlow: "ចេញវិក្កយបត្រទិញលំនាំលំនៅ",
    purchaseInvoiceDocumentFlowRules: "ច្បាប់ចរាចរណ៍ឯកសារទិញវិក័យប័ត្រ",
    equal: "ស្មើ",
    notEqual: "មិនស្មើ",
    lessThan: "តិចជាង",
    lessThanOrEqual: "តិចជាងឬស្មើ",
    greaterThan: "ធំជាង",
    greaterThanOrEqual: "ធំជាងឬស្មើ",
    purchaseOrderDocumentFlowRules: "ច្បាប់លំហូរឯកសារបញ្ជាទិញ",
    purchaseReceiptDocumentFlowRules: "ច្បាប់លំហូរឯកសារទទួលទំនិញទិញ",
    default: "លំហូរឯកសារដើម",
    purchaseOrderDMLDocumentFlowRules: "ច្បាប់លំហូរឯកសារបញ្ជាទិញ បញ្ជីទីផ្សារប្រចាំថ្ងៃ",
    documentsSourceInformation: "ឯកសារដែលបង្ហាញនៅលើទំព័រនេះមានតែពីការិយាល័យក្រោយ (ឧ. PI, PO, PR, ល។)។ ឯកសារដែលបង្កើតដោយការិយាល័យមុខអាចមើលបាននៅក្នុងម៉ូឌុលការិយាល័យមុខ។",
    refreshApprovals: "កែសម្រួលការអនុម័ត",
    showInformation: "បង្ហាញព័ត៌មាន",
    submitForApprovalConfirmation: "សំណើអនុម័តនឹងត្រូវបានផ្ញើតាមអ៊ីមែលទៅអ្នកប្រើទាំងនេះ។ សូមប្រាកដថាព័ត៌មានត្រឹមត្រូវ។",
    hideInformation: "លាក់ព័ត៌មាន",
    documentFlowBeingUsed: "ការប្រើប្រាស់ចលនាឯកសារ",
    sendEmail: "បញ្ជូនអ៊ីមែល",
    sendReminder: "ផ្ញើការចងចាំ",
    reminderCount: "ចំនួនការជូនដំណឹង",
    remindedAt: "បានរំលឹកនៅ",
  },
  changesLog: {
    logCategory: "ប្រភេទកំណត់ហេតុ",
    sourceId: "អត្តសញ្ញាណប្រភព",
  },
  taxSubmission: {
    availableToCancelOrReject: "អាចបោះបង់/បដិសេធបាន",
    availableToGetSubmittedDetails: "អាចទទួលបានព័ត៌មានដែលបានដាក់ស្នើ",
    availableToSend: "អាចផ្ញើបាន",
    buyerAddress: "អាសយដ្ឋានអ្នកទិញ",
    buyerContractName: "ឈ្មោះកិច្ចសន្យាអ្នកទិញ",
    buyerName: "ឈ្មោះអ្នកទិញ",
    buyerRegistrationNumber: "លេខចុះឈ្មោះអ្នកទិញ",
    buyerSSTRegistrationID: "លេខសម្គាល់ចុះឈ្មោះ SST អ្នកទិញ",
    buyerTIN: "លេខសម្គាល់ពន្ធអ្នកទិញ",
    classification: "ចំណាត់ថ្នាក់",
    eInvoice: "វិក័យប័ត្រ​អេឡិចត្រូនិច",
    eInvoiceCode: "កូដ e-វិក័យប័ត្រ",
    eInvoiceType: "ប្រភេទ e-Invoice",
    eInvoiceVersion: "កំណែ e-Invoice",
    invoiceDateAndTime: "កាលបរិច្ឆេទ និងម៉ោងវិក័យប័ត្រ",
    originalInvoiceRefNo: "លេខយោងវិក័យប័ត្រដើម: មិនអាចអនុវត្តបាន",
    sendCountInvoicesToTaxInterface: "ផ្ញើវិក្កយបត្រ {count} ទៅអន្តរកម្មពន្ធ",
    subtotal: "សរុបរង",
    supplierBusinessActivityDescription: "ការពិពណ៌នាសកម្មភាពអាជីវកម្មអ្នកផ្គត់ផ្គង់",
    supplierMSICCode: "កូដ MSIC អ្នកផ្គត់ផ្គង់",
    supplierRegistrationNumber: "លេខចុះឈ្មោះអ្នកផ្គត់ផ្គង់",
    supplierSSTID: "អត្តសញ្ញាណ SST អ្នកផ្គត់ផ្គង់",
    supplierTIN: "លេខសម្គាល់ពន្ធអ្នកផ្គត់ផ្គង់",
    taxRate: "អត្រាពន្ធ",
    totalExcludingTax: "សរុបមិនរាប់ពន្ធ",
    totalIncludingTax: "សរុបរួមទាំងពន្ធ",
    totalPayableAmount: "ចំនួនសរុបដែលត្រូវបង់",
    uniqueIdentifierNo: "លេខសម្គាល់ឯកតា",
    unitPrice: "តម្លៃឯកតា",
    digitalSignature: "ហត្ថលេខាឌីជីថល",
    validationDateTime: "កាលបរិច្ឆេទ និងម៉ោងនៃការបញ្ជាក់",
    visualPresentation: "ឯកសារនេះគឺជាការបង្ហាញទស្សនវិស័យនៃវិក្កយបត្រ​អេឡិចត្រូនិច",
    na: "មិនអាចអនុវត្តបាន",
    getSubmittedDocumentURL: "ទទួលយក URL ឯកសារដែលបានដាក់ស្នើ",
    cancelOrRejectDocument: "បោះបង់ឬបដិសេធឯកសារ",
    interfaceStatus: "ស្ថានភាពអន្តរកម្ម",
    receiptVerificationRedirectURL: "URL បញ្ជូនទៅកាន់ការបញ្ជាក់វិក្កយបត្រ",
    receiptVerificationSubmissionUUID: "លេខសម្គាល់ UUID សម្រាប់ការបញ្ជូនការពិនិត្យវិក្កយបត្រ",
    receiptVerificationDocumentUUID: "លេខសម្គាល់ឯកសារពិនិត្យបញ្ជីទទួល",
    reject: "បដិសេធ",
  },
  template: {
    columnLengthDifference: "គំរូមិនត្រឹមត្រូវ: ចំនួនជួរ​មិនត្រូវគ្នា។",
  },
  radio: {
    autoclose: "បិទដោយអូតូ",
    manualclose: "បិទដោយដៃ",
  },
  cashFlowBudget: {
    editTitle: "កែប្រែថវិកា",
    title: "នាំចូលពី XLS",
    successImportData: "ទិន្នន័យបាននាំចូល!",
  },
}
